<template>
    <div class="home">
        <Header></Header>
        <div :key="componentKey">
            <!-- device info row -->
            <div class="row defaultRow stickyTop">
                <div class="card" style="width: 100%; text-align:center; background-color:#064ea1">
                    <div>
                        <b-dropdown id="dropdown-1">
                            <template #button-content>
                                {{ newSlotName }}
                                <!--<div :style="{ backgroundColor: isDataReadingReady ? 'green' : 'red', width: '20px', height: '20px', borderRadius: '50%', display: 'inline-block', marginLeft: '5px', verticalAlign: 'middle' }"></div>-->
                            </template>
                            <b-dropdown-item class="btn" style="width:300px;" v-for="accountDevice in this.outDat"
                                v-bind:key="accountDevice.id" @click="(e) => setDeviceId(accountDevice.id)"
                                :value="accountDevice.id">
                                <img v-if="accountDevice.online" src="/assets/greenCircle.png"
                                    class="deviceActiveImg" />
                                <img v-else src="/assets/greyCircle.png" class="deviceActiveImg" />
                                {{ accountDevice.name }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
            <!-- device status  -->
            <div class="row defaultRow">
                <!-- <div v-if="deviceOffline" class="card overlay">
            <p> Device Offline </p>
            <p> select wider date range or check back later </p>
          </div> -->
              <div class="card" style="width: 100%">
                    <div class="row" style="align-content:center;">
                        <!-- device last heard -->
                        <div class="col-12 col-sm-3" style="text-align:center;">
                            <p class="statusLabel">Device Last Online:</p>
                            <p class="statusLabel">{{ this.lastHeard }}</p>
                        </div>
                        <!-- Signal Strength -->
                        <div class="col-12 col-sm-3">
                            <div style="display: flex; justify-content:center">
                                <p class="statusLabel">Signal Strength:</p>
                                <span @mouseover="sigHover = true" @mouseleave="sigHover = false"
                                    style="display:flex; align-items:center;">
                                    <img class="sigStatImg" v-if="parseInt(signal) > 30" src="/assets/100_sig.png" />
                                    <img class="sigStatImg" v-if="parseInt(signal) <= 30 && parseInt(signal) > 20"
                                        src="/assets/75_sig.png" />
                                    <img class="sigStatImg" v-if="parseInt(signal) <= 20 && parseInt(signal) > 10"
                                        src="/assets/50_sig.png" />
                                    <img class="sigStatImg" v-if="parseInt(signal) <= 10 && parseInt(signal) > 0"
                                        src="/assets/20_sig.png" />
                                    <img class="sigStatImg" v-if="parseInt(signal) <= 0" src="/assets/0_sig.png" />
                                    <span v-if="sigHover" class="statusVal">{{ parseInt(signal).toFixed(0) }}%</span>
                                </span>
                            </div>
                        </div>
                        <!-- battery -->
                        <div class="col-12 col-sm-3">
                            <div style="display: flex; justify-content:center">
                                <p class="statusLabel">Battery Status:</p>
                                <span @mouseover="batHover = true" @mouseleave="batHover = false"
                                    style="display:flex; align-items:center; margin-top:5px">
                                    <img class="battStatImg" v-if="parseInt(battery) > 80" src="/assets/100_batt.png" />
                                    <img class="battStatImg" v-if="parseInt(battery) <= 80 && parseInt(battery) > 60"
                                        src="/assets/80_batt.png" />
                                    <img class="battStatImg" v-if="parseInt(battery) <= 60 && parseInt(battery) > 40"
                                        src="/assets/60_batt.png" />
                                    <img class="battStatImg" v-if="parseInt(battery) <= 40 && parseInt(battery) > 20"
                                        src="/assets/40_batt.png" />
                                    <img class="battStatImg" v-if="parseInt(battery) <= 20 && parseInt(battery) > 0"
                                        src="/assets/20_batt.png" />
                                    <img class="battStatImg" v-if="parseInt(battery) == 0" src="/assets/0_batt.png" />

                                    <span v-if="batHover" class="statusVal">{{ parseInt(battery).toFixed(0) }}%</span>
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div style="display: flex; justify-content:space-between; align-items: center;">
                                <div style="display: flex; align-items: center;">
                                    <p class="statusLabel">In Water:</p>
                                    <div style="margin-left: 8px; margin-top: 6px;">
                                        <div class="pretty p-default p-round">
                                            <input type="checkbox" v-model="deviceInWaterProperty" />
                                            <div class="state p-success-o">
                                                <label>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <BootstrapIcon icon="question-circle" @click="openhelp" class="util-tools"
                                    v-b-popover.hover.top="'Help'" style="margin-right: 10px; width: 24px; height: 24px;">
                                </BootstrapIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- weather and map row -->
            <div class="row defaultRow">
                <div class="col-12 col-md-6 cust-col" v-if="inLongLat">
                    <SlotMap :deviceLat="deviceLat" :deviceLong="deviceLong" :gpsLastUpdate="gpsLastUpdate"
                        :mapOptions="mapOptions" :slotName="slotName" :fix-ok="fixOk">
                    </SlotMap>
                </div>
                <div class="col-12 col-md-6 cust-col">
                    <div class="card" id="weatherBox" style="position: relative;">
                        <WeatherWidget :lat="deviceLat.toString()" :long="deviceLong.toString()" :metric="deg">
                        </WeatherWidget>
                    </div>
                </div>
            </div>

            <!-- on load -->
            <loading :active="isLoading" :can-cancel="true" :is-full-page="true"></loading>

            <!-- row 2/3 - Sensor Gauges-->
            <div class="align-content-center justify-content-center row defaultRow">
                <!--phycocyanin-->
                <div class="col-6 col-md-4" id="doughnut" v-if="featureEnabled('phycocyanin')">
                    <div class="card" id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[4])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[4]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyPCStatChart">
                        </SensorGauges>
                    </div>
                </div>
                <!--chlorophyll-->
                <div class="col-6 col-md-4" id="doughnut" v-if="featureEnabled('chlorA')">
                    <div class="card" id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[5])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[5]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyCAStatChart">
                        </SensorGauges>
                    </div>
                </div>
                <!--turbidity -->
                <div class="col-6 col-md-4" id="doughnut">
                    <div class="card" id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[3])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[3]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyTUStatChart">
                        </SensorGauges>
                    </div>
                </div>
                <!--air temp-->
                <div class="col-6 col-md-4" id="doughnut" v-if="device?.feature === 0">
                    <div class="card" id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[1])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[1]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyATStatChart">
                        </SensorGauges>
                    </div>
                </div>
                <div class="col-6 col-md-4" id="doughnut" v-if="device?.feature !== 0">
                    <div class="card" id="doughnutBox">
                        <TrackerTracesGauges ref="trackerTracesGauges"></TrackerTracesGauges>
                    </div>
                </div>

                <!--water-->
                <div class="col-6 col-md-4" id="doughnut">
                    <div class="card " id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[2])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[2]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyWTStatChart">
                        </SensorGauges>
                    </div>
                </div>
                <!--solar-->
                <div class="col-6 col-md-4" id="doughnut">
                    <div class="card" id="doughnutBox">
                        <i class="material-icons-outlined alert-icon"
                            @click="editAlerts(statCharts[0])">notification_important</i>
                        <SensorGauges :deviceOffline="deviceOffline" :data="statCharts[0]"
                            :doughnutOptions="doughnutOptions" :loaded="loaded" :key="keyLIStatChart">
                        </SensorGauges>
                    </div>
                </div>
            </div>
            <!-- Utility Bar -->
            <div class="row defaultRow">
                <div class="card" style="width: 100%">
                    <p class="util-text">Options</p>
                    <div class="util-opts">
                        <img src="/assets/setting_check.svg" @click="qualityModel=!qualityModel" class="util-tools" v-b-popover.hover.top="'Quality Control Tool'"/>
                        <BootstrapIcon icon="menu-button-wide" @click="gotoEventsPage()" class="util-tools"
                                     v-b-popover.hover.top="'Events, Calibrations, Alert Log'">
                        </BootstrapIcon>
                        <BootstrapIcon icon="calendar2-plus" class="util-tools" @click="eventModal = !eventModal"
                            v-b-popover.hover.top="'Add Weather/Treatment Event'"></BootstrapIcon>
                        <BootstrapIcon icon="arrow-repeat" class="util-tools" @click="openDataReadingModal()"
                            v-b-popover.hover.top="'Take Data Reading'">
                        </BootstrapIcon>
                        <BootstrapIcon icon="bullseye" class="util-tools" @click="fieldCalModal = !fieldCalModal"
                            v-b-popover.hover.top="'Calibrate Device'">
                        </BootstrapIcon>
                        <!--                        <BootstrapIcon v-else icon="bullseye" class="util-tools"-->
                        <!--                            v-b-popover.hover.top="'contact admin to access'"></BootstrapIcon>-->
                        <BootstrapIcon icon="arrow-clockwise" @click="refreshUI()" class="util-tools"
                            v-b-popover.hover.top="'Refresh Data(Get Latest Data from Device)'"></BootstrapIcon>
                        <BootstrapIcon icon="calendar3" @click="selectChartDatesModal = !selectChartDatesModal"
                            class="util-tools" v-b-popover.hover.top="'Change Plot Date Ranges'"></BootstrapIcon>
                        <BootstrapIcon icon="download" @click="exportModal = !exportModal" class="util-tools"
                            v-b-popover.hover.top="'Download Data to Local Computer'"></BootstrapIcon>
                        <BootstrapIcon v-if="isART || !isViewerOnly" icon="wrench"
                            @click="chartPropertiesModal = !chartPropertiesModal" class="util-tools"
                            v-b-popover.hover.top="'Edit Chart Properties'"></BootstrapIcon>
                        <!--                        <BootstrapIcon v-if="isART" icon="gear-fill" @click="goToManageDevice" class="util-tools"-->
                        <!--                            v-b-popover.hover.top="'advanced settings'"></BootstrapIcon>-->
                        <BootstrapIcon v-if="isART" icon="graph-up" class="util-tools" @click="goCompensated()"
                        v-b-popover.hover.top="'Compensated Plots'"></BootstrapIcon>
                        <BootstrapIcon v-if="isART || !isViewerOnly"  icon="bucket" class="util-tools" @click="goCalibration()"
                            v-b-popover.hover.top="'Calibration'"></BootstrapIcon>
                        <BootstrapIcon icon="house" @click="goHome()" class="util-tools"
                            v-b-popover.hover.top="'Return Home'">
                        </BootstrapIcon>
                        <BootstrapIcon icon="question-circle" @click="openhelp" class="util-tools"
                            v-b-popover.hover.top="'Help'" style="font-size: 0.9em;">
                        </BootstrapIcon>
                    </div>
                </div>
            </div>
            <!--phycocyanin and chlorophyll line chart -->
            <div class="align-content-center justify-content-center row defaultRow"
                v-if="featureEnabled('phycocyanin')">
                <div class="card" style="width: 100%">
                    <line-chart class="lineChart" v-if="algaeTimeReportsChart" :chartdata="algaeTimeReportsChart"
                        :options="algaeLineChartOptions" :key="keyCaPc" :plugins="LinePlugin" :zoom-enable="true"
                        ref="lineChart" />
                    <div class="align-content-center justify-content-center row">
                        <div style="display: flex; flex-direction: row; width: 100%; justify-content: center;">
                            <div class="custom-switch">
                                <p>RFU</p>
                                <b-form-checkbox v-model="rfuSwitchUgL" name="check-button" class="my-checkbox" switch
                                    @change="onSwitchChange">
                                    ug/L
                                </b-form-checkbox>
                            </div>
                            <b-form-checkbox v-model="spikeRemovalFlag" class="util-text">Spike
                                Removal&nbsp;</b-form-checkbox>
                            <b-form-checkbox v-model="rawPlot" class="util-text">Detail</b-form-checkbox>
                            <b-form-checkbox v-model="smoothPlot" class="util-text"
                                style="margin-left: 15px">Trend</b-form-checkbox>
                            <b-form-checkbox v-model="fieldCalPlot" class="util-text" style="margin-left: 15px">Field
                                Calibrated</b-form-checkbox>
                            <b-form-checkbox v-model="showPC" class="util-text"
                                style="margin-left: 15px">PC</b-form-checkbox>
                            <b-form-checkbox v-model="showCA" class="util-text"
                                style="margin-left: 15px">CA</b-form-checkbox>
                            <BootstrapIcon icon="arrow-clockwise" @click="caPcChart(true)" class="util-tools refresh">
                            </BootstrapIcon>
                        </div>
                    </div>
                    <div class="align-content-center justify-content-center " style="text-align: center;"
                        v-if="calPlotError">
                        <p style="margin: auto; padding: auto 3px auto 3px; color:white;">
                            You have selected Field Calibrated but the following sensor(s) have no calibration data:
                        </p>
                        <p style="margin: auto; color:white; padding: auto 3px auto 3px;"> {{ calPlotError }} </p>
                        <p style="margin: auto; color:white; padding: auto 3px auto 3px;">
                            Trend data is displayed instead. </p>
                    </div>
                </div>
            </div>

            <!--water & turbidity :options="waterTempOptions"-->
            <div class="align-content-center justify-content-center row defaultRow">
                <!--water-->
                <div class="col-12 col-md-6 cust-col">
                    <div class="card">
                        <line-chart class="lineChart" :chartdata="waterTempLineChart" :options="waterTempOptions"
                            :key="keyWaterTemp" :plugins="LinePlugin" />
                    </div>
                </div>
                <!-- turbidity -->
                <div class="col-12 col-md-6 cust-col">
                    <div class="card">
                        <line-chart class="lineChart" :chartdata="turbidityLineChart" :options="turbidityOptions"
                            :key="keyTurb" :plugins="LinePlugin" zoom-enable="true" />
                    </div>
                </div>
            </div>
            <!--custom charts -->
            <div v-if="showCustomChart" class="align-content-center justify-content-center  defaultRow">
                <div class="card">
                    <line-chart class="lineChart" :chartdata="customChart" :options="customChartOptions"
                        :key="keyCustom" :plugins="LinePlugin" zoom-enable="true" />
                    <div class="align-content-center justify-content-center row" style="height: 40px;">
                        <b-btn class="customChartButton" style="backgroundColor:#005FBE;"
                            @click="createChartModal = !createChartModal">Customize</b-btn>
                    </div>
                </div>
            </div>
            <!-- Tracker Traces -->
            <div class="align-content-center justify-content-center row defaultRow">
                <TrackerTracesPlots ref="trackerTracesPlot" :event-table="eventTable"></TrackerTracesPlots>
            </div>

            <div class="align-content-center justify-content-center row defaultRow">
                <!--Chen: added time series data-->
                <TimeSeriesPlots :sensorNames="timeSeriesNames" :unitF="unitF"
                    @timeSeriesDataUpdated="handleTimeSeriesData" :event-table="eventTable"/>
            </div>

            <!--batt, PV & Signal Strength -->
            <div class="align-content-center justify-content-center row defaultRow">
                <!-- battery and PV -->
                <div class="col-12 col-md-6 cust-col">
                    <div class="card">
                        <line-chart class="lineChart" :chartdata="battPVChart" :options="battPVOptions" :key="keyBatSig"
                            :plugins="LinePlugin" />
                    </div>
                </div>
                <!--Signal Strength and Solar Light-->
                <div class="col-12 col-md-6 cust-col">
                    <div class="card">
                        <line-chart class="lineChart" :chartdata="ssLiChart" :options="sigStrengthSolarOptions"
                            :key="keyLight" :plugins="LinePlugin" />
                    </div>
                </div>
            </div>
            <!-- Utility Bar -->
            <div class="row defaultRow">
                <div class="card" style="width: 100%">
                    <p class="util-text">Options</p>
                    <div class="util-opts">
                      <img src="/assets/setting_check.svg" @click="qualityModel=!qualityModel" class="util-tools" v-b-popover.hover.top="'Quality Control Tool'"/>
                      <BootstrapIcon icon="menu-button-wide" @click="gotoEventsPage()" class="util-tools"
                                     v-b-popover.hover.top="'Events, Calibrations, Alert Log'">
                      </BootstrapIcon>
                        <BootstrapIcon icon="calendar2-plus" class="util-tools" @click="eventModal = !eventModal"
                            v-b-popover.hover.top="'Add Weather/Treatment Event'"></BootstrapIcon>
                        <BootstrapIcon icon="arrow-repeat" class="util-tools" @click="openDataReadingModal()"
                            v-b-popover.hover.top="'Take Data Reading'">
                        </BootstrapIcon>
                        <BootstrapIcon icon="bullseye" class="util-tools" @click="fieldCalModal = !fieldCalModal"
                            v-b-popover.hover.top="'Calibrate Device'">
                        </BootstrapIcon>
                        <!--                        <BootstrapIcon v-else icon="bullseye" class="util-tools"-->
                        <!--                            v-b-popover.hover.top="'contact admin to access'"></BootstrapIcon>-->
                        <BootstrapIcon icon="arrow-clockwise" @click="refreshUI()" class="util-tools"
                            v-b-popover.hover.top="'Refresh Data (Get Latest Data from Device)'"></BootstrapIcon>
                        <BootstrapIcon icon="calendar3" @click="selectChartDatesModal = !selectChartDatesModal"
                            class="util-tools" v-b-popover.hover.top="'Change Plot Date Ranges'"></BootstrapIcon>
                        <BootstrapIcon icon="download" @click="exportModal = !exportModal" class="util-tools"
                            v-b-popover.hover.top="'Download Data to Local Computer'"></BootstrapIcon>
                        <BootstrapIcon v-if="isART || !isViewerOnly" icon="wrench"
                            @click="chartPropertiesModal = !chartPropertiesModal" class="util-tools"
                            v-b-popover.hover.top="'Edit Chart Properties'"></BootstrapIcon>
                        <!--                        <BootstrapIcon v-if="isART" icon="gear-fill" @click="goToManageDevice" class="util-tools"-->
                        <!--                            v-b-popover.hover.top="'advanced settings'"></BootstrapIcon>-->
                        <BootstrapIcon v-if="isART" icon="graph-up" class="util-tools" @click="goCompensated()"
                                                   v-b-popover.hover.top="'Compensated Plots'"></BootstrapIcon>
                        <BootstrapIcon v-if="isART || !isViewerOnly" icon="bucket" class="util-tools" @click="goCalibration()"
                            v-b-popover.hover.top="'Calibration'"></BootstrapIcon>
                        <BootstrapIcon icon="house" @click="goHome()" class="util-tools"
                            v-b-popover.hover.top="'Return Home'">
                        </BootstrapIcon>
                        <BootstrapIcon icon="question-circle" @click="openhelp" class="util-tools"
                            v-b-popover.hover.top="'Help'" style="font-size: 0.9em;">
                        </BootstrapIcon>
                    </div>
                </div>
            </div>
            <!--Playground Charts -->
            <div v-if="isART && this.showPlaygroundChart"
                class="align-content-center justify-content-center  defaultRow">
                <div class="card" style="width: 100%">
                    <line-chart class="playgroundChart" :chartdata="playgroundChart" :options="playgroundChartOptions"
                        :key="keyPlayground" :plugins="LinePlugin" />
                    <div class="playgroundCard">
                        <!-- update -->
                        <div class="align-content-center justify-content-center row" style="width:100%">
                            <b-btn class="customChartButton"
                                style="margin-bottom:10px; margin-top: 10px; backgroundColor:#005FBE;"
                                @click="createPlayground()">Update Chart</b-btn>
                            <!-- <p class="playgroundHeader"> Update </p>
                <BootstrapIcon icon="arrow-clockwise" @click="updatePlayChart()" class="util-tools refresh"></BootstrapIcon> -->
                        </div>
                        <!-- PC -->
                        <div class="align-content-center justify-content-center row">
                            <div class="col-6" style="border-style:solid; border-color:#717173;">
                                <div class="row">
                                    <p class="playgroundHeader">Phycocyanin</p>
                                </div>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <label class="play-text">left axis</label>
                                    <div class="deg-switch">
                                        <b-form-checkbox switch size="lg" v-model="playPCAx">
                                        </b-form-checkbox>
                                    </div>
                                    <label class="play-text">right axis</label>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <b-form-checkbox v-model="playPC" class="playgroundText">
                                            Detail</b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playPCTrend" class="playgroundText">Trend
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playPCNPQ" class="playgroundText">NPQ
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playPCTempComp" class="playgroundText">Temp. Comp.
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playPCAvg" class="playgroundText">Day Avg.
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <p class="playgroundText">alpha:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.alpha"
                                            :placeholder="trendlineProperties.pcProperties.alpha.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">max light:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.maxLight"
                                            :placeholder="trendlineProperties.pcProperties.maxLight.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">k:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.kl"
                                            :placeholder="trendlineProperties.pcProperties.kl.toString()">
                                        </b-form-input>
                                    </div>
                                </div>
                                <div class="row playRow" style="margin-bottom: 10px;">
                                    <div>
                                        <p class="playgroundText">alpha (temp comp)</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.alphaTemp"
                                            :placeholder="trendlineProperties.pcProperties.alphaTemp.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">Temp during cal. (C):</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.stTemp"
                                            :placeholder="trendlineProperties.pcProperties.stTemp.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText ">k (temp comp):</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.pcProperties.kTemp"
                                            :placeholder="trendlineProperties.pcProperties.kTemp.toString()">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                            <!-- CA -->
                            <div class="col-6" style="border-style:solid; border-color:#717173;">
                                <div class="row">
                                    <p class="playgroundHeader">Chlorophyll-a</p>
                                </div>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <label class="play-text">left axis</label>
                                    <div class="deg-switch">
                                        <b-form-checkbox switch size="lg" v-model="playCAAx">
                                        </b-form-checkbox>
                                    </div>
                                    <label class="play-text">right axis</label>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <b-form-checkbox v-model="playCA" class="playgroundText">
                                            Detail</b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playCATrend" class="playgroundText">Trend
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playCANPQ" class="playgroundText">NPQ
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playCAAvg" class="playgroundText">Day Avg.
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="row playRow" style="margin-bottom: 10px;">
                                    <div>
                                        <p class="playgroundText">alpha:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.caProperties.alpha"
                                            :placeholder="trendlineProperties.caProperties.alpha.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">max light:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.caProperties.maxLight"
                                            :placeholder="trendlineProperties.caProperties.maxLight.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">k:</p>
                                        <b-form-input class=" playgroundInput" type="number"
                                            v-model.number="trendlineProperties.caProperties.kl"
                                            :placeholder="trendlineProperties.caProperties.kl.toString()">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- TB WT -->
                        <div class="align-content-center justify-content-center row">
                            <!-- turbidity -->

                            <div class="col-6 " style="border-style:solid;border-color:#717173">
                                <div class="row">
                                    <p class="playgroundHeader">Turbidity</p>
                                </div>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <label class="play-text">left axis</label>
                                    <div class="deg-switch">
                                        <b-form-checkbox switch size="lg" v-model="playTUAx">
                                        </b-form-checkbox>
                                    </div>
                                    <label class="play-text">right axis</label>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <b-form-checkbox v-model="playTU" class="playgroundText">
                                            Detail</b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playTUTrend" class="playgroundText"
                                            style="margin-left: 15px">Trend
                                        </b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playTUAvg" class="playgroundText">Day Avg.
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <p class="playgroundText">alpha (temp comp):</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.tuProperties.alphaTemp"
                                            :placeholder="trendlineProperties.tuProperties.alphaTemp.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">temp at cal (C)</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.tuProperties.stTemp"
                                            :placeholder="trendlineProperties.tuProperties.stTemp.toString()">
                                        </b-form-input>
                                    </div>
                                    <div>
                                        <p class="playgroundText">k (temp comp)</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.tuProperties.kTemp"
                                            :placeholder="trendlineProperties.tuProperties.kTemp.toString()">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                            <!-- water temp -->
                            <div class="col-6 " style="border-style:solid;border-color:#717173">
                                <div class="row">
                                    <p class="playgroundHeader">Water Temp</p>
                                </div>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <label class="play-text">left axis</label>
                                    <div class="deg-switch">
                                        <b-form-checkbox switch size="lg" v-model="playWTAx">
                                        </b-form-checkbox>
                                    </div>
                                    <label class="play-text">right axis</label>
                                </div>
                                <div class="d-flex flex-row justify-content-center align-items-center">
                                    <label class="play-text">&deg; F</label>
                                    <div class="deg-switch">
                                        <b-form-checkbox switch size="lg" v-model="unitPlayTemp">
                                        </b-form-checkbox>
                                    </div>
                                    <label class="play-text">&deg; C</label>
                                </div>
                                <div class="row playRow">
                                    <div>
                                        <b-form-checkbox v-model="playWT" class="playgroundText">
                                            Detail</b-form-checkbox>
                                    </div>
                                    <div>
                                        <b-form-checkbox v-model="playWTTrend" class="playgroundText"
                                            style="margin-left: 15px">Trend
                                        </b-form-checkbox>
                                    </div>
                                </div>
                                <div class="row playRow" style="margin-bottom: 10px;">
                                    <div>
                                        <p class="playgroundText">alpha:</p>
                                        <b-form-input class="playgroundInput" type="number"
                                            v-model.number="trendlineProperties.wtProperties.alpha"
                                            :placeholder="trendlineProperties.wtProperties.alpha.toString()">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- All other params -->
                        <div class="align-content-center justify-content-center row"
                            style="border-style:solid;border-color:#717173">
                            <div class="row" style="width:100%">
                                <p class="playgroundHeader col-12">Other Parameters</p>
                            </div>

                            <div class="row playRow" style="width:100%">
                                <!-- solar light -->
                                <div>
                                    <b-form-checkbox v-model="playSL" class="playgroundText">Solar Light
                                    </b-form-checkbox>
                                    <div class="d-flex flex-row justify-content-center align-items-center">
                                        <label class="play-text">left</label>
                                        <div class="deg-switch">
                                            <b-form-checkbox switch size="lg" v-model="playSLAx">
                                            </b-form-checkbox>
                                        </div>
                                        <label class="play-text">right</label>
                                    </div>
                                </div>
                                <!-- panel volts -->
                                <div>
                                    <b-form-checkbox v-model="playPV" class="playgroundText">Panel Volts
                                    </b-form-checkbox>
                                    <div class="d-flex flex-row justify-content-center align-items-center">
                                        <label class="play-text">left</label>
                                        <div class="deg-switch">
                                            <b-form-checkbox switch size="lg" v-model="playPVAx">
                                            </b-form-checkbox>
                                        </div>
                                        <label class="play-text">right</label>
                                    </div>
                                </div>
                                <!-- sig strength -->
                                <div>
                                    <b-form-checkbox v-model="playSS" class="playgroundText">Signal Strength
                                    </b-form-checkbox>
                                    <div class="d-flex flex-row justify-content-center align-items-center">
                                        <label class="play-text">left</label>
                                        <div class="deg-switch">
                                            <b-form-checkbox switch size="lg" v-model="playSSAx">
                                            </b-form-checkbox>
                                        </div>
                                        <label class="play-text">right</label>
                                    </div>
                                </div>
                                <!-- bat strength -->
                                <div>
                                    <b-form-checkbox v-model="playBS" class="playgroundText">Battery Strength
                                    </b-form-checkbox>
                                    <div class="d-flex flex-row justify-content-center align-items-center">
                                        <label class="play-text">left</label>
                                        <div class="deg-switch">
                                            <b-form-checkbox switch size="lg" v-model="playBSAx">
                                            </b-form-checkbox>
                                        </div>
                                        <label class="play-text">right</label>
                                    </div>
                                </div>
                                <!-- Leak Detector -->
                                <div>
                                    <b-form-checkbox v-model="playLD" class="playgroundText">Leak Detector
                                    </b-form-checkbox>
                                    <div class="d-flex flex-row justify-content-center align-items-center">
                                        <label class="play-text">left</label>
                                        <div class="deg-switch">
                                            <b-form-checkbox switch size="lg" v-model="playLDAx">
                                            </b-form-checkbox>
                                        </div>
                                        <label class="play-text">right</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- update -->
                        <div class="align-content-center justify-content-center row" style="width:100%">
                            <b-btn class="customChartButton" style="margin-top: 20px; backgroundColor:#005FBE;"
                                @click="createPlayground()">Update Chart</b-btn>

                            <!-- <p class="playgroundHeader"> Update </p>
                <BootstrapIcon icon="arrow-clockwise" @click="updatePlayChart()" class="util-tools refresh"></BootstrapIcon> -->
                        </div>
                        <div class="align-content-center justify-content-center row" style="width:100%">
                            <b-btn class="customChartButton"
                                style="margin-bottom:10px; margin-top: 10px; backgroundColor:#005FBE;"
                                @click="updateTrendLineProperties()">Save Data to Device</b-btn>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Super_Admin settings modal -->
            <b-modal v-if="device" v-model="adminSettingsModal" title="Trendline Properties"
                @ok="updateTrendLineProperties()" ok-title="Update">
                <div>
                    <label class="unitText">{{ awakedMessage }}</label>
                    <input type="checkbox" value="test" v-model="device.wakeRequest" @change="updateAwake($event)" />
                </div>
                <div>
                    <p class="unitText">Show Playground Chart:</p>
                    <input type="checkbox" v-model="showPlaygroundChart" />
                </div>
                <div class="editUnit">
                    <p class="unitText">Trendline alpha:</p>
                    <b-row>
                        <b-col>
                            <p>Phycocyanin</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.pcProperties.alpha"
                                :placeholder="trendlineProperties.pcProperties.alpha.toString()"></b-form-input>
                        </b-col>
                        <b-col>
                            <p>Chlorophyll A</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.caProperties.alpha"
                                :placeholder="trendlineProperties.caProperties.alpha.toString()"></b-form-input>
                        </b-col>
                    </b-row>
                </div>
                <div class="editUnit">
                    <p class="unitText">Light Gain:</p>
                    <b-row>
                        <b-col>
                            <p>Phycocyanin</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.pcProperties.kl"
                                :placeholder="trendlineProperties.pcProperties.kl.toString()"></b-form-input>
                        </b-col>
                        <b-col>
                            <p>Chlorophyll A</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.caProperties.kl"
                                :placeholder="trendlineProperties.caProperties.kl.toString()"></b-form-input>
                        </b-col>
                    </b-row>
                </div>
                <div class="editUnit">
                    <p class="unitText">Max Solar Light:</p>
                    <b-row>
                        <b-col>
                            <p>Phycocyanin</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.pcProperties.maxLight"
                                :placeholder="trendlineProperties.pcProperties.maxLight.toString()"></b-form-input>
                        </b-col>
                        <b-col>
                            <p>Chlorophyll A</p>
                            <b-form-input type="number" v-model.number="trendlineProperties.caProperties.maxLight"
                                :placeholder="trendlineProperties.caProperties.maxLight.toString()"></b-form-input>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <!-- alerts modal -->
            <b-modal v-model="alertEditModal" id="modal-alerts" :title="editChartData.displayName"
                @ok="(e) => saveAlert(e, editChartData, editChartDataRangeValue)">
                <div class="row">
                    <p>Set Sensor Alert Levels</p>
                    <BootstrapIcon icon="question-circle" style="margin-left:0.5rem" id="alert-popover"></BootstrapIcon>
                    <b-popover target="alert-popover" triggers="hover">
                        Use the slider or text boxes below to change alert triggers
                    </b-popover>
                </div>
                <div class="row mt-3" style="margin-bottom:2rem">
                    <div class="col">
                        <vue-slider @change="alertRangeSliderChanged()" ref="alertRangeSlider"
                            v-model="editChartDataRangeValue" :min="alertRangeSliderMin" :max="alertRangeSliderMax"
                            :marks="[alertRangeSliderMin, alertRangeSliderMax]">
                        </vue-slider>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-form-input id="alert-low-popover" v-model="editChartDataRangeValue[0]"
                            @change="(val) => setRange(0, val)" placeholder="low"></b-form-input>
                    </div>
                    <div class="col">
                        <b-form-input id="alert-high-popover" v-model="editChartDataRangeValue[1]"
                            @change="(val) => setRange(1, val)" placeholder="high"></b-form-input>
                    </div>
                    <b-popover target="alert-low-popover" triggers="hover">
                        Sensor values below this limit will result in a red gauge
                    </b-popover>
                    <b-popover target="alert-high-popover" triggers="hover" placement="left">
                        Sensor values above this limit will result in a red gauge
                    </b-popover>
                </div>
                <div class="row">
                    <div class="col">
                        Low Limit
                    </div>
                    <div class="col">
                        High Limit
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-form-checkbox id="checkbox-alertActive" v-model="editChartData.alertActive"
                            name="checkbox-alertActive">
                            <p style="color: black">Allow Email Notifications</p>
                        </b-form-checkbox>
                    </div>
                </div>
            </b-modal>
            <!-- alert modal for lowest permission level -> 'users' -->
            <b-modal v-model="lowPermAlertEditModal" id="modal-alerts" :title="editChartData.displayName">
                <div class="row">
                    <p>Sensor Alert Level Settings</p>
                    <BootstrapIcon icon="question-circle" style="margin-left:0.5rem" id="alert-popover"></BootstrapIcon>
                    <b-popover target="alert-popover" triggers="hover">
                        Please note you do not have the permissions to change these settings. Please contact
                        your admin or AquaRealTime
                    </b-popover>
                </div>
                <div class="row mt-3" style="margin-bottom:2rem">
                    <div class="col">
                        <vue-slider ref="alertRangeSlider" v-model="editChartDataRangeValue" :min="alertRangeSliderMin"
                            :max="alertRangeSliderMax" :marks="[alertRangeSliderMin, alertRangeSliderMax]"
                            :disabled="true">
                        </vue-slider>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-form-input id="alert-low-popover" v-model="editChartDataRangeValue[0]" placeholder="low"
                            :disabled="true"></b-form-input>
                    </div>
                    <div class="col">
                        <b-form-input id="alert-high-popover" v-model="editChartDataRangeValue[1]" placeholder="high"
                            :disabled="true"></b-form-input>
                    </div>
                    <b-popover target="alert-low-popover" triggers="hover">
                        Sensor values below this limit will result in a red gauge
                    </b-popover>
                    <b-popover target="alert-high-popover" triggers="hover" placement="left">
                        Sensor values above this limit will result in a red gauge
                    </b-popover>
                </div>
                <div class="row">
                    <div class="col">
                        Low Limit
                    </div>
                    <div class="col">
                        High Limit
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <b-form-checkbox id="checkbox-alertActive" name="checkbox-alertActive" :disabled="true">Allow
                            Email
                            Notifications</b-form-checkbox>
                    </div>
                </div>
            </b-modal>
            <!-- select date range for charts   -->
            <b-modal v-model="selectChartDatesModal" title="Customize Chart" ok-title="Update" @ok="selectChartDates()">
                <div class="util-sub-head">
                    <p class="util-p">start date:</p>
                    <b-form-input class="exprt-form" type="date" v-model="startDateProperty"></b-form-input>
                </div>
                <div class="util-sub-head">
                    <p class="util-p">end date:</p>
                    <b-form-input class="exprt-form" type="date" v-model="endDateProperty"></b-form-input>
                </div>
            </b-modal>
            <!-- export data -->
            <b-modal v-model="exportModal" title="Export Data" @ok="handleExportOk" ok-title="Export" class="export-modal">
                <div class="util-sub-head">
                    <p class="util-p">start date:</p>
                    <b-form-input class="exprt-form" type="date" v-model="startDate"></b-form-input>
                </div>
                <div class="util-sub-head">
                    <p class="util-p">end date:</p>
                    <b-form-input class="exprt-form" type="date" v-model="endDate"></b-form-input>
                </div>
                <div class="util-sub-head">
                    <p class="util-p">Data Type (select at least one):</p>
                </div>
                <div style="margin-left: 20px; margin-bottom: 15px; border-bottom: 1px solid #ccc; padding-bottom: 10px;">
                    <b-form-checkbox v-model="exportDetail">Detail</b-form-checkbox>
                    <b-form-checkbox v-model="exportTrend">Trend</b-form-checkbox>
                </div>
                <div class="util-sub-head">
                    <p class="util-p">Apply these options to the data:</p>
                </div>
                <div style="margin-left: 20px;">
                    <b-form-checkbox v-model="exportSpikeRemoval">Spike Removal</b-form-checkbox>
                    <b-form-checkbox v-model="exportDataExclusion">Data Exclusion</b-form-checkbox>
                </div>
                <div v-if="!exportDetail && !exportTrend" style="color: #dc3545; margin-top: 10px; font-weight: 500;">
                    Please select at least one data type (Detail or Trend)
                </div>
            </b-modal>
            <!-- chart properties modal -->
            <b-modal v-model="chartPropertiesModal" title="Chart Properties" @cancel="chartCancel()"
                @ok="chartProperties()" ok-title="Update">
                <div class="editUnit">
                    <p class="unitText">Temperature:</p>
                    <p class="unitText">&deg; F</p>
                    <b-form-checkbox switch size="lg" v-model="unitF" class="deg-switch"> </b-form-checkbox>
                    <p class="unitText">&deg; C</p>
                </div>
                <div class="editUnit">
                    <p class="unitText">Water Temperature Trend:</p>
                    <p class="unitText">Off</p>
                    <b-form-checkbox switch size="lg" v-model="waterTrend" class="deg-switch">
                    </b-form-checkbox>
                    <p class="unitText">On</p>
                </div>
                <div class="editUnit">
                    <p class="unitText">Turbidity trend:</p>
                    <p class="unitText">Off</p>
                    <b-form-checkbox switch size="lg" v-model="turbidityTrend" class="deg-switch">
                    </b-form-checkbox>
                    <p class="unitText">On</p>
                </div>
                <div v-if="isART" class="editUnit">
                    <p class="unitText">Show Playground Chart:</p>
                    <input type="checkbox" v-model="showPlaygroundChart" />
                </div>
            </b-modal>
            <!-- Create Custom Chart modal -->
            <b-modal v-model="createChartModal" title="Choose Parameters" @cancel="chartCancel()"
                @ok="createCustomChart()" ok-title="Update">
                <div>
                    <b-form-group v-for="(sensor, index) in sensorsSelected" style="margin-bottom: 5px;">
                        <div class="row" v-if="featureEnabled(sensor.feature)">
                            <div class="col-6" style="display: flex;">
                                <b-form-checkbox v-model="sensor.selected">
                                </b-form-checkbox>
                                <p>{{ sensor.text }}</p>
                            </div>
                            <div class="col-6" style="display: flex;">
                                <b-form-select v-model="sensor.axis" :options="axesOpts">
                                </b-form-select>
                            </div>
                        </div>
                    </b-form-group>
                </div>
            </b-modal>
            <!-- calibrate device to field sample -->
            <b-modal v-model="fieldCalModal" title="Calibrate Device" ok-title="Calibrate"
                @ok="applyCal(calSensor, calVal, fieldSample)" ok-variant="success">
                <div>
                    <div>
                        <b-row style="margin-bottom: 5px;">
                            <b-col cols="4">
                                <p class="util-p">Sensor:</p>
                            </b-col>
                            <b-col cols="8">
                                <b-form-select v-model="calSensor" :options="calSensorOptions" class="exprt-form">
                                </b-form-select>
                            </b-col>
                        </b-row>

                        <b-row style="margin-bottom: 5px;">
                            <b-col cols="4">
                                <p class="util-p">Calibration Date:</p>
                            </b-col>
                            <b-col cols="8">
                                <b-form-input class="exprt-form" type="date" v-model="calDate" required></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row style="margin-bottom: 5px;">
                            <b-col cols="4">
                                <p class="util-p">Calibration Time:</p>
                            </b-col>
                            <b-col cols="8">
                                <b-form-input class="exprt-form" type="time" v-model="calTime" required></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4">
                                <p class="util-p">Field Sample (&#181;g/L):</p>
                            </b-col>
                            <b-col cols="8">
                                <b-form-input class="exprt-form" placeholder="sample ug/L" v-model="fieldSample"
                                    required>
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </div>
                    <div style="text-align:center">
                        <b-btn @click="checkCal(calDate, calTime, calSensor, fieldSample)"
                            style="background:#49dcf3; color:black;">
                            Check Calibration
                        </b-btn>
                    </div>
                    <line-chart class="lineChart" v-if="verCalChart" :chartdata="calChartData"
                        :options="calChartOptions" :key="keyCalChart" :plugins="LinePlugin" />
                    <div v-if="verCalChart" style="margin-top:5px;">
                        <p>
                            The closest measurement by the AlgaeTracker is
                            <strong> {{ Math.round(calVal * 10) / 10 }}RFU </strong> one
                            <strong>{{ calDate }}</strong> at <strong>{{ calTime }}</strong> and is shown in red
                            in the plot above.
                        </p>
                        <p>
                            Calibrate <strong> {{ Math.round(calVal * 10) / 10 }} RFU </strong> to
                            <strong> {{ fieldSample }}&#181;g/L </strong>?
                        </p>
                        <!-- <div style="text-align:center">
              <b-btn @click="postCal(calSensor,calVal,fieldSample)"> Calibrate {{calSensor}} </b-btn>
            </div> -->
                    </div>
                    <div v-if="calError">
                        <p>{{ calError }}</p>
                    </div>
                    <div v-if="calSuccess">
                        <p>{{ calSuccess }}</p>
                    </div>
                </div>
                <template #footer>
                    <p v-if="isViewerOnly" style="flex-grow:1;flex-shrink: 0">This feature requires Admin rights.</p>
                    <button class="btn btn-secondary btn-md btn" type="button" @click="fieldCalModal = !fieldCalModal">
                        <div class="btn-content">Cancel</div>
                    </button>
                    <button class="btn btn-success btn-md btn" type="button"
                        :style="{ backgroundColor: isViewerOnly ? '#e0e0e0' : '' }" :disabled="isViewerOnly"
                        @click="applyCal(calSensor, calVal, fieldSample)">
                        <div class="btn-content">Calibrate</div>
                    </button>
                </template>
            </b-modal>
            <!-- Data Reading Modal -->
            <b-modal v-model="dataReadingModal" hide-footer size="xl" @hidden="closeDataReadingModal" :title="dataReadingTitle">
                <!-- Device Status Subtitle -->
                <div v-if="formattedLastHeard" class="alert alert-info mb-3">
                    <div><strong>Device Last Online:</strong> {{ formattedLastHeard }}</div>
                    <div v-if="predictedNextReading"><strong>Predicted Next Reading:</strong> {{ predictedNextReading }}</div>
                </div>
                <!-- Debug Panel Toggle -->
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="d-flex">
                        <button class="btn btn-sm btn-outline-secondary me-2" @click="toggleMockMode()">
                            {{ mockMode ? 'Disable Mock' : 'Enable Mock' }}
                        </button>
                        <button class="btn btn-sm btn-outline-info me-2" @click="showDebugPanel = !showDebugPanel">
                            {{ showDebugPanel ? 'Hide Debug' : 'Show Debug' }}
                        </button>
                        <button class="btn btn-sm btn-outline-warning me-2" @click="clearDebugLogs()" v-if="showDebugPanel">
                            Clear Logs
                        </button>
                        <button class="btn btn-sm btn-outline-success me-2" @click="runTestScenario()" v-if="showDebugPanel && !isRunningTest">
                            Run Test
                        </button>
                        <button class="btn btn-sm btn-outline-primary me-2" @click="exportTestReport()" v-if="showDebugPanel">
                            Export Report
                        </button>
                    </div>
                    <div class="d-flex align-items-center">
                        <button class="btn btn-sm btn-link text-primary p-2" @click="openTestingGuide()" 
                                v-b-popover.hover.top="'Open testing guide for detailed instructions'"
                                style="text-decoration: none; border: 1px solid #007bff; border-radius: 4px;">
                            <BootstrapIcon icon="question-circle" style="font-size: 1.2em;"></BootstrapIcon>
                        </button>
                    </div>
                </div>
                
                <div class="row">
                    <div :class="showDebugPanel ? 'col-8' : 'col-12'">
                        <div v-if="dataReadingStep === 'preparation'">
                            <h5>{{ preparationMessage }}</h5>
                            <div v-if="!isDataReadingReady && currentDataReadingAttempt < maxDataReadingAttempt">
                                <b-spinner small type="grow"></b-spinner>
                            </div>
                            <div class="text-center mt-3" v-if="isDataReadingReady">
                                <button class="btn btn-success btn-md" @click="dataReadingStep = 'reading'">
                                    Next
                                </button>
                            </div>
                        </div>
                        
                        <div v-if="dataReadingStep === 'reading'">
                            <h5>Data Reading</h5>
                            <div v-if="!isWaitingForData && !dataReadingSuccess">
                                <p>Click "Take Reading" button to start data collection. This process takes approximately 30 seconds.</p>
                                <div class="text-center">
                                    <button class="btn btn-primary btn-md" @click="takeReading()" :disabled="isWaitingForData">
                                        Take Reading
                                    </button>
                                </div>
                            </div>
                            
                            <div v-if="isWaitingForData" class="text-center">
                                <h6>Waiting for data reading to complete...</h6>
                                <b-spinner type="grow"></b-spinner>
                                <p class="mt-2">Please wait approximately 30 seconds</p>
                            </div>
                            
                            <div v-if="dataReadingSuccess" class="text-center mt-3">
                                <div class="alert alert-success">
                                    <strong>The reading was successful and can be seen when you return to the dashboard.</strong>
                                </div>
                                <div class="mt-2">
                                    <button class="btn btn-primary btn-md me-2" @click="takeAnotherReading()" :disabled="isWaitingForData">
                                        Take Another Reading
                                    </button>
                                    <button class="btn btn-secondary btn-md" @click="closeDataReadingModal()">
                                        Finish
                                    </button>
                                </div>
                            </div>
                            
                            <div v-if="dataReadingError" class="alert alert-danger">
                                {{ dataReadingError }}
                            </div>
                        </div>
                    </div>
                    
                    <!-- Debug Panel -->
                    <div class="col-4" v-if="showDebugPanel">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="mb-0">Debug Panel</h6>
                            </div>
                            <div class="card-body debug-panel-body" style="max-height: 400px; overflow-y: auto; background-color: #f8f9fa;">
                                <div class="mb-2">
                                    <small class="text-muted">Mock Mode: {{ mockMode ? 'ON' : 'OFF' }}</small>
                                </div>
                                <div v-if="debugLogs.length === 0" class="text-muted small">
                                    No API calls yet...
                                </div>
                                <div v-for="(log, index) in debugLogs" :key="index" class="mb-3 p-3 debug-log-item" 
                                     style="border-left: 4px solid; border-radius: 4px; background-color: #fff;"
                                     :class="{'border-success': log.success, 'border-danger': !log.success}">
                                    <div class="d-flex justify-content-between">
                                        <strong class="debug-log-type">{{ log.type }}</strong>
                                        <small class="debug-log-timestamp">{{ log.timestamp }}</small>
                                    </div>
                                    <div class="debug-log-details mt-1">{{ log.details }}</div>
                                    <div v-if="log.response" class="mt-2">
                                        <strong>Response:</strong>
                                        <pre class="debug-log-response">{{ JSON.stringify(log.response, null, 2) }}</pre>
                                    </div>
                                    <div v-if="log.error" class="mt-2 text-danger">
                                        <strong>Error:</strong> {{ log.error }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <template #footer>
                    <button class="btn btn-secondary btn-md" @click="closeDataReadingModal()">
                        {{ dataReadingStep === 'preparation' ? 'Cancel' : 'Close' }}
                    </button>
                </template>
            </b-modal>
            <!-- Add Event (weather or treatment) -->
            <b-modal v-model="eventModal" title="" hide-footer>
                <div class="overflow-auto">
                    <h3>Previous Events</h3>

                    <b-table id="event-table" style="max-width: 90%; text-align:center" striped hover bordered small
                        :items="eventsProperty" :fields="eventFields" :sort-compare-options="{ numeric: true }"
                        :sort-by.sync="eventSort" responsive="sm" ref="eventSelect" selectable
                        @row-selected="onEventSelected" :per-page="eventPerPage" :current-page="eventCurrentPage"
                        @row-hovered="onRowHovered" @row-unhovered="onRowUnhovered">
                        <template #cell(delete_event)="row">
                            <BootstrapIcon icon="trash" @click="deleteEvent(row)">
                                Show Details
                            </BootstrapIcon>
                        </template>
                    </b-table>
                    <div v-if="rowTooltip && rowTooltip.item.description.length > 0" :style="tooltipStyle"
                        class="custom-tooltip">
                        <b>{{ rowTooltip.item.description }}</b>
                    </div>
                    <b-pagination v-model="eventCurrentPage" :total-rows="eventRows" :per-page="eventPerPage"
                        aria-controls="event-table"></b-pagination>
                </div>
                <div>
                    <h3>Add New Event</h3>
                    <div class="mt-3">Event Type:</div>
                    <div class="row">
                        <div class="col-9">
                            <b-form-select v-model="newEventSelected" :options="newEventOptions"></b-form-select>
                        </div>
                    </div>

                    <div class="mt-3">Event Date/Time:</div>
                    <div class="row">
                        <div class="col-6">
                            <Datepicker v-model="newEventDateTime"></Datepicker>
                        </div>
                    </div>

                    <div v-if="newEventSelected" class="mt-3">Description:</div>
                    <!-- 当选择 Custom 时显示输入框 -->
                    <div v-if="newEventSelected" class="row">
                        <b-form-input v-model="customEventText"
                            :placeholder="`Enter ${newEventSelected.toLowerCase()} event description`"></b-form-input>
                    </div>
                    <div class="row" style="margin-top: 10px; margin-bottom: 10px;">
                        <b-btn class="customChartButton"
                            style="margin-top: 20px; backgroundColor:#005FBE; cursor: pointer;" @click="addEvent()"> Add
                            Event </b-btn>
                    </div>
                    <div class="row" v-if="this.addEventError">
                        <p style="color: red;">{{ addEventError }}</p>
                    </div>
                </div>
            </b-modal>
            <b-modal id="switch_modal" v-model="isShowSwitchAlert" @ok="doneSwitchChange(true)"
                @cancel="doneSwitchChange(false)" @hidden="removeAriaHidden">
                Switching to ug/L values for chlorophyll-a and phycocyanin. Note that there is no one size fits all
                conversion from
                RFU to ug/L for any fluorescence sensor, as this depends on the genera of algae, it's growth phase, and
                other
                factors. For more accurate ug/L readings, use the Field Calibration feature to calibrate RFU to real
                world samples
                you take at the site.
            </b-modal>
            <b-modal v-model="qualityModel" id='modal-lg' size='lg' title="Quality Control (QC) Tool - Data Exclusion" hide-footer>
              <b-tabs content-class="mt-3" class="col-12 col-sm-12" fill active-nav-item-class="active-tab-cu" active-tab-class="tab-cu">
                <b-tab title="Data Exclusion Periods" active>
                  <div class="overflow-auto" style="padding-left: 5px;">
                    <b-form-checkbox v-model="exclusionData.on" name="check-button" switch @change="changeExclusionSwitch">
                      <span style="color:rgb(33, 37, 41)">Activate data exclusion feature.</span>
                    </b-form-checkbox>
                    <h3>Previous data exclusion periods</h3>

                    <b-table id="exclusion-table" style="max-width: 90%; text-align:center" striped hover bordered small
                             :items="exclusionProperty" :fields="exclusionData.fields" :sort-compare-options="{ numeric: true }"
                             :sort-by.sync="exclusionData.sort" responsive="sm" ref="exclusionSelect" :per-page="exclusionData.perpage" :current-page="exclusionData.currentPage" show-empty
                             empty-text="No Previous data exclusion periods">
                      <template #cell(delete_data)="row">
                        <BootstrapIcon icon="trash" @click="deleteExclusionData(row)">
                          Show Details
                        </BootstrapIcon>
                      </template>
                    </b-table>
                    <b-pagination v-model="exclusionData.currentPage" :total-rows="exclusionData.rows" :per-page="exclusionData.perpage"
                                  aria-controls="exclusion-table"></b-pagination>
                  </div>
                  <div>
                    <h3>Add new data exclusion</h3>
                    <div class="mt-3">Data exclusion start date/time</div>
                    <div class="row">
                      <div class="col-6">
                        <Datepicker v-model="exclusionData.startDateTime" @closed="exclusionOnClose"></Datepicker>
                      </div>
                    </div>
                    <div class="mt-3">Data exclusion end date/time</div>
                    <div class="row">
                      <div class="col-6">
                        <Datepicker v-model="exclusionData.endDateTime" @closed="exclusionOnClose"></Datepicker>
                      </div>
                    </div>
                    <div class="mt-3" v-if="exclusionData.showTips" style="color: red">
                      {{exclusionData.tips}}
                    </div>
                    <div class="row" style="margin-bottom: 10px;">
                      <b-btn class="customChartButton"
                             style="margin-top: 20px; backgroundColor:#005FBE; cursor: pointer;" @click="addExclusionPeriod()">Apply exclusion period</b-btn>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Spike Removal">
                  <div class="spike-removal-container">
                    <div class="row mt-3" style="margin-bottom:2rem">
                      <div class="col" style="padding: 0;white-space: pre-wrap;">
<!--                        <vue-slider @change="" ref="spikeSlider"-->
<!--                                    v-model="spikeRemovalData.editDataValue" :min="spikeRemovalData.min" :max="spikeRemovalData.max"-->
<!--                                    :marks="[spikeRemovalData.min, spikeRemovalData.max]">-->
<!--                        </vue-slider>-->
                        Current Z-score Threshold:  {{spikeRemovalData.value}}
                      </div>
                    </div>
                    <div class="row mt-3" style="flex-direction: row;align-items: center">
                      New Z-Score Threshold:
                      <div style="width: 120px;">
                        <b-form-input id="alert-low-popover" v-model="spikeRemovalData.editDataValue"
                                      @change="(val) => setSpikeRange(val)" placeholder="low" style="text-align: center"></b-form-input>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col" style="color:#999;padding: 0px">
                        The default threshold is 3. To remove more spikes, decrease the threshold. To remove less spikes, increase the threshold.
                        <br>
                        The Z-Score of a data point measures how many standard deviations it is from the mean. The Z-Score threshold determines how high of a Z-Score will be considered an outlier in the time series. Data points outside the threshold will be adjusted.
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button  class="btn btn-secondary btn-md btn" type="button" @click="cancelSpike">
                        <div class="btn-content">Cancel</div>
                      </button><button class="btn btn-primary btn-md btn" type="button" @click="doneSpike">
                        <div class="btn-content">Ok</div>
                      </button>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
          </b-modal>
          <Footer></Footer>
        </div>
    </div>
</template>

<style lang="scss">
// Extra small screen / phone
$screen-xs: 425px !default;
// Small screen / tablet
$screen-sm: 768px !default;
// Medium screen / desktop
$screen-md: 992px !default;
// Large screen / wide desktop
$screen-lg: 1560px !default;

.nav-tabs .nav-link.active-tab-cu {
  color: #007bff !important;
}
.nav-tabs .nav-link  {
  color: black !important;
}
:root {
    --headerTitle: #ffffff;
    --subTitle: #d7d7d8;
    --backgroundMain: #2c3e50;
    --cardBorder: #005fbe;
    --cardBackground: #282d38;
}

.home {
    display: block;
    margin: auto;
    background-color: rgb(40, 45, 56);
}

.row {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
}

.row.playRow>* {
    width: unset;
}

.defaultRow {
    margin: 0 3% 0 3%;
}

.stickyTop {
    position: sticky;
    position: -webkit-sticky;
    z-index: 1;
    top: 0;
}

.overlay {
    width: 100%;
    z-index: 9;
    margin: 0;
    background-color: var(--headerTitle);
    opacity: 0.7;
    color: var(--headerTitle);
}

.statusBgd {
    background-color: #28a745;
}

.statusRow {
    margin-bottom: 0;
    justify-content: center;
}

.devOffline {
    background-color: #dee8fd40;
}

.blink-bg {
    padding: 10px;
    display: inline-block;
    border-radius: 5px;
}

.blink-yellow {
    // animation: blinkYellow 4s infinite;
    background-color: #ddce00;
}

.blink-red {
    // animation: blinkRed 4s infinite;
    background-color: #800101;
}

.blink-green {
    // animation: blinkGreen 4s infinite;
    background-color: #018001;
}

@keyframes blinkGreen {
    0% {
        background-color: #018001;
    }

    60% {
        background-color: #018001e5;
    }

    70% {
        background-color: #018001c5;
    }

    80% {
        background-color: #01800173;
    }

    90% {
        background-color: #01800141;
    }

    100% {
        background-color: #01800121;
    }
}

@keyframes blinkRed {
    0% {
        background-color: #800101;
    }

    70% {
        background-color: #800101c5;
    }

    80% {
        background-color: #80010165;
    }

    90% {
        background-color: #80010128;
    }

    100% {
        background-color: #80010100;
    }
}

@keyframes blinkYellow {
    0% {
        background-color: #ddce00;
    }

    70% {
        background-color: #ddce00c9;
    }

    80% {
        background-color: #ddce0088;
    }

    90% {
        background-color: #ddce0054;
    }

    100% {
        background-color: #ddce0000;
    }
}

.statusLabel {
    color: #d7d7d8;
    margin: 0;
}

.statusVal {
    font-size: 1rem;
    margin-left: 2%;
    color: #d7d7d8;
}

.statusText {
    margin-bottom: 2px;
}

.cust-col {
    padding: 0;
}

.editUnit {
    min-width: 150px;
    margin: 0 0 5px 0;
    display: flex;
}

.unitText {
    display: inline-block;
    color: black;
    padding: 5px;
    margin-bottom: 0;
}

.paramText {
    color: black;
    margin: auto;
}

.deg-switch {
    display: inline-block;
    color: rgb(6, 78, 161);
    padding: 0 0 0 8px;
    margin-left: 5px;
}

.util-tools {
    color: #d7d7d8;
    height: 30px;
    width: 30px;
    margin: 5px;
}

.bi.util-tools {
    width: 30px;
    height: 30px;
}

/* Debug Panel Styles */
.debug-panel-body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.debug-log-item {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
}

.debug-log-item:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.debug-log-type {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
}

.debug-log-timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
}

.debug-log-details {
    font-size: 13px;
    color: #495057;
    line-height: 1.4;
}

.debug-log-response {
    font-size: 11px;
    background-color: #f8f9fa;
    color: #495057;
    padding: 8px;
    border-radius: 4px;
    margin-top: 4px;
    border: 1px solid #dee2e6;
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.util-opts {
    display: flex;
    float: right;
}

.form-check-label {
    color: #d7d7d8;
    margin-left: 5px;
}

.util-text {
    color: #d7d7d8;
    display: flex;
    float: left;
    margin: 5px auto 5px 5px;
}

.play-text {
    color: #d7d7d8;
}

.playRow {
    width: 100%;
    justify-content: space-around;
    margin-left: auto;
    margin-right: auto;
}

.playgroundHeader {
    text-align: center;
    font-family: sans-serif;
    margin-bottom: 0;
    margin-left: 10px;
    padding-left: 10px;
    color: #ffffff;
}

.playgroundText {
    color: #d7d7d8;
    display: flex;
    // padding: 0;
    margin-bottom: 3px;
}

.playgroundInput {
    max-width: 100px;
    min-width: 60px;
    max-height: 30px;
}

.playgroundCard {
    display: block;
    border-top: 3px solid rgb(42, 59, 94);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.19);
    margin: 5px;
    padding: 5px;
    // min-height: 74px;
    // max-height: 300px;
    background-color: #313846;
}

.playgroundChart {
    height: 450px;
    width: 100%;
    position: relative;
}

.exprt-form {
    display: block;
    min-height: 50px;
    min-width: 200px;
    max-width: 400px;
    margin-left: 10px;
}

.util-sub-head {
    display: flex;
    color: #d7d7d8;
    font-size: 14px;
    align-items: flex-end;
}

.util-p {
    display: block;
    min-width: 80px;
}

.btn {
    background-color: rgb(50, 59, 77);
    border: none;
}

.img {
    min-width: 70px;
}

.deviceActiveImg {
    width: 40px;
}

#batt {
    margin-left: 20px;
}

#battPercent {
    :hover {
        display: show;
    }
}

#mapBox {
    display: block;
    height: 94%;
    min-height: 250px;

    #device {
        display: block;
        float: left;
        color: white;
        margin-left: 5px;
    }

    #gps {
        display: block;
        float: left;
        clear: both;
        width: 100%;
        margin: auto;
        color: white;
        font-size: 16px;
        height: min-content;

        span {
            display: block;
            float: right;
            clear: none;
            width: 100%;
            color: #d7d7d8;
            text-align: center;
        }
    }
}

#weatherBox {
    display: block;
    min-height: 250px;

    .Weather {
        display: block;
    }
}

#doughnut {
    padding: 0;
}

.lineChart {
    height: 300px;
    width: 100%;
    position: relative;
}

.card {
    display: block;
    border-top: 3px solid rgb(42, 59, 94);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.19);
    margin: 0px;
    padding: 5px;
    // min-height: 74px;
    // max-height: 300px;
    border-top: solid 2px rgb(6, 78, 161);
    background-color: rgb(50, 59, 77);

    &.doughnut-chart {
        overflow: hidden;
    }

    .device-title {
        font-size: 14px;
        color: #d7d7d8;
        padding: 5px;
        text-align: center;

        .text {
            color: black;
        }
    }

    .title {
        display: block;
        float: left;
        margin-bottom: 6%;
        font-size: 14px;
        color: #d7d7d8;

        .text {
            color: black;
        }
    }
}

.chart-value {
    text-align: center;
    font-size: 15px;
    color: white;
    max-width: 100px;
    line-height: 22px;
    margin: auto;
    margin-top: -40px;
    // margin-bottom: 40px;
}

.battStatImg {
    max-width: 60px;
    margin-left: 20%;
    margin-right: 10%;
    // margin-top: 5px;
}

.alert-icon {
    position: absolute;
    top: 3px;
    right: 3px;
    cursor: pointer;
    font-size: 20px;
    color: #9698a2;
}

.btn-group {
    display: flex;

    .btn-content {
        flex: 1;
    }
}

.card .dropdown-menu.show {
    --bs-dropdown-bg: rgba(255, 0, 0, 0.0);
}

#dropdown-1 {
    display: flex;
    flex-wrap: wrap;
    color: white;
    min-width: 200px;

    ul {
        background-color: rgba(40, 45, 56, 0);
        border: solid 1px rgba(40, 45, 56, 0);
        border-radius: 5px;
        width: 100%;
        margin-left: -10px;

        li {
            li:first-child {
                margin-top: -30px;
            }

            border: solid 2px rgb(40, 45, 56);
            border-radius: 5px;
            color: white;
            text-align: left;

            img {
                margin-bottom: 5px;
                padding-right: 20px;
                margin-left: -30px;
            }
        }
    }
}

#dropdown-start {
    display: flex;
    // max-width: 600px;
    width: 300px;
    // width: 30%;
    margin: auto;
    margin-top: 70px;
    padding-bottom: 350px;

    ul {
        background-color: rgb(40, 45, 56);
        border: rgb(40, 45, 56);
        width: 100%;

        li {
            li:first-child {
                margin-top: -10px;
            }

            color: white;
            font-size: 1.1rem;
            text-align: left;
            margin-bottom: 7px;

            img {
                margin-bottom: 5px;
                padding-right: 20px;
            }
        }
    }
}

.dropdown-item {
    color: white;
    width: 100%;
}

.btn-dark:hover {
    background-color: white;
    color: black;
}

.sigStatImg {
    max-width: 50px;
    margin-left: 15%;
    margin-right: 10%;
}

.calendarBtn {
    .btn {
        background-color: #f3f3f5;
        border-width: 0;
    }
}

@media (max-width: ($screen-xs - 1)) {
    .title {
        font-size: 12px;
    }

    .chart-value {
        font-size: 10px;
        max-width: 60px;
        margin-top: -30px;
        line-height: inherit;
    }

    .refresh {
        margin-left: 45%;
    }
}

@media (max-width: ($screen-sm - 1)) {
    .playrow {
        width: 100%;
    }

    .col-12 {
        margin-top: 2px;
        margin-bottom: 2px;
    }

    #dropdown-menu {
        font-size: 1.2rem;
    }

    .welcome {
        display: none;
    }

    .time {
        margin-left: auto;
    }

    .defaultRow {
        margin: 5px 3% 5px 3%;
        // flex-direction: column;
        // flex-grow: 1;
    }

    #device {
        // font-size: 1.5rem;
        margin: 0;
    }

    .customChartButton {
        // font-size: 1.1rem;
        width: 60%;
        min-height: 45px;
    }

    #mapBox {
        min-height: 400px;
        margin-bottom: 1%;
    }

    #doughnut {
        // padding: 1% 2%;
        margin-bottom: 10px;
    }

    .title {
        font-size: 12px;
    }

    .chartjs-render-monitor {
        max-height: 400px;
    }
}

@media (min-width: $screen-sm) {
    .card {
        margin: 8px;

        .title {
            font-size: 14px;
            padding: 0 15px;
            text-align: center;
        }
    }
}

@media (min-width: $screen-lg) {
    #dropdown-1 {
        display: flex;
    }
}

.customChartButton {
    width: unset;
    color: #fff;
    border-radius: 0.25rem;
    line-height: 1.5;
    font-weight: 400;
    font-size: 18px;
}

.custom-switch {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: 16px;
    color: white;
    position: absolute;
    left: 10px;

    p {
        margin-right: 15px;
    }
}

/* Export modal styling for better contrast */
.export-modal .modal-body {
    color: #333 !important;
}

.export-modal .util-p {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
}

/* More specific selectors for b-form-checkbox */
.export-modal .modal-body .custom-control-label {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 15px !important;
}

.export-modal .modal-body .custom-checkbox .custom-control-label {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    padding-left: 1.75rem !important;
    margin-bottom: 0.5rem !important;
    line-height: 1.5 !important;
}

.export-modal .modal-body .form-check-label {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 15px !important;
}

.export-modal .modal-body .custom-checkbox .custom-control-label::before {
    border-color: #007bff !important;
    border-width: 2px !important;
}

.export-modal .modal-body .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #007bff !important;
}

.export-modal .modal-body .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff !important;
    border-color: #007bff !important;
}

.export-modal .modal-body .custom-checkbox {
    margin-bottom: 0.75rem !important;
}

/* Additional Bootstrap Vue specific selectors */
.export-modal .modal-body .b-form-checkbox .custom-control-label {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 15px !important;
}

.export-modal .modal-body .form-check .form-check-label {
    color: #333 !important;
    font-weight: 600 !important;
    font-size: 15px !important;
}
#doughnutBox{
  height: calc(100% - 16px);
}
</style>

<script lang="ts">
import router from "../router";
import { deviceRoot } from "../vue-client";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import SlotMap from "../components/SlotMap.vue";
import SensorGauges from "../components/SensorGauges.vue";
import LineChart from "../components/LineChart.vue";
import WeatherWidget from "../components/WeatherWidget.vue";
import SlotNote from "../components/SlotNote.vue";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import tz from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { calibrateHistory } from "../utilities/scaleHistory";
import "pretty-checkbox/dist/pretty-checkbox.min.css";
import LinePlugin from "../plugins/LinePlugin";
import { useAuthStore } from "../stores/authStore";
import { useSlotStore } from "../stores/slotStore";
import { usePreferenceStore } from "../stores/preferenceStore";
import { useDurationStore } from "../stores/durationStore";
import {
    fromSlotsToSummaries,
    removeDuplicates,
    getDefaultOptions,
    getLineChartColor,
    getReportMinMax,
    getAxesMinMaxStep,
    featureEnabled
} from "../utilities/slotUtilities";
import { storeToRefs } from "pinia";
import { getImage } from "../utilities/annotationImages";
import { callAwakeFunction } from "../utilities/awakeUtilities";
import { calibrationCallFunction, pingDevice, callCalibarationAwakeFunction } from "../utilities/calibrationUtilities";
import TimeSeriesPlots from "../components/timeSeriesPlots.vue";
import TrackerTracesPlots from "../components/trackerTracesPlots.vue";
import TrackerTracesGauges from "../components/trackerTracesGauges.vue";
import { ExportUtility } from "../utilities/exportUtility.js";
import { dataReadingTestSuite, performanceMonitor } from "../utilities/dataReadingTestUtilities";
import {
  queryExclusionDataList,
  submitExclusionData,
  deleteExclusionData,
  updateExclusionOff,
  filterExclusionData,
  updateSpikeRemovalThreshold
} from "../utilities/exclusionUtilities"


dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(customParseFormat);

export default {
    components: {
        LineChart,
        SensorGauges,
        WeatherWidget,
        VueSlider,
        Header,
        Footer,
        // Cal,
        Loading,
        SlotMap,
        SlotNote,
        TimeSeriesPlots,
        TrackerTracesPlots,
        TrackerTracesGauges
    },
    setup() {
        const authStore = useAuthStore();
        if (!authStore.authUser) {
            router.push({ name: "signIn" });
        }
    },
    data() {
        return {
            trackerTracesPlot: null,
            trackerTracesGauges: null,
            outDat: null,
            addDeviceModal: false,
            timeSeriesNames: [],
            usersSelected: [],
            newDeviceName: "",
            newDeviceId: "",
            slotName: "",
            newSlotName: "",
            device: null,
            loaded: false,
            battery: 0,
            signal: 0,
            isART: false,
            window_open: false,
            hover: false,
            infoWindow: { lat: 0, lng: 0 },
            gmapName: "",
            gmapId: "",
            initDashboardMap: 5,
            isLoading: false,
            isStartLoading: true,
            quickLoadStart: false,
            fullPage: false,
            loaderBgnd: "rgb(50, 59, 77)",
            loaderType: "spinner",
            loaderOpacity: 0.75,
            loaderColor: "#ffffff",
            loaderHeight: 60,
            loaderWidth: 60,
            slotId: "",
            devAlerts: [],
            trendlineProperties: this.resetTrendline(),
            lastHeard: "",
            // deviceActive:true,
            deg: false,
            account: null,
            componentKey: 0,
            keyPCStatChart: 0,
            keyCAStatChart: 0,
            keyTUStatChart: 0,
            keyATStatChart: 0,
            keyWTStatChart: 0,
            keyLIStatChart: 0,
            keyCaPc: 0,
            keyWaterTemp: 0,
            keyBatSig: 0,
            keyTurb: 0,
            keyLight: 0,
            keyWaterTempTrend: 0,
            keyTurbTrend: 0,
            keyWaterTempStatChart: 0,
            keyAirTempStatChart: 0,
            keyCustom: 0,
            utI: 0,
            liI: 1,
            atI: 2,
            wtI: 3,
            tuI: 4,
            pcI: 5,
            caI: 6,
            wlI: 7,
            btI: 8,
            laI: 9,
            loI: 10,
            bvI: 11,
            bsI: 12,
            ssI: 13,
            sqI: 14,
            cvI: 15,
            pvI: 16,
            ldI: 17,
            wsI: 18,
            piI: 19,
            deviceLat: 360,
            deviceLong: 360,
            inLongLat: false,
            deviceInWater: false,
            gpsLastUpdate: "GPS last update is unknown",
            smoothPlot: false,
            rawPlot: false,
            spikeRemovalFlag: false,
            fieldCalPlot: false,
            calPlotError: "",
            showCA: true,
            showPC: true,
            unitF: false,
            turbidityTrend: true,
            waterTrend: true,
            batHover: false,
            sigHover: false,
            exportModal: false,
            selectChartDatesModal: false,
            selectUnitsModal: false,
            createChartModal: false,
            chartPropertiesModal: false,
            adminSettingsModal: false,
            fieldCalModal: false,
            dataReadingModal: false,
            dataReadingStep: 'preparation', // 'preparation' or 'reading'
            isDataReadingReady: false,
            currentDataReadingAttempt: 0,
            maxDataReadingAttempt: 720,
            isWaitingForData: false,
            dataReadingSuccess: false,
            dataReadingError: null,
            lastDataTime: null,
            dataReadingCanceled: false,
            // Timer management for data reading
            pingRetryInterval: null,
            dataCheckInterval: null,
            dataCheckTimeout: null,
            // Debug panel for testing
            showDebugPanel: false,
            debugLogs: [],
            mockMode: false,
            isRunningTest: false,
            testSuiteInstance: null,
            eventModal: false,
            calDate: null,
            calTime: null,
            calSensor: null,
            calSensorOptions: [
                { value: null, text: "Please Select Sensor" },
                { value: "phycocyanin", text: "Phycocyanin" },
                { value: "chlorA", text: "Chlorophyll-a" },
            ],
            fieldSample: null,
            calVal: null,
            calChartData: {},
            calChartOptions: {},
            verCalChart: false,
            calError: null,
            setCalTime: null,
            keyCalChart: 0,
            calSuccess: null,
            deviceOffline: false,
            annotationId: 0,
            //
            axesOpts: [
                { value: "left", text: "Left Axis" },
                { value: "right", text: "Right Axis" },
            ],
            sensorsSelected: [
                { sensor: "phycocyanin", axis: "left", selected: true, text: "Phycocyanin (PC)", feature: 'phycocyanin' },
                { sensor: "chlorA", axis: "left", selected: false, text: "Chlorophyll (CA)", feature: 'chlorA' },
                { sensor: "waterTemp", axis: "left", selected: false, text: "Water Temp.", feature: 'waterTemp' },
                { sensor: "ph", axis: "left", selected: false, text: "PH", feature: 'ph' },
                { sensor: "do", axis: "left", selected: false, text: "DO", feature: 'do' },
                { sensor: "ps", axis: "left", selected: false, text: "PS", feature: 'ps' },
                { sensor: "turbidity", axis: "left", selected: false, text: "Turbidity (TU)", feature: 'turbidity' },
                { sensor: "light", axis: "left", selected: true, text: "Solar Light", feature: 'light' },
                { sensor: "battSOC", axis: "left", selected: false, text: "Battery", feature: 'battSOC' },
                { sensor: "sigStrength", axis: "left", selected: false, text: "Signal", feature: 'sigStrength' },
                { sensor: "panelVolts", axis: "left", selected: false, text: "Solar Panel", feature: 'panelVolts' },
                { sensor: "algaeRatio", axis: "left", selected: false, text: "Algae Ratio", feature: 'algaeRatio' },
                { sensor: "dayAvgPC", axis: "left", selected: false, text: "PC Daily Average", feature: 'phycocyanin' },
                { sensor: "dayAvgCA", axis: "left", selected: false, text: "CA Daily Average", feature: 'chlorA' },
                { sensor: "dayAvgTU", axis: "left", selected: false, text: "TU Daily Average", feature: 'turbidity' },
                { sensor: "windSpeed", axis: "left", selected: false, text: "Wind Speed", feature: 'windSpeed' },
                { sensor: "precipitationIntensity", axis: "left", selected: false, text: "Precipitation", feature: 'precipitationIntensity' },
            ],
            customChart: [],
            showCustomChart: false,
            eventTable: [],
            eventFields: [
                { key: "date", label: "Date", sortable: true },
                { key: "event_type", label: "Event Type", sortable: true },
                { key: "delete_event", label: "Delete Event", sortabe: true },
            ],
            eventSelect: [],
            newEventSelected: null,
            newEventDateTime: null, newEventOptions: [
                { value: null, text: "Please select an option" },
                { value: "Treatment", text: "Treatment" },
                { value: "Rain", text: "Rain" },
                { value: "Custom", text: "Custom" }
            ],
            addEventError: null,
            eventSort: "date",
            eventPerPage: 5,
            eventCurrentPage: 1,
            startDate: null,
            endDate: null,
            alertEditModal: false,
            lowPermAlertEditModal: false,
            editChartData: {},
            editChartDataRangeValue: [0, 100],
            alertRangeSliderInterval: 0.001,
            alertRangeSliderMin: 0,
            alertRangeSliderMax: 100,
            alertMarks: [0, 100],
            datByCol: [],
            statCharts: [],
            reportLabels: [],
            turbTrendChart: null,
            waterTrendChart: null,
            algaeTimeReportsChart: null,
            waterTempLineChart: null,
            phLineChart: null,
            doLineChart: null,
            psLineChart: null,
            turbidityLineChart: null,
            batteryAndSingalReportsChart: null,
            battPVChart: null,
            signalAndPanelTimeReportsChart: null,
            ssLiChart: null,
            newDataArray: [],
            selectedReportId: null,
            doughnutOptions: {
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 2.5,
                circumference: 180,
                rotation: -90,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                },
                borderWidth: 2
            },
            algaeLineChartOptions: null,
            battPVOptions: null,
            waterTempOptions: null,
            sigStrengthSolarOptions: null,
            turbidityOptions: null,
            customChartOptions: null,
            mapOptions: {
                // zoomControl: false,
                // scaleControl: false,
                // disableDefaultUI: true,
                // gestureHandling: "auto"//allow users to pan the map
                gestureHandling: "cooperative",
            },
            sensorGauges: [
                {
                    name: "light",
                    displayName: "Solar Light",
                    units: "uMoles\nm²/sec",
                    maxValue: 2000,
                    minValue: 0,
                },
                {
                    name: "airTemp",
                    displayName: "Air Temperature",
                    units: "\u00B0 C",
                    maxValue: 40,
                    minValue: 0,
                },
                {
                    name: "waterTemp",
                    displayName: "Water Temperature",
                    units: "\u00B0 C",
                    maxValue: 40,
                    minValue: 0,
                },
                {
                    name: "turbidity",
                    displayName: "Turbidity",
                    units: "NTU",
                    maxValue: 400,
                    minValue: 0,
                },
                {
                    name: "phycocyanin",
                    displayName: "Phycocyanin",
                    units: "RFU",
                    maxValue: 1500,
                    minValue: 0,
                },
                {
                    name: "chlorA",
                    displayName: "Chlorophyll",
                    units: "RFU",
                    maxValue: 3000,
                    minValue: 0,
                }
            ],
            caTrendData: [],
            pcTrendData: [],
            pcAvgNightNPQ: [],
            caAvgNightNPQ: [],
            pcNPQTrendData: [],
            caNPQTrendData: [],
            turbCompData: [],
            pcTempCompData: [],
            showPlaygroundChart: false,
            playgroundChart: null,
            playgroundChartOptions: null,
            keyPlayground: 0,
            // playground data
            playPC: false,
            playCA: false,
            playTU: true,
            playBS: false,
            playPV: false,
            playSL: false,
            playWT: true,
            playSS: false,
            playPCTrend: false,
            playCATrend: false,
            playPCNPQ: false,
            playCANPQ: false,
            playPCNightAvg: false,
            playCANightAvg: false,
            playTUTrend: true,
            playPCTempComp: false,
            playPCAvg: false,
            playCAAvg: false,
            playTUAvg: false,
            playWTTrend: false,
            playLD: false,
            // axis data
            playPCAx: false,
            playCAAx: false,
            playTUAx: true,
            playBSAx: false,
            playPVAx: false,
            playSLAx: false,
            playWTAx: false,
            playSSAx: false,
            playLDAx: true,
            unitPlayTemp: true, //false when F
            fixOk: 0,
            customEventText: '', // 存储自定义事件文本
            rfuSwitchUgL: false,
            isShowSwitchAlert: false,
            rowTooltip: null,
            defaultUnitValue: {
                uglToRfuProperties: {
                    pcValue: 35.0,
                    caValue: 20.0,
                    pcMaxValue: 175,
                    caMaxValue: 100,
                }
            },
            timeSeriesData: new Map(), // 存储从子组件接收的数据
            qualityModel:false,// Quality Control Model
            exclusionData:{
              on:true,
              fields: [
                { key: "startTime", label: "Start Time", sortable: true },
                { key: "endTime", label: "End Time", sortable: true },
                { key: "delete_data", label: "Delete Data", sortable: true },
              ],
              dataProperty:[],
              sort:'startTime',
              currentPage:1,
              perpage:5,
              rows:0,
              startDateTime:null,
              endDateTime:null,
              showTips:false,//是否提示内容
              tips:'end time must be greater than start time'
            },
          spikeRemovalData:{
            editDataValue:3,
            min:0,
            max:50,
            value:3
          },
          exportDetail: true,
          exportTrend: false,
          exportSpikeRemoval: false,
          exportDataExclusion: false,
        };
    },
    async created() {
        await this.initDat();
        this.$watch(() => this.$route.params,
            async () => {
                await this.initDat();
            })
    },
    beforeDestroy: function () {
        // Clear data reading timers
        if (this.pingRetryInterval) {
            clearInterval(this.pingRetryInterval);
            this.pingRetryInterval = null;
        }
        if (this.dataCheckInterval) {
            clearInterval(this.dataCheckInterval);
            this.dataCheckInterval = null;
        }
        if (this.dataCheckTimeout) {
            clearTimeout(this.dataCheckTimeout);
            this.dataCheckTimeout = null;
        }
        
        this.device = null;
        this.loaded = false;
        this.datByCol = [];
        this.statCharts = [];
        this.algaeTimeReportsChart = null;
        this.batteryAndSingalReportsChart = null;
        this.battPVChart = null;
        this.signalAndPanelTimeReportsChart = null;
    },
    computed: {
        isLoggedIn: {
            get: function () {
                const authStore = useAuthStore();
                return authStore.authUser !== null;
            }
        },
        isViewerOnly: {
            get: function () {
                const authStore = useAuthStore();
                return authStore.authUser.role === 'user';
            }
        },

        SLOTS: function () {
            const slotStore = useSlotStore();
            return slotStore.slots;
        },
        deviceInWaterProperty: {
            get: function () {
                return this.deviceInWater;
            },
            set: function (val) {
                this.deviceInWater = val;
                // Make REST API call to save the data
                const slotStore = useSlotStore();
                slotStore.updateSlot(this.device._id, { inWater: this.deviceInWater }); // Don't wait
                const slotSummary = this.outDat.find(item => item.id === this.device._id);
                if (slotSummary) {
                    slotSummary.inWater = this.deviceInWater;
                }
            }
        },
        startDateProperty: { // Converting from DateTime to Date
            get: function () {
                let timestamp;
                if (typeof this.startDate === 'number') {
                    timestamp = this.startDate
                } else {
                    timestamp = Date.parse(this.startDate)
                }
                return dayjs(timestamp + 48 * 3600 * 1000).format('YYYY-MM-DD');
            },
            set: function (val) {
                this.startDate = dayjs(val).format();
                const durationStore = useDurationStore();
                const jsDate = dayjs(this.startDate).toDate();
                let timestamp = jsDate.valueOf() - 48 * 3600 * 1000
                durationStore.updateStartDateTime(timestamp);
            }
        },
        endDateProperty: { // Converting from DateTime to Date
            get: function () {
                return dayjs(this.endDate).format('YYYY-MM-DD');
            },
            set: function (val) {
                this.endDate = dayjs(val).hour(23).minute(59).second(59).format();
                const durationStore = useDurationStore();
                const jsDate = dayjs(this.endDate).toDate();
                durationStore.updateEndDateTime(jsDate);
            }
        },
        awakedMessage: function () {
            return "Wake Up Device";
        },
        eventRows() {
            return this.eventTable.length;
        },
        eventsProperty: {
            get: function () {
                const timeZone = dayjs.tz.guess();
                const events = [];
                for (let i = 0; i < this.eventTable.length; i++) {
                    const event = this.eventTable[i];
                    events.push({
                        id: event._id,
                        date: dayjs.utc(event.start_date).tz(timeZone)
                            .format("M/DD/YY h:mm a"),
                        event_type: event.name,
                        delete_event: false,
                        description: event.description || ''
                    });
                }

                return events;
            }
        },
        exclusionProperty: {
          get: function () {
            const timeZone = dayjs.tz.guess();
            const list = [];
            for (let i = 0; i < this.exclusionData.dataProperty.length; i++) {
              const data = this.exclusionData.dataProperty[i];
              list.push({
                id: data._id,
                startTime: dayjs.utc(data.start_date).tz(timeZone)
                    .format("M/DD/YY h:mm a"),
                endTime: dayjs.utc(data.end_date).tz(timeZone)
                    .format("M/DD/YY h:mm a"),
                delete_data: false,
              });
            }
            return list;
          }
        },
        isART() {
            const authStore = useAuthStore();
            return authStore.isArt;
        },
        preparationMessage() {
            if (this.isDataReadingReady) {
                return "Device is ready. Click next to start data reading";
            } else {
                let instruction = "Power cycle the Tracker and wait for connection confirmation ";
                if (this.currentDataReadingAttempt > 0 && this.currentDataReadingAttempt < this.maxDataReadingAttempt) {
                    instruction += `(${this.currentDataReadingAttempt}/${this.maxDataReadingAttempt})`;
                }
                if (this.currentDataReadingAttempt >= this.maxDataReadingAttempt) {
                    instruction = "Still unable to connect to the device";
                }
                return instruction;
            }
        },
        dataReadingTitle() {
            const statusCircle = this.isDataReadingReady ? '🟢' : '🔴';
            return `Take data reading ${statusCircle}`;
        },
        formattedLastHeard() {
            if (!this.lastHeard) return ''; // Avoid errors if lastHeard is unset

            // Slice off the trailing ' am' or ' pm' (last 3 characters, including space)
            const trimmed = this.lastHeard.slice(0, -3);

            // Parse the trimmed string into a Day.js object using the custom format
            const last = dayjs(trimmed, 'YYYY-MM-DD HH:mm:ss', true); // true enables strict parsing

            if (!last.isValid()) return ''; // Fallback if parsing still fails
            return last.format('YYYY-MM-DD HH:mm:ss') + ' ' + (last.hour() < 12 ? 'am' : 'pm');
        },
        predictedNextReading() {
            if (!this.lastHeard) return ''; // Avoid errors if lastHeard is unset

            // Slice off the trailing ' am' or ' pm' (last 3 characters, including space)
            const trimmed = this.lastHeard.slice(0, -3);

            // Parse the trimmed string into a Day.js object using the custom format
            const last = dayjs(trimmed, 'YYYY-MM-DD HH:mm:ss', true); // true enables strict parsing

            if (!last.isValid()) return ''; // Fallback if parsing still fails

            // Add 2 hours and 30 minutes
            const next = last.add(2, 'hour');

            // Format back to match the original style (YYYY-MM-DD HH:mm:ss am/pm), keeping 24-hour HH
            return next.format('YYYY-MM-DD HH:mm:ss') + ' ' + (next.hour() < 12 ? 'am' : 'pm');
        }
    },
    // ** function calls
    methods: {
        goHome() {
            router.push({ name: `summary` });
        },
        goCompensated() {
            router.push({ name: `compensatedSlot`, params: { id: this.device._id } });
        },
        openTestingGuide() {
            // Open the testing guide in a new tab
            const guideUrl = window.location.origin + '/docs/DataReadingTestingGuide.md';
            window.open(guideUrl, '_blank');
        },
        goCalibration() {
            const feature = this.device.feature;

            if (feature === 2) {
            const userChoice = confirm('Click OK to calibrate the Dissolved Oxygen Sensor, or Cancel to calibrate the Chlorophyll, Phycocyanin, and Turbidity sensors.');
            const featureId = userChoice ? '2' : '0';
            this.$router.push({
                name: 'calibration',
                params: {
                id: this.device._id,
                featureId
                }
            });
            } else if (feature === 3) {
            const userChoice = confirm('Click OK to calibrate the pH Sensor, or Cancel to calibrate the Chlorophyll, Phycocyanin, and Turbidity sensors.');
            const featureId = userChoice ? '3' : '0';
            this.$router.push({
                name: 'calibration',
                params: {
                id: this.device._id,
                featureId
                }
            });
            } else {
            this.$router.push({
                name: 'calibration',
                params: {
                id: this.device._id,
                featureId: feature.toString()
                }
            });
            }
        },
        goToManageDevice() {
            router.push({ name: "manageDevice" });
        },
        
                 // Data Reading Methods
         async openDataReadingModal() {
             // Clear any existing timers first
             if (this.pingRetryInterval) {
                 clearInterval(this.pingRetryInterval);
                 this.pingRetryInterval = null;
             }
             if (this.dataCheckInterval) {
                 clearInterval(this.dataCheckInterval);
                 this.dataCheckInterval = null;
             }
             if (this.dataCheckTimeout) {
                 clearTimeout(this.dataCheckTimeout);
                 this.dataCheckTimeout = null;
             }
             
             this.dataReadingModal = true;
             this.dataReadingStep = 'preparation';
             this.isDataReadingReady = false;
             this.currentDataReadingAttempt = 0;
             this.isWaitingForData = false;
             this.dataReadingSuccess = false;
             this.dataReadingError = null;
             this.dataReadingCanceled = false;

/*
            const slotId = this.device._id;

            const response = await calibrationCallFunction('read', 'setMeasurementPeriod', slotId);
            const measurementPeriodText = response.ok ? 'Success' : await response.text();
            console.log('Set Measurement Period:', measurementPeriodText);

            response = await calibrationCallFunction('read', 'setNumMeasurements', slotId);
            const numberMeasurementsText = response.ok ? 'Success' : await response.text();
            console.log('Set Number of Measurements:', numberMeasurementsText);
*/       
             // Start the preparation process
             await this.startDataReadingPreparation();
         },
        
        async startDataReadingPreparation() {
            // First, awake the device
            try {
                const slotId = this.device._id;
                
                if (this.mockMode) {
                    const mockResponse = this.getMockResponse('calAwakeMins', 60);
                    this.addDebugLog('calAwakeMins (Mock)', `Wake device for 60 minutes`, mockResponse, null, mockResponse.ok);
                    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate delay
                } else {
                    await callCalibarationAwakeFunction(60, slotId); // 60 minutes
                    this.addDebugLog('calAwakeMins', `Device wake-up command sent for 60 minutes`, null, null, true);
                }
                
                // Start pinging
                await this.pingDataReadingDevice();
                if (!this.isDataReadingReady) {
                    this.retryDataReadingPing();
                }
            } catch (error) {
                console.error('Error during preparation:', error);
                this.addDebugLog('Preparation Error', `Failed during preparation`, null, error.message, false);
                this.dataReadingError = 'Error during preparation: ' + error.message;
            }
        },
        
        async pingDataReadingDevice() {
            try {
                const slotId = this.device._id;
                let pingResult;
                
                if (this.mockMode) {
                    pingResult = this.getMockResponse('pingDevice');
                    this.addDebugLog('pingDevice (Mock)', `Checking device readiness`, pingResult, null, true);
                    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate delay
                } else {
                    pingResult = await pingDevice(slotId);
                    this.addDebugLog('pingDevice', `Device ping attempt`, pingResult, null, pingResult.ready);
                }
                
                this.isDataReadingReady = pingResult.ready;
                console.log('Ping result:', pingResult);
            } catch (error) {
                console.error('Ping failed:', error);
                this.addDebugLog('pingDevice Error', `Ping request failed`, null, error.message, false);
                this.isDataReadingReady = false;
            }
        },
        
        async retryDataReadingPing() {
            // Clear any existing ping retry interval
            if (this.pingRetryInterval) {
                clearInterval(this.pingRetryInterval);
                this.pingRetryInterval = null;
            }
            
            this.pingRetryInterval = setInterval(async () => {
                if (this.dataReadingCanceled || this.dataReadingStep !== 'preparation') {
                    clearInterval(this.pingRetryInterval);
                    this.pingRetryInterval = null;
                    return;
                }
                
                this.currentDataReadingAttempt++;
                
                if (this.currentDataReadingAttempt >= this.maxDataReadingAttempt) {
                    clearInterval(this.pingRetryInterval);
                    this.pingRetryInterval = null;
                    return;
                }
                
                await this.pingDataReadingDevice();
                
                if (this.isDataReadingReady) {
                    clearInterval(this.pingRetryInterval);
                    this.pingRetryInterval = null;
                }
            }, 2000); // Every 2 seconds
        },
        
        async takeReading() {
            this.isWaitingForData = true;
            this.dataReadingSuccess = false;
            this.dataReadingError = null;
            
            try {
                // First, record the current last data time
                await this.recordLastDataTime();                
                // Then call the publishTrackerData function
                const slotId = this.device._id;
                let response;
                let sampleTimestamp = Date.now() / 1000; // Current time in seconds

                if (this.mockMode) {
                    response = this.getMockResponse('publishTrackerData', '1');
                    this.addDebugLog('publishTrackerData (Mock)', `Triggering data collection with param "1"`, response, null, response.ok);
                    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate delay
                } else {
                    response = await calibrationCallFunction('1', 'publishTrackerData', slotId);
                    const responseBody = await response.json();

                    const responseText = response.ok ? 'Success' : await response.text();
                    if (response.ok) {
                        sampleTimestamp = responseBody.return_value; // This is the timestamp when the reading was taken          
                    }
                    this.addDebugLog('publishTrackerData', `Data collection request sent`, { 
                        ok: response.ok, 
                        status: response.status,
                        response: responseText 
                    }, null, response.ok);
                }
                
                if (!response.ok) {
                    const errorText = response.response || await response.text();
                    throw new Error(`Data reading request failed: ${errorText}`);
                }
   
                
                this.checkForNewData(sampleTimestamp); // TODO: ensure that newer data (later than publishTrackerData call) is fetched: return timestamp?
                
            } catch (error) {
                console.error('Error taking reading:', error);
                this.addDebugLog('Data Reading Error', `Failed to initiate data collection`, null, error.message, false);
                this.dataReadingError = 'Data reading failed: ' + error.message;
                this.isWaitingForData = false;
            }
        },
        
        async recordLastDataTime() {
            // Find current slot data to get the last data time
            const slotSummary = this.outDat.find(item => item.id === this.device._id);
            if (slotSummary && slotSummary.device_last_publish) {
                this.lastDataTime = slotSummary.device_last_publish;
            } else {
                this.lastDataTime = Date.now() / 1000; // Current timestamp as fallback
            }
        },
        
        async checkForNewData(sampleTimestamp) {
            // Clear any existing data check interval and timeout
            if (this.dataCheckInterval) {
                clearInterval(this.dataCheckInterval);
                this.dataCheckInterval = null;
            }
            if (this.dataCheckTimeout) {
                clearTimeout(this.dataCheckTimeout);
                this.dataCheckTimeout = null;
            }
            
            let checkCount = 0;
            this.dataCheckInterval = setInterval(async () => {
                if (this.dataReadingCanceled) {
                    clearInterval(this.dataCheckInterval);
                    this.dataCheckInterval = null;
                    return;
                }
                
                checkCount++;
                
                try {
                    console.log('Checking for new data...', {
                        lastDataTime: this.lastDataTime,
                        deviceId: this.device._id
                    });
                    
                    if (this.mockMode) {
                        // Mock mode: simulate new data after a few checks
                        if (checkCount >= 3) {
                            const mockData = this.getMockResponse('deviceHistory');
                            this.addDebugLog('Data Check (Mock)', `Mock data detected after ${checkCount} checks`, mockData, null, true);
                            
                            clearInterval(this.dataCheckInterval);
                            this.dataCheckInterval = null;
                            clearTimeout(this.dataCheckTimeout);
                            this.dataCheckTimeout = null;
                            this.isWaitingForData = false;
                            this.dataReadingSuccess = true;
                            await this.getReports(this.device._id);
                            return;
                        } else {
                            this.addDebugLog('Data Check (Mock)', `Check #${checkCount} - No new data yet`, null, null, true);
                        }
                        return;
                    }
                    
                    // Real mode: Re-fetch slot data to check for updates
                    // TODO: modify the current time
                    const slotStore = useSlotStore();
                    await slotStore.fetchSlotSummary(this.device._id);
                    const allSlots = slotStore.slots;
                    
                    // Update outDat
                    const authStore = useAuthStore();
                    let latTmp = [], longTmp = [];
                    this.outDat = await fromSlotsToSummaries(!!authStore.authUser, allSlots, latTmp, longTmp);
                    
                    // Check if data time has been updated
                    const slotSummary = this.outDat.find(item => item.id === this.device._id);
                    const checkDetails = {
                        checkNumber: checkCount,
                        found: !!slotSummary,
                        currentPublishTime: slotSummary?.device_last_publish,
                        lastDataTime: this.lastDataTime,
                        hasNewData: slotSummary?.device_last_publish > this.lastDataTime
                    };
                    
                    console.log('Current slot summary:', checkDetails);
                    this.addDebugLog('Data Check', `Check #${checkCount} - Looking for new data`, checkDetails, null, true);
                    
                    // TODO: compare timestamp
                    if (slotSummary && slotSummary.device_last_publish > this.lastDataTime) {
                        if (slotSummary.device_last_publish >= sampleTimestamp) {
                        console.log('New data detected!');
                        this.addDebugLog('Data Check Success', `New data detected! Data timestamp updated`, {
                            oldTime: this.lastDataTime,
                            newTime: slotSummary.device_last_publish
                        }, null, true);    
                        
                        // New data received!
                        clearInterval(this.dataCheckInterval);
                        this.dataCheckInterval = null;
                        clearTimeout(this.dataCheckTimeout);
                        this.dataCheckTimeout = null;
                        this.isWaitingForData = false;
                        this.dataReadingSuccess = true;

                        // Update time interval
                        this.startDateProperty = new Date((slotSummary?.device_last_publish - import.meta.env.VITE_APP_HoursBack * 3600)*1000)
                        this.endDateProperty = new Date(slotSummary?.device_last_publish *1000)
                        
                        // Refresh the page data
                        await this.getReports(this.device._id);        // Ensure that the new data is at or after the sampleTimestamp
                        } 
                        else {
                            console.log('Data updated but timestamp is older than sample time, continuing to check...');
                        }         
                    }
                } catch (error) {
                    console.error('Error checking for new data:', error);
                    this.addDebugLog('Data Check Error', `Failed to check for new data on attempt #${checkCount}`, null, error.message, false);
                    this.dataReadingError = 'Error checking for new data: ' + error.message;
                }
            }, 5000); // Check every 5 seconds
            
            // Set a timeout to stop checking after 5 minutes
            this.dataCheckTimeout = setTimeout(() => {
                if (this.isWaitingForData) {
                    clearInterval(this.dataCheckInterval);
                    this.dataCheckInterval = null;
                    this.dataCheckTimeout = null;
                    this.isWaitingForData = false;
                    this.addDebugLog('Data Check Timeout', `Data reading timeout after 5 minutes (${checkCount} checks)`, null, 'Timeout reached', false);
                    this.dataReadingError = 'Data reading timeout. Please check device status and try again.';
                }
            }, 300000); // 5 minutes timeout
        },
        
        closeDataReadingModal() {
            // Prevent multiple calls
            if (this.dataReadingCanceled) {
                return;
            }
            
            this.dataReadingCanceled = true;
            
            // Clear all timers immediately
            if (this.pingRetryInterval) {
                clearInterval(this.pingRetryInterval);
                this.pingRetryInterval = null;
            }
            if (this.dataCheckInterval) {
                clearInterval(this.dataCheckInterval);
                this.dataCheckInterval = null;
            }
            if (this.dataCheckTimeout) {
                clearTimeout(this.dataCheckTimeout);
                this.dataCheckTimeout = null;
            }
            
            // Force close modal
            this.dataReadingModal = false;
            
            // Call calibrationCallFunction to turn off stayAwakeMins
            if (this.device && this.device._id) {
                calibrationCallFunction('off', 'stayAwakeMins', this.device._id);
            }
            // Reset all states
            this.dataReadingStep = 'preparation';
            this.isDataReadingReady = false;
            this.currentDataReadingAttempt = 0;
            this.isWaitingForData = false;
            this.dataReadingSuccess = false;
            this.dataReadingError = null;
            this.lastDataTime = null;
        },
        openWindow(dat) {
            this.infoWindow = { lat: parseFloat(dat.latLong.lat), lng: parseFloat(dat.latLong.lng) };
            (this.gmapName = dat.name), (this.gmapId = dat.id), (this.window_open = true);
            // console.log(this.infoWindow);
        },
        featureEnabled(feature) {
            if (!this.device) {
                return true;
            }

            return featureEnabled(this.device, feature);
        },
        refreshPreference() {
            const preferenceStore = usePreferenceStore();
            const { preference } = storeToRefs(preferenceStore);
            this.waterTrend = preference.value.options.waterTrend;
            this.turbidityTrend = preference.value.options.turbidityTrend;
            this.smoothPlot = preference.value.options.smoothPlot;
            this.fieldCalPlot = preference.value.options.fieldCalPlot;
            this.rawPlot = preference.value.options.rawPlot;
            this.spikeRemovalFlag = preference.value.options.spikeRemovalFlag;
            this.unitF = preference.value.options.unitF;
            this.showCustomChart = preference.value.options.showCustomChart;
            this.showPlaygroundChart = preference.value.options.showPlaygroundChart;
            this.showCA = preference.value.options.showCA;
            this.showPC = preference.value.options.showPC;
            this.exclusionData.on = preference.value.options.qualityControlOn;
            this.spikeRemovalData.value = preference.value.options.spikeRemovalThreshold;
            this.spikeRemovalData.editDataValue = this.spikeRemovalData.value;
            
            // Load export options from preferences
            this.exportDetail = preference.value.options.exportDetailDefault ?? true;
            this.exportTrend = preference.value.options.exportTrendDefault ?? false;
            this.exportSpikeRemoval = preference.value.options.exportSpikeRemovalDefault ?? false;
            this.exportDataExclusion = preference.value.options.exportDataExclusionDefault ?? false;

            this.sensorsSelected.find(item => item.sensor === 'phycocyanin').selected = preference.value.options.phycocyaninSelected;
            this.sensorsSelected.find(item => item.sensor === 'chlorA').selected = preference.value.options.chlorASelected;
            this.sensorsSelected.find(item => item.sensor === 'waterTemp').selected = preference.value.options.waterTempSelected;
            this.sensorsSelected.find(item => item.sensor === 'ph').selected = preference.value.options.phSelected;
            this.sensorsSelected.find(item => item.sensor === 'do').selected = preference.value.options.doSelected;
            this.sensorsSelected.find(item => item.sensor === 'ps').selected = preference.value.options.psSelected;
            this.sensorsSelected.find(item => item.sensor === 'turbidity').selected = preference.value.options.turbiditySelected;
            this.sensorsSelected.find(item => item.sensor === 'light').selected = preference.value.options.lightSelected;
            this.sensorsSelected.find(item => item.sensor === 'battSOC').selected = preference.value.options.battSOCSelected;
            this.sensorsSelected.find(item => item.sensor === 'sigStrength').selected = preference.value.options.sigStrengthSelected;
            this.sensorsSelected.find(item => item.sensor === 'panelVolts').selected = preference.value.options.panelVoltsSelected;
            this.sensorsSelected.find(item => item.sensor === 'algaeRatio').selected = preference.value.options.algaeRatioSelected;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgPC').selected = preference.value.options.dayAvgPCSelected;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgCA').selected = preference.value.options.dayAvgCASelected;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgTU').selected = preference.value.options.dayAvgTUSelected;
            this.sensorsSelected.find(item => item.sensor === 'windSpeed').selected = preference.value.options.windSpeedSelected;
            this.sensorsSelected.find(item => item.sensor === 'precipitationIntensity').selected = preference.value.options.precipitationIntensitySelected;


            this.sensorsSelected.find(item => item.sensor === 'phycocyanin').axis = preference.value.options.phycocyaninAxis;
            this.sensorsSelected.find(item => item.sensor === 'chlorA').axis = preference.value.options.chlorAAxis;
            this.sensorsSelected.find(item => item.sensor === 'waterTemp').axis = preference.value.options.waterTempAxis;
            this.sensorsSelected.find(item => item.sensor === 'ph').axis = preference.value.options.phAxis;
            this.sensorsSelected.find(item => item.sensor === 'do').axis = preference.value.options.doAxis;
            this.sensorsSelected.find(item => item.sensor === 'ps').axis = preference.value.options.psAxis;
            this.sensorsSelected.find(item => item.sensor === 'turbidity').axis = preference.value.options.turbidityAxis;
            this.sensorsSelected.find(item => item.sensor === 'light').axis = preference.value.options.lightAxis;
            this.sensorsSelected.find(item => item.sensor === 'battSOC').axis = preference.value.options.battSOCAxis;
            this.sensorsSelected.find(item => item.sensor === 'sigStrength').axis = preference.value.options.sigStrengthAxis;
            this.sensorsSelected.find(item => item.sensor === 'panelVolts').axis = preference.value.options.panelVoltsAxis;
            this.sensorsSelected.find(item => item.sensor === 'algaeRatio').axis = preference.value.options.algaeRatioAxis;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgPC').axis = preference.value.options.dayAvgPCAxis;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgCA').axis = preference.value.options.dayAvgCAAxis;
            this.sensorsSelected.find(item => item.sensor === 'dayAvgTU').axis = preference.value.options.dayAvgTUAxis;
            this.sensorsSelected.find(item => item.sensor === 'windSpeed').axis = preference.value.options.windSpeedAxis;
            this.sensorsSelected.find(item => item.sensor === 'precipitationIntensity').axi = preference.value.options.precipitationIntensityAxis;

            this.deg = this.unitF; // This is the extra one
        },
        async initDat() {
            const authStore = useAuthStore();
            const slotStore = useSlotStore();
            const preferenceStore = usePreferenceStore();
            const durationStore = useDurationStore();
            this.startDate = durationStore.startDateTime;
            this.endDate = durationStore.endDateTime;

            this.isStartLoading = true;
            var allSlots = [];
            try {

                await slotStore.fetchAccountSlots();
                await slotStore.fetchAccountUsers();
                await preferenceStore.fetchPreference();
                await preferenceStore.fetchCompPreference();
                allSlots = slotStore.slots;
            } catch (err) {
                console.log(err);
            }

            let latTmp = [];
            let longTmp = [];
            this.outDat = await fromSlotsToSummaries(!!authStore.authUser, allSlots, latTmp, longTmp);

            if (authStore.authUser) {
                this.refreshPreference();
            } 
            // Set device ID
            const route = this.$route;
            const id = route.params.id; // read parameter id (it is reactive)
            //check device is offline
            const currentIndex = this.outDat.findIndex((x) => x.id == id)
            if (currentIndex < 0) {
              this.isStartLoading = false;
              return
            }
            let online = this.outDat[currentIndex].online;
            if (!online) {
                this.startDateProperty = new Date((this.outDat[currentIndex].device_last_publish - import.meta.env.VITE_APP_HoursBack * 3600)*1000)
                this.endDateProperty = new Date(this.outDat[currentIndex].device_last_publish*1000)
            }

            await this.populateDevice(id);
            this.isStartLoading = false;
        },
        async updateTrendLineProperties() {
            let trendPayload = this.trendlineProperties;
            const slotStore = useSlotStore();
            await Promise.all([
                slotStore.updateSlot(this.device._id, { trendlineProperties: trendPayload }),
            ]);
            await this.getReports(this.device._id);
        },
        async getSlotData() {
            const slotStore = useSlotStore();
            const slotData = slotStore.currentSlot;

            const props = slotData.trendlineProperties;
            if (
                props &&
                props.hasOwnProperty("pcProperties") &&
                props.hasOwnProperty("caProperties") &&
                props.hasOwnProperty("wtProperties") &&
                props.hasOwnProperty("tuProperties") &&
                props.hasOwnProperty("phProperties") &&
                props.hasOwnProperty("doProperties") &&
                props.hasOwnProperty("psProperties")
            ) {
                this.trendlineProperties = slotData.trendlineProperties;
            } else {
                const trendPayload = this.resetTrendline();
                this.trendlineProperties = trendPayload;
                await slotStore.updateSlot(this.device._id, { trendlineProperties: trendPayload });
            }
            if (slotData.deviceAlerts.length < 6) {
                const devAlerts = this.resetAlerts();
                const payload = { deviceAlerts: devAlerts };
                await slotStore.updateSlot(this.device._id, payload);
            }

            return;
            // console.log(this.trendlineProperties);
            // console.log(this.devAlerts);
        },
        async chartProperties() {
            this.deg = this.unitF;
            // Update the store
            const preferenceStore = usePreferenceStore();
            const patchBody = {
                unitF: this.unitF,
                waterTrend: this.waterTrend,
                turbidityTrend: this.turbidityTrend,
                showCustomChart: this.showCustomChart,
                showPlaygroundChart: this.showPlaygroundChart
            }

            await preferenceStore.updatePreference(patchBody);
            await this.getReports(this.device._id);
        },
        async chartCancel() {
            // Repopulate fields
            this.refreshPreference();
        },
        updateAwake: async function () {
            await callAwakeFunction(this.device.wakeRequest, this.device._id);
        },
        validateForm() {
            // convert to unix
            let st = Math.round(new Date(this.startDate).getTime() / 1000);
            let en = Math.round(new Date(this.endDate).getTime() / 1000);
            let timeDiff = en - st;
            if (timeDiff < 0) {
                alert("End Date Must Occur Before Start Date ");
                return false;
            }

            // set time to iso standards
            return true;
        },
        async handleExportOk(bvModalEvt) {
            // Validate at least one data type is selected
            if (!this.exportDetail && !this.exportTrend) {
                bvModalEvt.preventDefault(); // Prevent modal from closing
                return;
            }
            
            // Save export options to preferences
            await this.saveExportPreferences();
            
            // If validation passes, execute export
            this.exportCSV();
        },
        async saveExportPreferences() {
            const preferenceStore = usePreferenceStore();
            const patchBody = {
                exportDetailDefault: this.exportDetail,
                exportTrendDefault: this.exportTrend,
                exportSpikeRemovalDefault: this.exportSpikeRemoval,
                exportDataExclusionDefault: this.exportDataExclusion
            };
            
            await preferenceStore.updatePreference(patchBody);
        },
        async exportCSV() {
            const authStore = useAuthStore();
            const slotStore = useSlotStore();
            let st = dayjs(this.startDate).toISOString();
            let en = dayjs(this.endDate)
                .set("hour", 23)
                .set("minute", 59)
                .toISOString();
            // const timeZone = await this.getTimeZone(this.deviceLat,this.deviceLong);
            const deviceTimeZone = slotStore.deviceTimeZone;
            if (deviceTimeZone.status === "OK") {
                st = dayjs.tz(this.startDate, deviceTimeZone.timeZoneId).toISOString();
                en = dayjs
                    .tz(this.endDate, deviceTimeZone.timeZoneId)
                    .set("hour", 23)
                    .set("minute", 59)
                    .toISOString();
            }

            let dID = this.device._id;

            // Read export options
            const exportOptions = {
                detail: this.exportDetail,
                trend: this.exportTrend,
                spikeRemoval: this.exportSpikeRemoval,
                dataExclusion: this.exportDataExclusion
            };

            const data = { startDate: st, endDate: en };
            let authString = "Bearer " + authStore.authUser.authToken;
            this.isLoading = true;
            //let historyUrl = `${deviceRoot}/devices/${dID}/history/v2`;
            let historyUrl = `${deviceRoot}/slots/${dID}/configuration/history`;
            if (import.meta.env.VITE_APP_Mock === 'true') {
                historyUrl += `?mock=true`;
            }
            const response = await fetch(historyUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
                body: JSON.stringify(data),
            });
            if (response.status !== 200) {
                alert("Error exporting data");
                this.isLoading = false;
                return;
            }

            const hisReport = await response.json();
            // Populate timestamps
            hisReport.forEach((entry) => {
                entry.timestamp = new Date(entry.handshakeTime);
                entry.interpolated = false;
            });

            this.isLoading = false;
            let pubSensors = [
                "timeString",
                "utcTime",
                "light",
                "airTemp",
                "waterTemp",
                "turbidity",
                "phycocyanin",
                "chlorA",
                "waterLight",
                "buoyTemp",
                "latitude",
                "longitude",
                "battVolts",
                "battSOC",
                "sigStrength",
                "sigQuality",
                "codeVersion",
                "panelVolts",
                "leakDetect",
                'ph',
                'do',
                'ps',
                'fixOk'
            ];

            // Filter sensors based on user selection
            if (exportOptions.trend) {
                // Add trend sensors in TU, PC, CA order
                pubSensors.push("turbidityTrend", "phycocyaninTrend", "chlorATrend");
            }

            // If only Trend is selected, remove Detail data
            if (exportOptions.trend && !exportOptions.detail) {
                const detailSensors = ["phycocyanin", "chlorA", "turbidity"];
                pubSensors = pubSensors.filter(sensor => !detailSensors.includes(sensor));
            }

            // If only Detail is selected, remove Trend data
            if (exportOptions.detail && !exportOptions.trend) {
                const trendSensors = ["turbidityTrend", "phycocyaninTrend", "chlorATrend"];
                pubSensors = pubSensors.filter(sensor => !trendSensors.includes(sensor));
            }

            // Filter out the sensors that are not selected
            pubSensors = pubSensors.filter((sensorName) => {
                return this.featureEnabled(sensorName)
            });

            // Apply Spike Removal and Data Exclusion processing
            let processedHisReport = [...hisReport];
            if (exportOptions.spikeRemoval || exportOptions.dataExclusion) {
                processedHisReport = await this.applyDataProcessing(hisReport, exportOptions);
            }

            // Ensure trendlineProperties exists
            const trendlineProperties = this.device.trendlineProperties || this.resetTrendline();
            
            var str = ExportUtility.exportToCsv(processedHisReport, pubSensors, deviceTimeZone, trendlineProperties);
            if (str.length == 0) {
                alert("No data between " + this.startDate + " and " + this.endDate);
                return;
            }
            else {
                let optionsStr = [];
                if (exportOptions.detail && exportOptions.trend) {
                    optionsStr.push("Detail+Trend");
                } else if (exportOptions.detail) {
                    optionsStr.push("Detail");
                } else if (exportOptions.trend) {
                    optionsStr.push("Trend");
                }
                
                if (exportOptions.spikeRemoval) optionsStr.push("SpikeRemoval");
                if (exportOptions.dataExclusion) optionsStr.push("DataExclusion");
                
                let outDat = "data:text/csv;charset=utf-8," + encodeURI(str);
                let fileName = this.startDate + " to " + this.endDate + ", " + this.device.name;
                if (optionsStr.length > 0) {
                    fileName += " (" + optionsStr.join("+") + ")";
                }
                fileName += ".csv";
                let link = document.createElement("a");
                link.href = outDat;
                link.target = "_blank";
                link.download = fileName;
                link.click();
            }

        },
        async caPcChart(saveFlag) {
            if (saveFlag) {
                // Save preferences
                const preferenceStore = usePreferenceStore();
                const patchBody = {
                    rawPlot: this.rawPlot,
                    spikeRemovalFlag: this.spikeRemovalFlag,
                    smoothPlot: this.smoothPlot,
                    fieldCalPlot: this.fieldCalPlot,
                    showPC: this.showPC,
                    showCA: this.showCA
                }

                await preferenceStore.updatePreference(patchBody);

                // If spikeRemovedFlag is changed, we might have to repopulate the data, thus displayDeviceHistoryImpl is called
                const slotStore = useSlotStore();
                const deviceHistory = slotStore.computeCompensatedHistory();
                if (deviceHistory && deviceHistory.sensors && deviceHistory.sensors[0].history.length > 0) {
                    await this.displayDeviceHistoryImpl(deviceHistory, slotStore);
                }
            }
            this.calPlotError = "";
            var errorMsg = "";
            const dat = this.algaeTimeReportsChart.datasets;
            const pcDetailIndex = dat.findIndex((x) => x.label == "PC Detail");
            const pcTrendIndex = dat.findIndex((x) => x.label == "PC Trend");
            const pcCalIndex = dat.findIndex((x) => x.label == "PC Cal");
            const pcCalTrendIndex = dat.findIndex((x) => x.label == "PC Cal Trend");
            const caDetailIndex = dat.findIndex((x) => x.label == "CA Detail");
            const caTrendIndex = dat.findIndex((x) => x.label == "CA Trend");
            const caCalIndex = dat.findIndex((x) => x.label == "CA Cal");
            const caCalTrendIndex = dat.findIndex((x) => x.label == "CA Cal Trend");

            if (this.showPC) {
                // if pc is selected to view, show it
                dat[pcDetailIndex].hidden = !this.rawPlot;

                //  if calibration is done, we will never show the original trend.
                // In other words, trend will be shown only if this.smoothPlot is true and there is no calibration
                dat[pcTrendIndex].hidden = !this.smoothPlot || (this.fieldCalPlot && (dat[pcCalIndex].data.length !== 0));

                // If there is no calibration, we will never show pcCal. If the UI doesn't want to show cal plot, we won't show pcCal neither.
                dat[pcCalIndex].hidden = !this.fieldCalPlot || (dat[pcCalIndex].data.length === 0);

                // If the UI doesn't want to show smoothPlot, we will hide CalTrend. If there is no calibration, we will not show pcCalTrend.
                dat[pcCalTrendIndex].hidden = !this.smoothPlot || (dat[pcCalIndex].data.length === 0) || !this.fieldCalPlot;

                if (dat[pcCalIndex].data.length == 0 && this.fieldCalPlot) {
                    // if no field cal data, throw error
                    errorMsg += "Phycocyanin. ";
                }
            } else {
                dat[pcDetailIndex].hidden = true;
                dat[pcTrendIndex].hidden = true;
                dat[pcCalIndex].hidden = true;
                dat[pcCalTrendIndex].hidden = true;
            }

            if (this.showCA) {
                // if ca is selected to view, show it
                dat[caDetailIndex].hidden = !this.rawPlot;

                //  if calibration is done, we will never show the original trend.
                // In other words, trend will be shown only if this.smoothPlot is true and there is no calibration
                dat[caTrendIndex].hidden = !this.smoothPlot || (this.fieldCalPlot && (dat[caCalIndex].data.length !== 0));

                // If there is no calibration, we will never show caCal. If the UI doesn't want to show cal plot, we won't show caCal neither.
                dat[caCalIndex].hidden = !this.fieldCalPlot || (dat[caCalIndex].data.length === 0);

                // If the UI doesn't want to show smoothPlot, we will hide CalTrend. If there is no calibration, we will not show caCalTrend.
                dat[caCalTrendIndex].hidden = !this.smoothPlot || (dat[caCalIndex].data.length === 0) || !this.fieldCalPlot;

                if (dat[caCalIndex].data.length == 0 && this.fieldCalPlot) {
                    // if no field cal data, throw error
                    errorMsg += "Chlorophyll-a. ";
                }
            } else {
                dat[caDetailIndex].hidden = true;
                dat[caTrendIndex].hidden = true;
                dat[caCalIndex].hidden = true;
                dat[caCalTrendIndex].hidden = true;
            }

            var minMaxPC = [];
            var minMaxPCTrend = [];
            var maxPC = 0;
            var minMaxCA = [];
            var minMaxCATrend = [];
            var maxCA = 0;
            if (this.fieldCalPlot && !this.smoothPlot && !this.rawPlot) {
                // show only calibration data
                if (dat[pcCalIndex].data.length > 0) {
                    minMaxPC = getReportMinMax(dat[pcCalIndex].data, -0.2, 10);
                    maxPC = Math.ceil(minMaxPC[1] + minMaxPC[1] * 0.2);
                    this.algaeLineChartOptions.scales.y_axis_1.title = {
                        display: true,
                        text: "PC (ug/L)",
                        color: 'white'
                    }
                } else {
                    minMaxPCTrend = getReportMinMax(dat[pcTrendIndex].data, -0.2, 10);
                    maxPC = Math.ceil(minMaxPCTrend[1]);
                    this.algaeLineChartOptions.scales.y_axis_1.title = {
                        display: true,
                        text: "PC RFU",
                        color: 'white'
                    }
                }

                if (dat[caCalIndex].data.length > 0) {
                    minMaxCA = getReportMinMax(dat[caCalIndex].data, -0.2, 15);
                    maxCA = Math.ceil(minMaxCA[1] + minMaxCA[1] * 0.2);
                    this.algaeLineChartOptions.scales.y_axis_2.title = {
                        display: true,
                        text: "CA (ug/L)",
                        color: 'white'
                    }
                } else {
                    minMaxCATrend = getReportMinMax(dat[caTrendIndex].data, -0.2, 150);
                    maxCA = Math.ceil(minMaxCATrend[1]);
                    this.algaeLineChartOptions.scales.y_axis_2.title = {
                        display: true,
                        text: "CA RFU",
                        color: 'white'
                    }
                }
            } else {
                // show any other combo
                minMaxPC = getReportMinMax(dat[pcDetailIndex].data, -0.2, 10);
                minMaxPCTrend = getReportMinMax(dat[pcTrendIndex].data, -0.2, 10);
                maxPC = Math.ceil(Math.max(minMaxPC[1], minMaxPCTrend[1]));
                this.algaeLineChartOptions.scales.y_axis_1.title = {
                    display: true,
                    text: "PC RFU",
                    color: 'white'
                };

                minMaxCA = getReportMinMax(dat[caDetailIndex].data, -0.2, 150);
                minMaxCATrend = getReportMinMax(dat[caTrendIndex].data, -0.2, 150);
                maxCA = Math.ceil(Math.max(minMaxCA[1], minMaxCATrend[1]));
                this.algaeLineChartOptions.scales.y_axis_2.title = {
                    display: true,
                    text: "CA RFU",
                    color: 'white'
                };
            }
            this.algaeLineChartOptions.scales.y_axis_1.title = {
                display: true,
                text: this.rfuSwitchUgL ? "PC (ug/L)" : "PC RFU",
                color: 'white'
            };
            this.algaeLineChartOptions.scales.y_axis_2.title = {
                display: true,
                text: this.rfuSwitchUgL ? "CA (ug/L)" : "CA RFU",
                color: 'white'
            };
            let real_maxPC = this.rfuSwitchUgL ? Math.max(Math.ceil(maxPC), this.defaultUnitValue.uglToRfuProperties.pcMaxValue) / this.defaultUnitValue.uglToRfuProperties.pcValue : Math.max(Math.ceil(maxPC), this.defaultUnitValue.uglToRfuProperties.pcMaxValue);
            this.algaeLineChartOptions.scales.y_axis_1.max = real_maxPC;
            this.algaeLineChartOptions.scales.y_axis_1.ticks.stepSize = Math.round(real_maxPC / 5);
            let real_maxCA = this.rfuSwitchUgL ? Math.max(Math.ceil(maxCA), this.defaultUnitValue.uglToRfuProperties.caMaxValue) / this.defaultUnitValue.uglToRfuProperties.caValue : Math.max(Math.ceil(maxCA), this.defaultUnitValue.uglToRfuProperties.caMaxValue);
            this.algaeLineChartOptions.scales.y_axis_2.max = real_maxCA;
            this.algaeLineChartOptions.scales.y_axis_2.ticks.stepSize = Math.round(real_maxCA / 5);

            this.algaeTimeReportsChart.datasets = dat;
            this.calPlotError = errorMsg;
            this.keyCaPc += 1;

            this.incrementKeys();
            this.$forceUpdate();
            this.allowDetailPage = true;
            this.loaded = true;
            this.isLoading = false;
        },
        async selectChartDates() {
            if (this.validateForm()) {
                await this.getReports(this.device._id);
            }
        },
        startText() {
            return "Choose Your Device";
        },
        getSlotName(slotId) {
            const c = this.SLOTS.find((x) => x._id == slotId);
            if (c) {
                return c.name;
            } else {
                return "Unknown device";
            }
        },
        setDeviceId(id) {
            router.push({ name: `slot`, params: { id } });
        },
        getFeatureName(feature) {
            if (feature === 1) {
                return "Turbidity Tracker";
            }
            else if (feature === 2) {
                return "Multi Tracker-DO";
            }
            else if (feature === 3) {
                return "Multi Tracker-PH";
            }
            else if (feature === 4) {
                return "Multi Tracker-PS";
            }

            return "Algae Tracker";
        },
        async populateDevice(slotId) {
            const slotStore = useSlotStore();
            const payload = { id: slotId };
            await slotStore.fetchSlot(payload);
            this.device = slotStore.currentSlot;
            this.slotName = this.device.name;
            this.newSlotName = this.slotName + ' ' + this.getFeatureName(this.device.feature)
            // reset trend data
            this.trendlineProperties = this.resetTrendline();
            this.calPlotError = "";
            // get current data for slot - check trendline and device alerts
            await this.getSlotData();
            await this.getReports(slotId);
        },
        async saveAlert(e, editChartData, editChartDataRangeValue) {
            const slotStore = useSlotStore();
            if (
                (editChartData.name.toLowerCase() === "watertemp" ||
                    editChartData.name.toLowerCase() === "airtemp") &&
                !this.deg
            ) {
                // values displayed at F, need to save as C
                editChartDataRangeValue[0] = this.ftoC(editChartDataRangeValue[0]);
                editChartDataRangeValue[1] = this.ftoC(editChartDataRangeValue[1]);
            }
            if (!editChartData.alertActive) {
                editChartData.alertActive = false; // take care of null values
                // console.log("alertActive" + editChartData.alertActive);
            }

            let device = this.device;
            // update device -> deviceAlert
            if (device.deviceAlerts && device.deviceAlerts.length > 0) {
                //  find alert
                const devAlert = device.deviceAlerts.findIndex(
                    (x) => x.devicePropName == editChartData.name
                );
                // update
                if (devAlert >= 0) {
                    device.deviceAlerts[devAlert].active = editChartData.alertActive;
                    device.deviceAlerts[devAlert].low = editChartDataRangeValue[0];
                    device.deviceAlerts[devAlert].high = editChartDataRangeValue[1];
                } else {
                    // create
                    device.deviceAlerts.push({
                        devicePropName: editChartData.name,
                        active: editChartData.alertActive,
                        low: editChartDataRangeValue[0],
                        high: editChartDataRangeValue[1],
                    });
                }
            } else {
                // create alert and alertArray
                device.deviceAlerts.push({
                    devicePropName: editChartData.name,
                    active: editChartData.alertActive,
                    low: editChartDataRangeValue[0],
                    high: editChartDataRangeValue[1],
                });
            }
            const payload = { deviceAlerts: device.deviceAlerts };
            try {
                await slotStore.updateSlot(this.device._id, payload);
                device = slotStore.currentSlot;
            } catch (err) {
                console.log(err);
            }
            this.device = device;
            // update homepage
            const i = this.outDat.findIndex((x) => x.id == device._id);
            this.outDat[i].pcAlert = device.deviceAlerts.find(
                (x) => x.devicePropName == "phycocyanin"
            ).high;
            this.outDat[i].caAlert = device.deviceAlerts.find((x) => x.devicePropName == "chlorA").high;
            this.outDat[i].tbAlert = device.deviceAlerts.find(
                (x) => x.devicePropName == "turbidity"
            ).high;
            if (this.newDataArray){
              this.updateStatChart();
            }else {
              this.refreshUI(false);
            }
        },
        editAlerts(chartData) {
            const slotStore = useSlotStore();
            var device = slotStore.currentSlot;
            let sensorName = chartData.sensorName;
            if (!sensorName) // featured sensor
            {
                const feature = chartData.feature;
                if (feature === 3) {
                    chartData.name = 'ph';
                    chartData.sensorName = 'ph';
                    chartData.displayName = 'PH';
                    chartData.alertActive = false;
                }
                else if (feature === 2) {
                    chartData.name = 'do';
                    chartData.sensorName = 'do';
                    chartData.displayName = 'DO';
                    chartData.alertActive = false;
                }
            }

            let alert = device.deviceAlerts.find((x) => x.devicePropName == chartData.sensorName);

            if (!alert) {
                const devAlerts = this.resetAlerts();
                alert = devAlerts.find((y) => y.devicePropName == chartData.name);
                device.deviceAlerts.push(alert);
            }

            const alertFormat = alert ? { name: alert.devicePropName, alertActive: alert.active } : null;

            this.editChartData = Object.assign({}, chartData, alertFormat ? alertFormat : {});

            const defaultGauges = this.resetAlerts();
            const deviceProp = defaultGauges.find((x) => x.devicePropName == chartData.sensorName);
            let high = deviceProp.high;
            let low = deviceProp.low;
            if (
                (alert.devicePropName.toLowerCase() === "watertemp" ||
                    alert.devicePropName.toLowerCase() === "airtemp") &&
                !this.deg
            ) {
                // in C need F
                this.alertRangeSliderMin = this.ctoF(low);
                this.alertRangeSliderMax = this.ctoF(high);

                this.editChartDataRangeValue = alert
                    ? [this.ctoF(Number(alert.low)).toFixed(0), this.ctoF(Number(alert.high)).toFixed(0)]
                    : [low + low * 0.25, high - high * 0.25];
            } else {
                this.alertRangeSliderMin = low;
                this.alertRangeSliderMax = high;

                this.editChartDataRangeValue = alert
                    ? [Number(alert.low).toFixed(0), Number(alert.high).toFixed(0)]
                    : [low + low * 0.25, high - high * 0.25];
            }

            if (this.isViewerOnly) {
                this.lowPermAlertEditModal = !this.lowPermAlertEditModal;
            } else {
                this.alertEditModal = !this.alertEditModal;
            }
        },
        setRange(position, value) {
            if (
                (alert.devicePropName === "waterTemp" && !this.deg) ||
                (alert.devicePropName === "airTemp" && this.deg)
            ) {
                // want to display as F
                value = Number((value * (9 / 5) + 32).toFixed(0));
            }
            this.editChartDataRangeValue[position] = parseFloat(value);
            this.$refs.alertRangeSlider.setValue(this.editChartDataRangeValue);
        },
        alertRangeSliderChanged() {
            const currentSliderVal = this.$refs.alertRangeSlider.getValue();
            this.editChartDataRangeValue = currentSliderVal;
        },
        async refreshUI(change=true) {
            if (change){
              this.endDate = new Date(Date.now()).toISOString();
            }
            await this.getReports(this.device._id);
        },

        /* Field calibrations
        Control POST, FETCH calls to slot
        */
        async getFieldCals(slotId) {
            const authStore = useAuthStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            const response = await fetch(`${deviceRoot}/slots/${slotId}/fieldcal`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
            });
            const cals = await response.json();
            return cals;
        },
        async createNewFieldCals(slotId, newCal) {
            const authStore = useAuthStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            const create = await fetch(`${deviceRoot}/slots/${slotId}/fieldcal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
                body: JSON.stringify(newCal),
            });
            const created = await create.json();
            return created;
        },
        async updateFieldCals(cal) {
            const authStore = useAuthStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            var slotId = cal.slot_id;
            var calId = cal._id;
            const create = await fetch(`${deviceRoot}/slots/${slotId}/updatefieldcal/${calId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
                body: JSON.stringify(cal),
            });
            const created = await create.json();
            return created;
        },
        async postCal(calSensor, calVal, fieldSample) {
            // post calibration to db
            if (!this.setCalTime || !calSensor) {
                return (this.calError =
                    "Error in attempting to calibrate.  Please check fields and try again.");
            }
            var slotId = this.device._id;
            // let slotId = this.slotId;
            const cals = await this.getFieldCals(slotId);
            if (cals.length == 0 || !cals.find((x) => x.sensorName == calSensor)) {
                // create cal log
                const newCal = {
                    sensorName: calSensor,
                    slot_id: slotId,
                    moments: [
                        {
                            activated_at: this.setCalTime,
                            rfu: calVal,
                            ugL: fieldSample,
                        },
                    ],
                };
                const created = await this.createNewFieldCals(slotId, newCal);
                if (created.sensorName) {
                    this.calSuccess =
                        "Successfully calibrated " +
                        created.sensorName +
                        ".  Enter another calibration or select done.";
                }
            } else {
                var appendCal = {
                    activated_at: this.setCalTime,
                    rfu: calVal,
                    ugL: fieldSample,
                };
                const prevCals = cals.find((x) => x.sensorName == calSensor);
                prevCals.moments.push(appendCal);
                const updated = await this.updateFieldCals(prevCals);
                if (updated.sensorName) {
                    this.calSuccess =
                        "Successfully calibrated " +
                        updated.sensorName +
                        ".  Enter another calibration or select done.";
                }
            }
        },
        async checkCal(calDate, calTime, calSensor) {
            if (!calDate || !calTime || !calSensor) {
                this.calError = "One or more inputs is missing.  Please check form.";
                return;
            }
            // user will input sensor, field ug/l value and date/time
            // const timeZone = await this.getTimeZone(this.device.gpsLat,this.device.gpsLong);
            const slotStore = useSlotStore();
            const deviceTimeZone = slotStore.deviceTimeZone;
            var start = "";
            var end = "";
            var unixTime = "";
            if (deviceTimeZone.rawOffset) {
                unixTime = dayjs.tz(calDate + " " + calTime, deviceTimeZone.timeZoneId).unix();
                this.setCalTime = dayjs.tz(calDate + " " + calTime, deviceTimeZone.timeZoneId)
                    .utc()
                    .format();
                var s = dayjs.tz(calDate + " " + calTime, deviceTimeZone.timeZoneId).subtract(4, "hours");
                var e = dayjs.tz(calDate + " " + calTime, deviceTimeZone.timeZoneId).add(4, "hours");
                start = s.utc().format();
                end = e.utc().format();
            } else {
                unixTime = dayjs(calDate + " " + calTime).unix();
                this.setCalTime = new Date(calDate + " " + calTime).toISOString();
                start = new Date(new Date(calDate + " " + calTime) - 4 * 60 * 60 * 1000).toISOString();
                end = new Date(new Date(calDate + " " + calTime) + 4 * 60 * 60 * 1000).toISOString();
            }

            // Determine mock flag from URL
            const urlParams = new URLSearchParams(window.location.search);
            const mockFlag = urlParams.get('mock') || '';
            const payload = { slotId: this.device._id, startDate: start, endDate: end, mock: mockFlag };
            await slotStore.fetchDeviceHistory(payload);
            const deviceHist = slotStore.computeCompensatedHistory(); // Cloned version
            // const deviceHist = await this.getDeviceHistory(start,end,this.device._id);

            // get data to calibrate to
            if (deviceHist && deviceHist.sensors[0].history.length > 0) {
                // find RFU of closest data point
                var diff = deviceHist.sensors[0].history.flatMap((x) => Math.abs(x.val - unixTime));
                var minDiff = Math.min(...diff);
                var index = diff.findIndex((x) => x == minDiff);
                var sensorData = deviceHist.sensors.find((x) => x.sensorName === calSensor);
                var val = sensorData.history[index].val;
                this.calVal = val;
                var i = diff.length - index - 1;
                var sensorLineLabels = [];
                if (deviceTimeZone.rawOffset) {
                    sensorLineLabels = deviceHist.sensors[0].history
                        .flatMap((x) => dayjs.tz(x.val * 1000, deviceTimeZone.timeZoneId).format("hh:mm"))
                        .reverse();
                } else {
                    sensorLineLabels = deviceHist.sensors[0].history
                        .flatMap((x) => dayjs(x.val * 1000).format("hh:mm"))
                        .reverse();
                }

                var sensorLineData = sensorData.history.flatMap((x) => x.val).reverse();
                var calChartData = {
                    labels: sensorLineLabels,
                    datasets: [
                        {
                            label: calSensor,
                            data: sensorLineData,
                            pointBackgroundColor: function (context) {
                                var index = context.dataIndex;
                                var value = context.dataset.data[index];
                                return value == val && index == i ? "#de0d0d" : "#c3c8c9";
                            },
                            pointRadius: function (context) {
                                var index = context.dataIndex;
                                var value = context.dataset.data[index];
                                return value == val && index == i ? 10 : 3;
                            },
                            pointStyle: function (context) {
                                var index = context.dataIndex;
                                var value = context.dataset.data[index];
                                return value == val && index == i ? "star" : "circle";
                            },
                            pointBorderColor: function (context) {
                                var index = context.dataIndex;
                                var value = context.dataset.data[index];
                                return value == val && index == i ? "#de0d0d" : "#c3c8c9";
                            },
                            pointBorderWidth: function (context) {
                                var index = context.dataIndex;
                                var value = context.dataset.data[index];
                                return value == val && index == i ? 3 : 1;
                            },
                        },
                    ],
                };
                this.calChartData = calChartData;
                var calChartOptions = {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltips: {
                            intersect: false,
                            axis: "x",
                            backgroundColor: "#000000",
                        },
                    },
                    scales: {
                        y_axis_1:
                        {
                            gridLines: {
                                display: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: "RFU",
                            },
                        },
                    },
                };
                this.calChartOptions = calChartOptions;
                this.calError = null;
                this.calSuccess = null;
                this.verCalChart = true;
                this.keyCalChart += 1;
                this.$forceUpdate();
            } else {
                this.calError =
                    "No AlgaeTracker data for " +
                    calDate +
                    " " +
                    calTime +
                    ".  Please adjust the date range.";
            }
        },
        async applyCal(calSensor, calVal, fieldSample) {
            await this.postCal(calSensor, calVal, fieldSample);
            await this.getReports(this.slotId);
            // this.fieldCalModal = !this.fieldCalModal;
            return;
        },
        async getEvent(slotId) {
            const authStore = useAuthStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            const response = await fetch(`${deviceRoot}/slots/${slotId}/events`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
            });
            const events = await response.json();
            return events;
        },
        async getEventsGlobal(slotId, deviceTimeZone) {
            // get custom events
            const events = await this.getEvent(slotId);
            this.eventTable = events;
            this.updateAnnotations();
            return;
        },
        async createEvent(slotId, event) {
            const authStore = useAuthStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            const create = await fetch(`${deviceRoot}/slots/${slotId}/events`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
                body: JSON.stringify(event),
            });
            const created = await create.json();
            return created;
        },
        onEventSelected(items) {
            this.eventSelect = items;
        },
        onRowHovered(item, _, event) {
            const row = event.target.closest('tr');
            if (!row) return;

            const rect = row.getBoundingClientRect();

            this.tooltipStyle = {
                top: `${rect.top}px`,
                left: `${rect.left + rect.width / 2}px`,
                display: 'block'
            };

            this.rowTooltip = {
                item: item
            };
        },

        onRowUnhovered() {
            this.tooltipStyle.display = 'none';
            this.rowTooltip = null;
        },
        async addEvent() {
            if (this.newEventDateTime == null || this.newEventSelected == null) {
                this.addEventError = "please select treatment type, date and time";
            } else {
                let dateTime = dayjs(this.newEventDateTime);
                console.log(dateTime);
                let ev = this.newEventSelected;
                let payload = {
                    name: ev,
                    start_date: dateTime,
                };
                // 如果是 Custom 类型，添加自定义文本
                // if (this.newEventSelected === 'Custom') {
                    payload.description = this.customEventText;
                // }

                let created = await this.createEvent(this.slotId, payload); // create event
                this.eventTable.push(created);
                this.updateAnnotations();

                this.addEventError = null;
                this.newEventDateTime == null;
                this.newEventSelected = null;
                this.customEventText = '';
            }
        },
        async deleteEvent(row) {
            // delete eventst selected in eventSelect
            const authStore = useAuthStore();
            const slotStore = useSlotStore();
            let authString = "Bearer " + authStore.authUser.authToken;
            let fetchObj = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authString,
                },
            };

            let fetchString = `${deviceRoot}/slots/${this.slotId}/events/${row.item.id}`;
            await fetch(fetchString, fetchObj);
            // now re-create table
            await this.getEventsGlobal(this.slotId, slotStore.deviceTimeZone);
        },

        updateAnnotations() {
          if (!this.algaeTimeReportsChart) {
            return;
          }
          // Add custom events to chart options
          this.algaeLineChartOptions.cevents = this.eventTable;
          this.turbidityOptions.cevents = this.eventTable;
          this.waterTempOptions.cevents = this.eventTable;
          this.battPVOptions.cevents = this.eventTable;
          this.sigStrengthSolarOptions.cevents = this.eventTable;


          // use this.eventTable, always updated and don't have to fetch events from slots
          let annotationsPcCa = [];
          let annotationsTurb = [];
          let annotationsWater = []
          let annotationsBattPV = []
          let annotationsSigs = []

          for (const event of this.eventTable) {
            if (event && event.start_date) {
              const eventDate = dayjs(new Date(event.start_date));
              if (
                  eventDate >= dayjs(new Date(this.algaeTimeReportsChart.labels[0])) &&
                  eventDate <= dayjs(new Date(this.algaeTimeReportsChart.labels.slice(-1)[0]))) {
                const dateOnChart = dayjs(this.getClosestDateOnChart(eventDate)).format(
                    "M/DD/YY h:mm a"
                );
                const annotationImg = getImage(event.name);
                if (annotationImg) {
                  annotationImg.onload = () => {
                    this._loadAnnotationImage(annotationImg, this.algaeLineChartOptions)
                    this._loadAnnotationImage(annotationImg, this.turbidityOptions)
                    this._loadAnnotationImage(annotationImg, this.waterTempOptions)
                    this._loadAnnotationImage(annotationImg, this.battPVOptions)
                    this._loadAnnotationImage(annotationImg, this.sigStrengthSolarOptions)
                    this._loadAnnotationImage(annotationImg, this.customChartOptions)
                  }
                }

                annotationsPcCa.push(this._createAnnotation(event, dateOnChart, this.algaeLineChartOptions, () => {
                  this.keyCaPc += 1;
                }));

                annotationsTurb.push(this._createAnnotation(event, dateOnChart, this.turbidityOptions, () => {
                  this.keyTurb += 1;
                }));
                annotationsWater.push(this._createAnnotation(event, dateOnChart, this.waterTempOptions, () => {
                  this.keyWaterTemp += 1;
                }))
                annotationsBattPV.push(this._createAnnotation(event, dateOnChart, this.battPVOptions, () => {
                  this.keyBatSig += 1;
                }))
                annotationsSigs.push(this._createAnnotation(event, dateOnChart, this.sigStrengthSolarOptions, () => {
                  this.keyLight += 1;
                }))
                // annotations on both the CA/PC chart and the turbidity chart

              }
            }
            // this.keyCaPc += 1;
            // this.keyTurb += 1;
          }
          this.algaeLineChartOptions.plugins.annotation.annotations = annotationsPcCa;
          this.turbidityOptions.plugins.annotation.annotations = annotationsTurb;
          this.waterTempOptions.plugins.annotation.annotations = annotationsWater;
          this.battPVOptions.plugins.annotation.annotations = annotationsBattPV;
          this.sigStrengthSolarOptions.plugins.annotation.annotations = annotationsSigs;
          this.updateCustomChartAnnotations();
        },
        updateCustomChartAnnotations(){
          if (!this.customChartOptions) return;
          this.customChartOptions && (this.customChartOptions.cevents = this.eventTable);
          let annotationsCustom = []
          for (const event of this.eventTable) {
            if (event && event.start_date) {
              const eventDate = dayjs(new Date(event.start_date));
              if (
                  eventDate >= dayjs(new Date(this.algaeTimeReportsChart.labels[0])) &&
                  eventDate <= dayjs(new Date(this.algaeTimeReportsChart.labels.slice(-1)[0]))) {
                const dateOnChart = dayjs(this.getClosestDateOnChart(eventDate)).format(
                    "M/DD/YY h:mm a"
                );
                const annotationImg = getImage(event.name);
                if (annotationImg) {
                  annotationImg.onload = () => {
                    this._loadAnnotationImage(annotationImg, this.customChartOptions)
                  }
                }
                annotationsCustom.push(this._createAnnotation(event, dateOnChart, this.customChartOptions, () => {
                  this.keyCustom += 1;
                }))
                // annotations on both the CA/PC chart and the turbidity chart

              }
            }
          }
          this.customChartOptions.plugins.annotation.annotations = annotationsCustom;
        },
        _loadAnnotationImage(annotationImg,options){
          if (!options) return;
          options.plugins.annotation.annotations.forEach((item) => {
            if (annotationImg.eventType === item.eventType) {
              item.label.content = annotationImg
            }
          })
        },
        _createAnnotation(event,dateOnChart,options,keyCallBack){
          if (!options) return {};
          this.annotationId++;
          return {
            type: "line",
            id: "line" + this.annotationId + '_' + event.name,
            drawTime: "afterDatasetsDraw",
            mode: "vertical",
            scaleID: "x_axis_0",
            value: dateOnChart,
            borderWidth: 5,
            borderColor: this.getAnnotationColor(event.name),
            eventType: event.name,
            label: {
              position: "center",
              backgroundColor: 'white',
              content: "",
              width: '30%',
              height: '30%',
              display: true,
              enabled: true,
              // position: "bottom",
              // // content: image,
              // content: dayjs(new Date(event.start_date)).format("M/DD h:mm a"),
            },
            onMouseenter(e) {
              console.log("mouseenter");

              // this.options.label.enabled = true;
              //    this.appInstance.keyCaPc += 1;
              // this.$root.keyTurb += 1;

              this.options.helper(this.options.value, this.options.eventType);
              console.log("Running...");
            },

            onMouseleave(e) {
              console.log("mouseleave");
              this.options.helper2(this.options.value, this.options.eventType);
              console.log("Running...");
            },

            helper: (date, type) => {
              console.log(options.plugins.annotation.annotations);
              console.log(date);
              for (const line of options.plugins.annotation.annotations) {
                console.log(line);

                if (line.value === date) {
                  line.label.enabled = true;
                  line.borderColor = this.getAnnotationColor(type + "_bold");
                  //!line.label.enabled;
                }
              }
              keyCallBack && keyCallBack()
            },

            helper2: (date, type) => {
              console.log(options.plugins.annotation.annotations);
              console.log(date);
              for (const line of options.plugins.annotation.annotations) {
                console.log(line);

                if (line.value === date) {
                  line.label.enabled = false;
                  line.borderColor = this.getAnnotationColor(type);
                  //!line.label.enabled;
                  console.log(line);
                }
              }
              keyCallBack && keyCallBack()
            },
          }
        },
        getClosestDateOnChart(eventDate) {
            const arr = this.algaeTimeReportsChart.labels.map((x) => new Date(x));
            arr.sort((a, b) => {
                var distanceA = Math.abs(a - eventDate);
                var distanceB = Math.abs(b - eventDate);
                return distanceA - distanceB;
            });
            return arr[0];
        },
        getLastHeard(slotId) {
            const currentSlotIndex = this.outDat.findIndex((x) => x.id == slotId);
            return this.outDat[currentSlotIndex].lastHeard;
        },
        async displayDeviceHistoryImpl(deviceHistory, slotStore) {
            // TODO: perform compensation here?

            if (this.spikeRemovalFlag) {
                slotStore.performSpikeRemoval(deviceHistory);
            }

            const deviceSnapshot = slotStore.deviceSnapshot;

            this.deviceOffline = false;
            this.assignSensorIndices(deviceHistory); // assign sensor indices
            let numSensors = deviceHistory.sensors.length;

            // sort object by utcTime (for synching data)
            let lenDat = [];
            for (let c = 0; c < numSensors; c++) {
                lenDat.push(deviceHistory.sensors[c].history.length);
            }
            lenDat = Math.max.apply(Math, lenDat);
            let fullDat = [];
            for (let i = 0; i < lenDat; i++) {
                let a = [];
                for (let t = 0; t < numSensors; t++) {
                    if (i < deviceHistory.sensors[t].history.length) {
                        a.push(deviceHistory.sensors[t].history[i].val);
                    } else {
                        a.push(-1);
                    }
                }
                fullDat.push(a);
            }
            fullDat.sort((first, last) => first[this.utI] - last[this.utI]);
            // remove duplicates
            fullDat = removeDuplicates(fullDat);
            // NPQ comp
            this.NPQComp(fullDat);

            let datByCol = fullDat[0].map((_, colIndex) => fullDat.map((row) => row[colIndex]));
            this.datByCol = datByCol;

            lenDat = datByCol[0].length;

            /* set lat and long */
            if (this.device.useDefaultGPS === false) {
                const latitude = deviceSnapshot.deviceProps[this.laI].result;
                const longitude = deviceSnapshot.deviceProps[this.loI].result;
                var gpsLastUpdate = datByCol[this.utI][lenDat - 1];
                if (latitude !== 1 && longitude !== 1 && latitude !== 0 && longitude !== 0) {
                    this.device.gpsLat = latitude;
                    this.device.gpsLong = longitude;
                }
            }
            if (deviceSnapshot.deviceProps && deviceSnapshot.deviceProps.length > 0) {
                deviceSnapshot.deviceProps.forEach((item, index) => {
                    if (item.name === 'fixOk') {
                        this.fixOk = item.result;
                    }
                })
            }
            this.deviceLat = this.device.gpsLat;
            this.deviceLong = this.device.gpsLong;
            this.inLongLat = true;
            this.deviceInWater = this.device.inWater;

            /* NOW do time zone, weather */
            var tzPayload = {
                lat: this.deviceLat,
                lng: this.deviceLong,
            };

            await slotStore.fetchWeatherLabel(tzPayload);
            await slotStore.fetchTimeZone(tzPayload);
            await this.getExclusionData()

            this.timeSeriesNames = ['precipitationIntensity', 'windSpeed']; // Trigger refresh of time series

            const deviceTimeZone = slotStore.deviceTimeZone;
            this.battery = fullDat[lenDat - 1][this.bsI].toFixed(1);
            this.signal = fullDat[lenDat - 1][this.ssI].toFixed(1);

            // this new array can be added to with trend data etc
            var newDataArray = [];
            for (let i = 0; i < numSensors; i++) {
                var [label, units] = this.assignChartTitles(deviceHistory.sensors[i].sensorName);
                newDataArray.push({
                    sensorName: deviceHistory.sensors[i].sensorName,
                    history: datByCol[i],
                    label: label,
                    units: units,
                });
            }
            //数据过滤
            if (this.exclusionData.on) {
              filterExclusionData(newDataArray,this.exclusionData.dataProperty)
            }
            // const timeZone = await this.getTimeZone(this.deviceLat,this.deviceLong);
            var timeString = [];
            var utcTime = newDataArray.find((x) => x.sensorName == "utcTime").history;
            if (deviceTimeZone.status === "OK") {
                timeString = utcTime.map((y) =>
                    dayjs.tz(y * 1000, deviceTimeZone.timeZoneId).format("M/DD/YY h:mm a")
                );
                this.gpsLastUpdate =
                    "GPS last updated: " +
                    dayjs.tz(gpsLastUpdate * 1000, deviceTimeZone.timeZoneId).format("M/DD h:mm a");
            } else {
                timeString = utcTime.map((y) => dayjs(y * 1000).format("M/DD/YY h:mm a"));
                this.gpsLastUpdate =
                    "GPS last updated: " + dayjs(gpsLastUpdate * 1000).format("M/DD h:mm a");
            }
            newDataArray.push({
                sensorName: "timeString",
                history: timeString,
            });
            this.lastHeard = this.getLastHeard(this.slotId);

            // save data array to use as extern
            this.newDataArray = newDataArray;

            /*  START CAL AND TREND ANALYSIS */

            // get trendline and calibration data
            let props = this.trendlineProperties;
            const cals = await this.getFieldCals(this.slotId);
            await this.getEventsGlobal(this.slotId, deviceTimeZone);

            // ca trend data
            let lightCompCA = this.lightComp(
                datByCol[this.caI],
                datByCol[this.liI],
                props.caProperties.kl,
                props.caProperties.maxLight,
                []
            );
            const caTrendData = this.lowpassFilter(lightCompCA, props.caProperties.alpha);
            this.caTrendData = caTrendData;
            newDataArray.push({
                sensorName: "caTrend",
                history: caTrendData,
                label: "Chlorophyll Trend",
                units: "RFU",
            });
            // ca calibrated data
            if (cals.length > 0 && cals.find((x) => x.sensorName == "chlorA")) {
                const caRawData = newDataArray.find((x) => x.sensorName == "chlorA");
                const caCalData = cals.find((x) => x.sensorName == "chlorA");
                newDataArray.push({
                    sensorName: "caFieldCal",
                    history: calibrateHistory(caRawData.history, timeString, caCalData.moments),
                    label: "Field Calibrated Chlorophyll",
                    units: "ug/L",
                });
                newDataArray.push({
                    sensorName: "caTrendFieldCal",
                    history: calibrateHistory(caTrendData, timeString, caCalData.moments),
                    label: "Field Calibrated Chlorophyll Trend",
                    units: "ug/L",
                });
            } else {
                newDataArray.push({
                    sensorName: "caFieldCal",
                    history: [],
                    label: "Field Calibrated Chlorophyll",
                    units: "ug/L",
                });
                newDataArray.push({
                    sensorName: "caTrendFieldCal",
                    history: [],
                    label: "Field Calibrated Chlorophyll Trend",
                    units: "ug/L",
                });
            }
            //ca NPQ data
            // this.lightComp(this.datByCol[this.caI],this.datByCol[this.liI],this.playPC_k,this.playPC_maxLight,this.caAvgNightNPQ);
            const caNPQ = this.lightComp(
                this.datByCol[this.caI],
                this.datByCol[this.liI],
                props.caProperties.kl,
                props.caProperties.maxLight,
                this.caAvgNightNPQ
            );
            newDataArray.push({
                sensorName: "caNPQ",
                history: caNPQ,
                label: "Chlorophyll NPQ",
                units: "RFU",
            });

            // pc data
            let lightCompPC = this.lightComp(
                datByCol[this.pcI],
                datByCol[this.liI],
                props.pcProperties.kl,
                props.pcProperties.maxLight,
                []
            );
            const pcTrendData = this.lowpassFilter(lightCompPC, props.pcProperties.alpha);
            this.pcTrendData = pcTrendData;
            newDataArray.push({
                sensorName: "pcTrend",
                history: pcTrendData,
                label: "Phycocyanin Trend",
                units: "RFU",
            });
            // pc calibrated data
            if (cals.length > 0 && cals.find((x) => x.sensorName == "phycocyanin")) {
                const pcRawData = newDataArray.find((x) => x.sensorName == "phycocyanin");
                const pcCalData = cals.find((x) => x.sensorName == "phycocyanin");
                newDataArray.push({
                    sensorName: "pcFieldCal",
                    history: calibrateHistory(pcRawData.history, timeString, pcCalData.moments),
                    label: "Field Calibrated Phycocyanin",
                    units: "ug/L",
                });
                newDataArray.push({
                    sensorName: "pcTrendFieldCal",
                    history: calibrateHistory(pcTrendData, timeString, pcCalData.moments),
                    label: "Field Calibrated Phycocyanin Trend",
                    units: "ug/L",
                });
            } else {
                newDataArray.push({
                    sensorName: "pcFieldCal",
                    history: [],
                    label: "Field Calibrated Phycocyanin",
                    units: "ug/L",
                });
                newDataArray.push({
                    sensorName: "pcTrendFieldCal",
                    history: [],
                    label: "Field Calibrated Phycocyanin Trend",
                    units: "ug/L",
                });
            }
            // pc NPQ
            const pcNPQ = this.lightComp(
                this.datByCol[this.pcI],
                this.datByCol[this.liI],
                props.pcProperties.kl,
                props.pcProperties.maxLight,
                this.pcAvgNightNPQ
            );
            newDataArray.push({
                sensorName: "pcNPQ",
                history: pcNPQ,
                label: "Phycocyanin NPQ",
                units: "RFU",
            });

            // temperatue compensation PC
            const pcTempComp = this.tempComp(
                this.datByCol[this.pcI],
                props.pcProperties.alpha,
                props.pcProperties.stTemp,
                props.pcProperties.kTemp
            );
            newDataArray.push({
                sensorName: "pcTempComp",
                history: pcTempComp,
                label: "PC Temp. Comp.",
                units: "RFU",
            });
            // ratio pc / ca
            const algaeRatio = datByCol[this.pcI].map((val, ind) => {
                return val === 0 ? 0 : datByCol[this.caI][ind] / val
            });
            newDataArray.push({
                sensorName: "algaeRatio",
                history: algaeRatio,
                label: "CA/PC",
                units: "RFU",
            });

            // PC daily averages
            const dayAvgPC = this.dailyAverage(timeString, datByCol[this.pcI]);
            newDataArray.push({
                sensorName: "dayAvgPC",
                history: dayAvgPC,
                label: "Phycocyanin Daily Average",
                units: "RFU",
            });

            // CA daily averages
            const dayAvgCA = this.dailyAverage(timeString, datByCol[this.caI]);
            newDataArray.push({
                sensorName: "dayAvgCA",
                history: dayAvgCA,
                label: "Chlorophyll Daily Average",
                units: "RFU",
            });

            // TU daily averages
            const dayAvgTU = this.dailyAverage(timeString, datByCol[this.tuI]);
            newDataArray.push({
                sensorName: "dayAvgTU",
                history: dayAvgTU,
                label: "Turbidty Daily Average",
                units: "NTU",
            });

            // TU trend data
            const tuTrendData = this.tempCompTurbidity(
                this.datByCol[this.tuI],
                props.tuProperties.alphaTemp,
                props.tuProperties.stTemp,
                props.tuProperties.kTemp
            );
            this.tuTrendData = tuTrendData;
            newDataArray.push({
                sensorName: "tuTrend",
                history: tuTrendData,
                label: "Turbidity Trend",
                units: "NTU",
            });

            // temperatue compensation TU
            /*
            const tuTempComp = this.tempComp(this.datByCol[this.tuI],
            props.tuProperties.alphaTemp,props.tuProperties.stTemp,props.tuProperties.kTemp);
            newDataArray.push({
            sensorName:"tuTempComp",
            history: tuTempComp,
            label: "Turbidity Temperature Compensated",
            units: "NTU"
            });
            */
            // WT trend data
            const wtTrendData = this.lowpassFilter(
                newDataArray.find((x) => x.sensorName == "waterTemp").history,
                props.wtProperties.alpha
            );
            this.wtTrendData = wtTrendData;
            newDataArray.push({
                sensorName: "wtTrend",
                history: wtTrendData,
                label: "Water Temperature Trend",
                units: "C",
            });

            //WT farenheit
            newDataArray.push({
                sensorName: "wtF",
                history: newDataArray
                    .find((x) => x.sensorName == "waterTemp")
                    .history.flatMap((x) => x * (9 / 5) + 32),
                label: "Water Temperature",
                units: "F",
            });

            //WT trend farenheit
            newDataArray.push({
                sensorName: "wtFTrend",
                history: newDataArray
                    .find((x) => x.sensorName == "wtTrend")
                    .history.flatMap((x) => x * (9 / 5) + 32),
                label: "Water Temp. Trend",
                units: "F",
            });

            /* END CAL AND TREND ANALYSIS  */

            /* Gauges */
            const airTempFromServer = deviceSnapshot.deviceProps[this.atI].result;
            // let targetValue = 0;
            // this.statCharts = lastDataPoint.sensorGauges
            var gauges = this.sensorGauges;
            var smooth = this.smoothPlot;
            var degF = this.deg;
            var statCharts = gauges.map((x) => {
                const devicePropDetails = newDataArray.find((dp) => dp.sensorName === x.name);
                const len = devicePropDetails.history.length - 1;
                // let targetValue = fullDat[len][i];
                var targetValue = devicePropDetails.history[len];
                const alerts = this.device.deviceAlerts.find((y) => y.devicePropName == x.name);
                var high = alerts.high;
                var low = alerts.low;
                var maxValue = x.maxValue;
                if (devicePropDetails.sensorName === "airTemp") {
                    targetValue = airTempFromServer;
                    if (!this.deg) {
                        high = this.ctoF(high);
                        low = this.ctoF(low);
                        targetValue = this.ctoF(targetValue);
                        maxValue = this.ctoF(maxValue);
                        x.units = "\u00B0 F";
                    } else {
                        x.units = "\u00B0 C";
                    }
                }
                if (devicePropDetails.sensorName === "waterTemp") {
                    if (!degF) {
                        high = this.ctoF(high);
                        low = this.ctoF(low);
                        targetValue = this.ctoF(targetValue);
                        maxValue = this.ctoF(maxValue);
                        x.units = "\u00B0 F";
                    } else {
                        x.units = "\u00B0 C";
                    }
                }

                if (devicePropDetails.sensorName === "phycocyanin") {
                    if (smooth) {
                        targetValue = newDataArray.find((x) => x.sensorName == "pcTrend").history[len]; // TODO: show trend
                        x.units = "RFU (Trend)";
                    }
                    else {
                        x.units = "RFU";
                    }

                }

                if (devicePropDetails.sensorName === "chlorA") {
                    if (smooth) {
                        targetValue = newDataArray.find((x) => x.sensorName == "caTrend").history[len]; // TODO: show trend
                        x.units = "RFU (Trend)";
                    }
                    else {
                        x.units = "RFU";
                    }
                }

                return Object.assign(
                    {},
                    { displayName: x.displayName },
                    { sensorName: x.name },
                    { units: x.units },
                    { value: targetValue },
                    { labels: [x.name, "total"] },
                    {
                        datasets: [
                            {
                                label: x.name,
                                backgroundColor: [this.getColor(targetValue, high, low), "#eaeaea"],
                                data: [
                                    targetValue > maxValue ? maxValue : targetValue,
                                    maxValue > targetValue ? maxValue - targetValue : 0,
                                ],
                            },
                        ],
                    }
                );
            });
            this.statCharts = statCharts;
            // phycocyanin and chloraphyll chart
            //PC and CA filter
            const algaeTimeReportsChart = {
                labels: newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [
                    {
                        // TODO: replace with compensated value
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "phycocyanin").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.pcValue) : newDataArray.find((x) => x.sensorName == "phycocyanin").history, //pc
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "PC Detail",
                        backgroundColor: getLineChartColor("phycocyanin"),
                        borderColor: getLineChartColor("phycocyanin"),
                        borderDash: [2],
                        yAxisID: "y_axis_1",
                        hidden: !this.rawPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "pcTrend").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.pcValue) : newDataArray.find((x) => x.sensorName == "pcTrend").history, //pc lowpass
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "PC Trend",
                        backgroundColor: getLineChartColor("pcTrend"),
                        borderColor: getLineChartColor("pcTrend"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                        hidden: !this.smoothPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "pcFieldCal").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.pcValue) : newDataArray.find((x) => x.sensorName == "pcFieldCal").history, //pc field cal - may be empty
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "PC Cal",
                        backgroundColor: getLineChartColor("pcFieldCal"),
                        borderColor: getLineChartColor("pcFieldCal"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                        hidden: !this.fieldCalPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "pcTrendFieldCal").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.pcValue) : newDataArray.find((x) => x.sensorName == "pcTrendFieldCal").history, //pc field cal - may be empty
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "PC Cal Trend",
                        backgroundColor: getLineChartColor("pcTrendFieldCal"),
                        borderColor: getLineChartColor("pcTrendFieldCal"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                        hidden: !this.fieldCalPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "chlorA").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.caValue) : newDataArray.find((x) => x.sensorName == "chlorA").history, //ca
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "CA Detail",
                        backgroundColor: getLineChartColor("chlorA"),
                        borderColor: getLineChartColor("chlorA"),
                        borderDash: [2],
                        yAxisID: "y_axis_2",
                        hidden: !this.rawPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "caTrend").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.caValue) : newDataArray.find((x) => x.sensorName == "caTrend").history, //ca lowpass
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "CA Trend",
                        backgroundColor: getLineChartColor("caTrend"),
                        borderColor: getLineChartColor("caTrend"),
                        borderWidth: 1,
                        yAxisID: "y_axis_2",
                        hidden: !this.smoothPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "caFieldCal").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.caValue) : newDataArray.find((x) => x.sensorName == "caFieldCal").history, //ca field calibration
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "CA Cal",
                        backgroundColor: getLineChartColor("caFieldCal"),
                        borderColor: getLineChartColor("caFieldCal"),
                        borderWidth: 1,
                        yAxisID: "y_axis_2",
                        hidden: !this.fieldCalPlot,
                    },
                    {
                        data: this.rfuSwitchUgL ? newDataArray.find((x) => x.sensorName == "caTrendFieldCal").history.map((data) => data / this.defaultUnitValue.uglToRfuProperties.caValue) : newDataArray.find((x) => x.sensorName == "caTrendFieldCal").history, //ca field calibration
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "CA Cal Trend",
                        backgroundColor: getLineChartColor("caTrendFieldCal"),
                        borderColor: getLineChartColor("caTrendFieldCal"),
                        borderWidth: 1,
                        yAxisID: "y_axis_2",
                        hidden: !this.fieldCalPlot,
                    },
                ],
            };
            this.algaeTimeReportsChart = algaeTimeReportsChart;

            const algaeLineChartOptions = getDefaultOptions();
            algaeLineChartOptions.plugins.title.text = "Phycocyanin and Chlorophyll-a";
            this.algaeLineChartOptions = algaeLineChartOptions;
            // water temp chart
            const waterTempLineChart = {
                labels: newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [
                    {
                        data: newDataArray.find((x) => x.sensorName == "waterTemp").history, //pc
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "Water Temperature",
                        backgroundColor: getLineChartColor("waterTemp"),
                        borderColor: getLineChartColor("waterTemp"),
                        borderDash: [2],
                        yAxisID: "y_axis_1",
                        hidden: this.waterTrend,
                    },
                    {
                        data: newDataArray.find((x) => x.sensorName == "wtTrend").history, //pc lowpass
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "WT Trend",
                        backgroundColor: getLineChartColor("wtTrend"),
                        borderColor: getLineChartColor("wtTrend"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                        hidden: !this.waterTrend,
                    },
                ],
            };
            this.waterTempLineChart = waterTempLineChart;

            const waterTempOptions = getDefaultOptions();
            waterTempOptions.plugins.title.text = "Water Temperature";
            waterTempOptions.scales.y_axis_2.display = false;
            var minMaxT = [];
            if (!this.deg) {
                waterTempLineChart.datasets[0].data = newDataArray.find(
                    (x) => x.sensorName == "wtF"
                ).history;
                waterTempLineChart.datasets[1].data = newDataArray.find(
                    (x) => x.sensorName == "wtFTrend"
                ).history;
                waterTempOptions.scales.y_axis_1.scaleLabel.labelString = "Temp. (\u00B0 F)";
                minMaxT = getReportMinMax(
                    newDataArray.find((x) => x.sensorName == "wtF").history,
                    40,
                    60
                );
                // var a = this.timeReportsChartsList[this.wtI].datasets[0].data.map(function(e)
                //   {return ((e * (9/5)) + 32)});
                // this.timeReportsChartsList[this.wtI].datasets[0].data = a;
            } else {
                waterTempOptions.scales.y_axis_1.scaleLabel.labelString = "Temp. (\u00B0 C)";
                minMaxT = getReportMinMax(
                    newDataArray.find((x) => x.sensorName == "waterTemp").history,
                    -10,
                    10
                );
            }
            const wtAx = getAxesMinMaxStep(minMaxT[0], minMaxT[1], 10, 0);
            waterTempOptions.scales.y_axis_1.suggestedMin = wtAx[0];
            waterTempOptions.scales.y_axis_1.suggestedMax = wtAx[1];
            waterTempOptions.scales.y_axis_1.ticks.stepSize = wtAx[2];
            this.waterTempOptions = waterTempOptions;

            // turbidity chart
            // TODO TU filter
            const turbidityLineChart = {
                labels: newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [
                    {
                        data: newDataArray.find((x) => x.sensorName == "turbidity").history, //pc
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "Turbidity",
                        backgroundColor: getLineChartColor("turbidity"),
                        borderColor: getLineChartColor("turbidity"),
                        borderDash: [2],
                        yAxisID: "y_axis_1",
                        hidden: this.turbidityTrend,
                    },
                    {
                        data: newDataArray.find((x) => x.sensorName == "tuTrend").history, //pc lowpass
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "Turbidity Trend",
                        backgroundColor: getLineChartColor("tuTrend"),
                        borderColor: getLineChartColor("tuTrend"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                        hidden: !this.turbidityTrend,
                    },
                ],
            };
            this.turbidityLineChart = turbidityLineChart;

            const turbidityOptions = getDefaultOptions();
            turbidityOptions.plugins.title.text = "Turbidity";
            turbidityOptions.scales.y_axis_2.display = false;
            turbidityOptions.scales.y_axis_1.scaleLabel.labelString = "Turbidity (NTU)";
            var minMaxTU = getReportMinMax(
                newDataArray.find((x) => x.sensorName == "turbidity").history,
                0,
                10
            );
            const tuAx = getAxesMinMaxStep(minMaxTU[0], minMaxTU[1], 10, 1);
            turbidityOptions.scales.y_axis_1.suggestedMax = tuAx[1];
            turbidityOptions.scales.y_axis_1.suggestedMin = tuAx[0];
            turbidityOptions.scales.y_axis_1.ticks.stepSize = tuAx[2];
            this.turbidityOptions = turbidityOptions;


            this.caPcChart(false);

            // battery and panel volts chart
            const battPVChart = {
                labels: newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [
                    {
                        data: newDataArray.find((x) => x.sensorName == "battSOC").history, //batSOC
                        // time: datByCol[this.utI],
                        // dataFullObj: report.timeReports[firstIndex].map((tr) => tr),
                        fill: false,
                        label: "Battery Strength",
                        backgroundColor: getLineChartColor("battSOC"),
                        borderColor: getLineChartColor("battSOC"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                    },
                    {
                        data: newDataArray.find((x) => x.sensorName == "panelVolts").history, //panelVolts
                        // time: datByCol[this.utI],
                        // dataFullObj: report.timeReports[secondIndex].map((tr) => tr),
                        fill: false,
                        label: "Panel Volts",
                        backgroundColor: getLineChartColor("panelVolts"),
                        borderColor: getLineChartColor("panelVolts"),
                        borderWidth: 1,
                        yAxisID: "y_axis_2",
                    },
                ],
            };
            this.battPVChart = battPVChart;
            const battPVOptions = getDefaultOptions();
            battPVOptions.scales.y_axis_2.max = 22;
            battPVOptions.scales.y_axis_2.ticks.stepSize = Math.round(22 / 10);
            battPVOptions.scales.y_axis_2.scaleLabel.labelString = "Solar Panel (V)";
            battPVOptions.scales.y_axis_1.scaleLabel.labelString = "Battery Strength (%)";
            battPVOptions.plugins.title.text = "Battery and Solar Panel";
            this.battPVOptions = battPVOptions;

            // signal strength and solar light chart
            const ssLiChart = {
                labels: newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [
                    {
                        data: newDataArray.find((x) => x.sensorName == "sigStrength").history, //sigstrength
                        // time: datByCol[this.utI],
                        fill: false,
                        label: "Signal Strength",
                        backgroundColor: getLineChartColor("sigStrength"),
                        borderColor: getLineChartColor("sigStrength"),
                        borderWidth: 1,
                        yAxisID: "y_axis_1",
                    },
                    {
                        data: newDataArray.find((x) => x.sensorName == "light").history, //solarLight
                        // time: datByCol[this.utI],
                        // dataFullObj: report.timeReports[secondIndex].map((tr) => tr),
                        fill: false,
                        label: "Solar Light",
                        backgroundColor: getLineChartColor("light"),
                        borderColor: getLineChartColor("light"),
                        borderWidth: 1,
                        yAxisID: "y_axis_2",
                    },
                ],
            };
            this.ssLiChart = ssLiChart;
            const sigStrengthSolarOptions = getDefaultOptions();
            const minMaxSS = getReportMinMax(
                newDataArray.find((x) => x.sensorName == "sigStrength").history,
                0,
                20
            );
            const ssAx = getAxesMinMaxStep(minMaxSS[0], minMaxSS[1], 10, 1);
            sigStrengthSolarOptions.scales.y_axis_1.max = ssAx[1];
            sigStrengthSolarOptions.scales.y_axis_1.ticks.stepSize = ssAx[2];
            sigStrengthSolarOptions.scales.y_axis_1.scaleLabel.labelString = "Signal Strength (%)";

            const minMaxLi = getReportMinMax(
                newDataArray.find((x) => x.sensorName == "light").history,
                0,
                400
            );
            const liAx = getAxesMinMaxStep(minMaxLi[0], minMaxLi[1], 10, 1);
            sigStrengthSolarOptions.scales.y_axis_2.max = liAx[1];
            sigStrengthSolarOptions.scales.y_axis_2.ticks.stepSize = liAx[2];
            sigStrengthSolarOptions.scales.y_axis_2.scaleLabel.labelString = "Solar Light (PAR)";
            sigStrengthSolarOptions.plugins.title.text = "Signal Strength and Ambient Solar Light";
            this.sigStrengthSolarOptions = sigStrengthSolarOptions;

            //update homepage data
            // console.log("break");
            let time = dayjs.utc(fullDat[lenDat - 1][this.utI] * 1000)
                .local()
                .format("MM-DD HH:mm:ss a");
            let iHomePage = this.outDat.findIndex((x) => x.id == this.slotId);
            this.outDat[iHomePage].bat = fullDat[lenDat - 1][this.bsI].toFixed(0);
            this.outDat[iHomePage].sig = fullDat[lenDat - 1][this.ssI].toFixed(0);
            this.outDat[iHomePage].sig = fullDat[lenDat - 1][this.ssI].toFixed(0);
            this.outDat[iHomePage].lastHeard = this.getLastHeard(this.slotId);
            this.outDat[iHomePage].online = true;
            //this.outDat[iHomePage].lastTEMP = fullDat[lenDat - 1][this.atI].toFixed(0);
            this.outDat[iHomePage].lastPC = fullDat[lenDat - 1][this.pcI].toFixed(0);
            this.outDat[iHomePage].lastCA = fullDat[lenDat - 1][this.caI].toFixed(0);
            this.outDat[iHomePage].lastTB = fullDat[lenDat - 1][this.tuI].toFixed(0);
            this.outDat[iHomePage].latLong = {
                lat: parseFloat(this.deviceLat),
                lng: parseFloat(this.deviceLong),
            };
            // console.log("break");

            this.newDataArray = newDataArray;

            this.createCustomChart();
            this.updateAnnotations();
            this.createPlayground();
        },
        async initializeTrackerTracesPlots() {
            const plot = this.$refs.trackerTracesPlot;
            await plot.initializeTrackerGroups(this.device, this.newDataArray);
        },
        async initializeTrackerTracesGauges() {
            const gauges = this.$refs.trackerTracesGauges;
            await gauges.initializeTrackerGroups(this.device, this.newDataArray);
        },
        async getReports(slotId) {
            this.loaded = false;
            this.isLoading = true;
            this.timeSeriesNames = [];
            this.slotId = slotId;
            this.resetCharts();
            const slotStore = useSlotStore();
            this.device = slotStore.currentSlot;
            this.trendlineProperties = this.device.trendlineProperties;
            // this.getSlotData();
            try {
                /* Query Data */
                const urlParams = new URLSearchParams(window.location.search);
                const mockFlag = urlParams.get('mock') || '';
                const payload = {
                    slotId: slotId,
                    startDate: new Date(this.startDate).toISOString(),
                    endDate: new Date(this.endDate).toISOString(),
                    mock: mockFlag
                };

                await slotStore.fetchDeviceSnapshot();
                await slotStore.fetchDeviceHistory(payload);

                const deviceHistory = slotStore.computeCompensatedHistory();
                //TODO  request filter list

                /* If data exists */
                if (deviceHistory && deviceHistory.sensors && deviceHistory.sensors.length > 0 && deviceHistory.sensors[0].history.length > 0) {
                    await this.displayDeviceHistoryImpl(deviceHistory, slotStore);
                } else {
                    // this.lastHeard = "Device Offline";
                    this.lastHeard = this.getLastHeard(this.slotId);
                    this.signal = 0;
                    this.battery = 0;

                    // this.statCharts = {};
                    this.blankStatChart();
                    const blankChart = {
                        labels: [],
                        datasets: [
                            {
                                data: [],
                                time: [],
                                label: "",
                                borderWidth: 1,
                            },
                        ],
                    };
                    this.algaeTimeReportsChart = blankChart;
                    this.signalAndPanelTimeReportsChart = blankChart;
                    this.ssLiChart = blankChart;
                    this.battPVChart = blankChart;
                    this.customChart = blankChart;
                    this.waterTempReportsChart = blankChart;
                    this.turbidityReportsChart = blankChart;
                    this.timeReportsChartsList = [];
                    this.playgroundChart = blankChart;
                    this.deviceLat = this.device.gpsLat;
                    this.deviceLong = this.device.gpsLong;
                    this.deviceInWater = this.device.inWater;
                    /* NOW do time zone, weather */
                    var updatedPayload = {
                        lat: this.deviceLat,
                        lng: this.deviceLong,
                    };

                    await slotStore.fetchWeatherLabel(updatedPayload);
                    await slotStore.fetchTimeZone(updatedPayload);
                    this.deviceOffline = true;
                }
            } catch (error) {
                console.log("getReports error", error);
            }

            const isOffline = this.deviceOffline;

            //await this.pingDataReadingDevice();
            this.incrementKeys();
            this.$forceUpdate();

            if (this.device.feature !== 0 && !isOffline) {
                await this.initializeTrackerTracesPlots();
                await this.initializeTrackerTracesGauges();
            }

            this.allowDetailPage = true;
            this.loaded = true;
            this.isLoading = false;
        },
        // Return 0: normal; 1: warning. 2: error
        computeAlertColor(currentValue, high, low) {
            if (currentValue > high || currentValue < low) {
                return 2;
            }

            const delta = high - low;
            const rangeRatio = 0.2; // 20%
            // const lowWarning = userAlertLow + delta * rangeRatio;
            const highWarning = high - delta * rangeRatio;
            if (currentValue > low && currentValue < highWarning) {
                return 0;
            } else {
                return 1;
            }
        },
        getColor(value, high, low) {
            let color = "#8DC050";
            const green = "#8DC050";
            const orange = "#ffa600";
            const red = "#FF0000";
            const computedColor = this.computeAlertColor(value, high, low);
            switch (computedColor) {
                case 0:
                    color = green;
                    break;
                case 1:
                    color = orange;
                    break;
                case 2:
                    color = red;
                    break;
                default:
                    break;
            }
            return color;
        },
        getAnnotationColor(name) {
          let color = "rgba(255, 255, 0, 1)";
          switch (name) {
            case "Rain":
              color = "rgba(255, 0, 0, 1)";
              break;
            case "Treatment":
              color = "rgba(193, 120, 245, 1)";
              break;

            case "Rain_bold":
              color = "rgba(255, 0, 0, 1)";
              break;

            case "Treatment_bold":
              color = "rgba(193, 120, 245, 1)";
              break;
            case "Custom_bold":
              color = "rgba(255, 255, 0, 1)";
              break;
            default:
              break;
          }
          return color;
        },
        getLineChartUnits(displayName) {
            let options;
            switch (true) {
                case displayName === "Water Temperature":
                    options = this.waterTempOptions;
                    break;
                case displayName === "Solar Light":
                    options = this.lightOptions;
                    break;
                case displayName === "turbidity":
                    options = this.turbidityOptions;
                    break;
                default:
                    break;
            }
            return options;
        },
        async createCustomChart() {
            ////////////////////////
            // Save options
            const preferenceStore = usePreferenceStore();
            const patchBody = {
                phycocyaninSelected: this.sensorsSelected.find(item => item.sensor === 'phycocyanin').selected,
                chlorASelected: this.sensorsSelected.find(item => item.sensor === 'chlorA').selected,
                waterTempSelected: this.sensorsSelected.find(item => item.sensor === 'waterTemp').selected,
                phSelected: this.sensorsSelected.find(item => item.sensor === 'ph').selected,
                doSelected: this.sensorsSelected.find(item => item.sensor === 'do').selected,
                psSelected: this.sensorsSelected.find(item => item.sensor === 'ps').selected,
                turbiditySelected: this.sensorsSelected.find(item => item.sensor === 'turbidity').selected,
                lightSelected: this.sensorsSelected.find(item => item.sensor === 'light').selected,
                battSOCSelected: this.sensorsSelected.find(item => item.sensor === 'battSOC').selected,
                sigStrengthSelected: this.sensorsSelected.find(item => item.sensor === 'sigStrength').selected,
                panelVoltsSelected: this.sensorsSelected.find(item => item.sensor === 'panelVolts').selected,
                algaeRatioSelected: this.sensorsSelected.find(item => item.sensor === 'algaeRatio').selected,
                dayAvgPCSelected: this.sensorsSelected.find(item => item.sensor === 'dayAvgPC').selected,
                dayAvgCASelected: this.sensorsSelected.find(item => item.sensor === 'dayAvgCA').selected,
                dayAvgTUSelected: this.sensorsSelected.find(item => item.sensor === 'dayAvgTU').selected,
                windSpeedSelected: this.sensorsSelected.find(item => item.sensor === 'windSpeed').selected,
                precipitationIntensitySelected: this.sensorsSelected.find(item => item.sensor === 'precipitationIntensity').selected,

                // 添加左右轴设置
                phycocyaninAxis: this.sensorsSelected.find(item => item.sensor === 'phycocyanin').axis,
                chlorAAxis: this.sensorsSelected.find(item => item.sensor === 'chlorA').axis,
                waterTempAxis: this.sensorsSelected.find(item => item.sensor === 'waterTemp').axis,
                phAxis: this.sensorsSelected.find(item => item.sensor === 'ph').axis,
                doAxis: this.sensorsSelected.find(item => item.sensor === 'do').axis,
                psAxis: this.sensorsSelected.find(item => item.sensor === 'ps').axis,
                turbidityAxis: this.sensorsSelected.find(item => item.sensor === 'turbidity').axis,
                lightAxis: this.sensorsSelected.find(item => item.sensor === 'light').axis,
                battSOCAxis: this.sensorsSelected.find(item => item.sensor === 'battSOC').axis,
                sigStrengthAxis: this.sensorsSelected.find(item => item.sensor === 'sigStrength').axis,
                panelVoltsAxis: this.sensorsSelected.find(item => item.sensor === 'panelVolts').axis,
                algaeRatioAxis: this.sensorsSelected.find(item => item.sensor === 'algaeRatio').axis,
                dayAvgPCAxis: this.sensorsSelected.find(item => item.sensor === 'dayAvgPC').axis,
                dayAvgCAAxis: this.sensorsSelected.find(item => item.sensor === 'dayAvgCA').axis,
                dayAvgTUAxis: this.sensorsSelected.find(item => item.sensor === 'dayAvgTU').axis,
                windSpeedAxis: this.sensorsSelected.find(item => item.sensor === 'windSpeed').axis,
                precipitationIntensityAxis: this.sensorsSelected.find(item => item.sensor === 'precipitationIntensity').axis
            }

            await preferenceStore.updatePreference(patchBody);
            ////////////////////////
            const sensorsSelected = this.sensorsSelected;
            var customChartOptions = getDefaultOptions();
            customChartOptions.plugins.title.text = "Custom Chart";
            let data = [];
            let yaxis = "y_axis_1";
            let leftMin = 0;
            let leftMax = 1;
            let rightMin = 0;
            let rightMax = 1;

            for (let i = 0; i < sensorsSelected.length; i++) {
                if (sensorsSelected[i].selected && this.featureEnabled(sensorsSelected[i].feature)) {
                    let sensorName = sensorsSelected[i].sensor;
                    let sensorData;
                    let sensorLabel;

                    // 检查是否是风速或降水数据，如果是则从 timeSeriesData 中获取
                    if ((sensorName === 'windSpeed' || sensorName === 'precipitationIntensity') && this.timeSeriesData.has(sensorName)) {
                        const timeSeriesData = this.timeSeriesData.get(sensorName);
                        const chartTimeStamps = this.newDataArray.find(x => x.sensorName === "utcTime").history.map(x => x * 1000);

                        const { timeStamps, values } = timeSeriesData;
                        let i = 0; // timeStamps 指针
                        sensorData = chartTimeStamps.map(timestamp => {
                          // 移动 i 指针，确保 timeStamps[i] 是最接近 timestamp 的
                          while (i < timeStamps.length - 1 && Math.abs(timeStamps[i + 1] - timestamp) < Math.abs(timeStamps[i] - timestamp)) {
                            i++;
                          }
                          return values[i] ?? null;
                        });;
                        // 使用 labelsUtc 进行时间戳匹配
                        // sensorData = chartTimeStamps.map(timestamp => {
                        //
                        //     // 找到最接近的时间戳索引
                        //     const closestIndex = timeSeriesData.timeStamps.findIndex(utc =>
                        //         Math.abs(utc - timestamp) === Math.min(...timeSeriesData.timeStamps.map(t => Math.abs(t - timestamp)))
                        //     );
                        //     return closestIndex !== -1 ? timeSeriesData.values[closestIndex] : null;
                        // });
                        sensorLabel = timeSeriesData.chartName;
                    } else {
                        sensorData = this.newDataArray.find((x) => x.sensorName == sensorName).history;
                        sensorLabel = this.newDataArray.find((x) => x.sensorName == sensorName).label;
                    }

                    let newMinMax = getReportMinMax(sensorData, 0, 1);
                    if (sensorsSelected[i].axis == "right") {
                        yaxis = "y_axis_2";
                        if (rightMin > newMinMax[0]) {
                            rightMin = newMinMax[0];
                        }
                        if (rightMax < newMinMax[1]) {
                            rightMax = newMinMax[1];
                        }
                        customChartOptions.scales.y_axis_2.suggestedMax = rightMax;
                        customChartOptions.scales.y_axis_2.suggestedMin = rightMin;
                        customChartOptions.scales.y_axis_2.ticks.stepSize = Math.round(
                            Math.max(rightMin, rightMax) / 10
                        );
                    } else {
                        yaxis = "y_axis_1";
                        if (leftMin > newMinMax[0]) {
                            leftMin = newMinMax[0];
                        }
                        if (leftMax < newMinMax[1]) {
                            leftMax = newMinMax[1];
                        }
                        customChartOptions.scales.y_axis_1.suggestedMax = leftMax;
                        customChartOptions.scales.y_axis_1.suggestedMin = leftMin;
                        customChartOptions.scales.y_axis_1.ticks.stepSize = Math.round(
                            Math.max(leftMin, leftMax) / 10
                        );
                    }
                    data.push({
                        data: sensorData,
                        fill: false,
                        label: sensorLabel,
                        backgroundColor: getLineChartColor(sensorName),
                        borderColor: getLineChartColor(sensorName),
                        borderWidth: 1,
                        yAxisID: yaxis,
                    });
                }
            }

            let customChart = {
                labels: this.newDataArray.find((x) => x.sensorName == "timeString").history,
                datasets: [...data],
            };
            this.customChart = customChart;
            this.customChartOptions = customChartOptions;
            this.keyCustom += 1;
            this.updateCustomChartAnnotations();
            return;
        },
        createPlayground() {
            this.isLoading = true;
            this.updatePlayChart();
            const data = this.newDataArray;
            this.playgroundChart = null;
            this.playgroundChartOptions = null;
            var options = getDefaultOptions();
            options.plugins.title.text = "Playground Chart";
            const params = [
                { sensorName: "phycocyanin", model: this.playPC, axes: this.playPCAx },
                { sensorName: "pcTrend", model: this.playPCTrend, axes: this.playPCAx },
                { sensorName: "pcNPQ", model: this.playPCNPQ, axes: this.playPCAx },
                { sensorName: "pcTempComp", model: this.playPCTempComp, axes: this.playPCAx },
                { sensorName: "dayAvgPC", model: this.playPCAvg, axes: this.playPCAx },
                { sensorName: "chlorA", model: this.playCA, axes: this.playCAAx },
                { sensorName: "caTrend", model: this.playCATrend, axes: this.playCAAx },
                { sensorName: "caNPQ", model: this.playCANPQ, axes: this.playCAAx },
                { sensorName: "dayAvgCA", model: this.playCAAvg, axes: this.playCAAx },
                { sensorName: "turbidity", model: this.playTU, axes: this.playTUAx },
                { sensorName: "tuTrend", model: this.playTUTrend, axes: this.playTUAx },
                { sensorName: "dayAvgTU", model: this.playTUAvg, axes: this.playTUAx },
                { sensorName: "waterTemp", model: this.playWT, axes: this.playWTAx },
                { sensorName: "wtTrend", model: this.playWTTrend, axes: this.playWTAx },
                { sensorName: "light", model: this.playSL, axes: this.playSLAx },
                { sensorName: "panelVolts", model: this.playPV, axes: this.playPVAx },
                { sensorName: "sigStrength", model: this.playSS, axes: this.playSSAx },
                { sensorName: "battSOC", model: this.playBS, axes: this.playBSAx },
                { sensorName: "leakDetect", model: this.playLD, axes: this.playLDAx }
            ];
            let yaxis = "y_axis_1";
            let leftMin = 0;
            let leftMax = 20;
            let rightMin = 0;
            let rightMax = 20;
            var datasets = [];

            for (let i = 0; i < params.length; i++) {
                if (params[i].model) {
                    let tmpDat = [];
                    let newMinMax = [];
                    let color = "";
                    let ylabel = "";
                    tmpDat = data.find((x) => x.sensorName == params[i].sensorName);
                    if (
                        (params[i].sensorName == "waterTemp" || params[i].sensorName == "wtTrend") &&
                        !this.unitPlayTemp
                    ) {
                        if (params[i].sensorName == "waterTemp") {
                            tmpDat = data.find((x) => x.sensorName == "wtF");
                        } else {
                            tmpDat = data.find((x) => x.sensorName == "wtFTrend");
                        }
                    }
                    color = getLineChartColor(params[i].sensorName);
                    newMinMax = getReportMinMax(tmpDat.history, 0, 20);
                    ylabel = tmpDat.label + " (" + tmpDat.units + ")";
                    if (params[i].axes) {
                        yaxis = "y_axis_2";
                        if (rightMin > newMinMax[0]) {
                            rightMin = newMinMax[0];
                        }
                        if (rightMax < newMinMax[1]) {
                            rightMax = newMinMax[1];
                        }
                        options.scales.y_axis_2.suggestedMax = rightMax;
                        options.scales.y_axis_2.suggestedMin = rightMin;
                        options.scales.y_axis_2.ticks.stepSize = Math.max(rightMin, rightMax) / 10;
                        options.scales.y_axis_2.scaleLabel.labelString = ylabel;
                    } else {
                        yaxis = "y_axis_1";
                        if (leftMin > newMinMax[0]) {
                            leftMin = newMinMax[0];
                        }
                        if (leftMax < newMinMax[1]) {
                            leftMax = newMinMax[1];
                        }
                        options.scales.y_axis_1.suggestedMax = leftMax;
                        options.scales.y_axis_1.suggestedMin = leftMin;
                        options.scales.y_axis_1.ticks.stepSize = Math.max(leftMin, leftMax) / 10;
                        options.scales.y_axis_1.scaleLabel.labelString = ylabel;
                    }
                    datasets.push({
                        data: tmpDat.history,
                        fill: false,
                        label: params[i].sensorName,
                        backgroundColor: color,
                        borderColor: color,
                        borderWidth: 1,
                        yAxisID: yaxis,
                    });
                }
            }
            var labels = data.find((x) => x.sensorName == "timeString").history;
            let createPlayChart = {
                labels: [...labels],
                datasets: [...datasets],
            };
            this.playgroundChart = createPlayChart;
            this.playgroundChartOptions = options;
            this.keyPlayground += 1;
            this.isLoading = false;
            return;
        },
        updatePlayChart() {
            var props = this.trendlineProperties;
            var updated = this.newDataArray;
            if (this.playPCTrend) {
                var pc_light = this.lightComp(
                    this.datByCol[this.pcI],
                    this.datByCol[this.liI],
                    props.pcProperties.kl,
                    props.pcProperties.maxLight,
                    []
                );
                var pcTrendData = this.lowpassFilter(pc_light, props.pcProperties.alpha);
                updated[updated.findIndex((x) => x.sensorName == "pcTrend")].history = pcTrendData;
            }
            if (this.playPCNPQ) {
                var pc_light1 = this.lightComp(
                    this.datByCol[this.pcI],
                    this.datByCol[this.liI],
                    props.pcProperties.kl,
                    props.pcProperties.maxLight,
                    this.pcAvgNightNPQ
                );
                var pcNPQTrendData = this.lowpassFilter(pc_light1, props.pcProperties.alpha);
                updated[updated.findIndex((x) => x.sensorName == "pcNPQ")].history = pcNPQTrendData;
            }
            if (this.playPCTempComp) {
                var pcTempCompData = this.tempComp(
                    this.datByCol[this.pcI],
                    props.pcProperties.alphaTemp,
                    props.pcProperties.stTemp,
                    props.pcProperties.kTemp
                );
                updated[updated.findIndex((x) => x.sensorName == "pcTempComp")].history = pcTempCompData;
            }
            if (this.playCATrend) {
                var ca_light = this.lightComp(
                    this.datByCol[this.caI],
                    this.datByCol[this.liI],
                    props.caProperties.kl,
                    props.caProperties.maxLight,
                    []
                );
                var caTrendData = this.lowpassFilter(ca_light, props.caProperties.alpha);
                updated[updated.findIndex((x) => x.sensorName == "caTrend")].history = caTrendData;
            }
            if (this.playCANPQ) {
                var ca_light1 = this.lightComp(
                    this.datByCol[this.caI],
                    this.datByCol[this.liI],
                    props.caProperties.kl,
                    props.caProperties.maxLight,
                    this.caAvgNightNPQ
                );
                var caNPQTrendData = this.lowpassFilter(ca_light1, props.caProperties.alpha);
                updated[updated.findIndex((x) => x.sensorName == "caNPQ")].history = caNPQTrendData;
            }
            if (this.playTUTrend) {
                var tuTrendData = this.tempCompTurbidity(
                    this.datByCol[this.tuI],
                    props.tuProperties.alphaTemp,
                    props.tuProperties.stTemp,
                    props.tuProperties.kTemp
                );
                updated[updated.findIndex((x) => x.sensorName == "tuTrend")].history = tuTrendData;
            }
            if (this.playWTTrend) {
                var waterTrendData = this.lowpassFilter(this.datByCol[this.wtI], props.wtProperties.alpha);
                updated[updated.findIndex((x) => x.sensorName == "wtTrend")].history = waterTrendData;
            }
            this.newDataArray = updated;
            this.trendlineProperties = props;
            return;
        },
        uniq(a) {
            var seen = {};
            return a.filter(function (item) {
                return seen.hasOwnProperty(item) ? false : (seen[item] = true);
            });
        },
        dailyAverage(timeStringArray, sensorArray) {
            var avgs = [];
            var outDat = [];
            var dates = this.uniq(timeStringArray.map((x) => new Date(x).getDate()));
            for (var i = 0; i < dates.length; i++) {
                var current = [];
                timeStringArray.forEach(function (x, ind) {
                    if (new Date(x).getDate() == dates[i]) {
                        current.push(sensorArray[ind]);
                    }
                });
                avgs.push(current.reduce((a, b) => a + b) / current.length);
            }
            for (var c = 0; c < dates.length; c++) {
                timeStringArray.forEach(function (x) {
                    if (new Date(x).getDate() == dates[c]) {
                        outDat.push(avgs[c]);
                    }
                });
            }
            return outDat;
        },
        ftoC(val) {
            return (val - 32) * (5 / 9);
        },
        ctoF(val) {
            return val * (9 / 5) + 32;
        },
        tempComp(sensorData, alpha, temperature, k) {
            // calVal is the sensor high calibration value
            // do temperature comp
            k = parseFloat(k);
            temperature = parseFloat(temperature);
            // let waterTemp = this.datByCol[this.wtI];
            let waterTemp = this.newDataArray.find((x) => x.sensorName == "waterTemp").history;

            let outDat = [];
            // if(this.deg || !this.unitPlayTemp)
            // { // if temp is in f, change to c
            //  waterTemp = waterTemp.map((x)=> this.ftoC(x));
            // }
            let tempCmpDat = [];
            for (let i = 0; i < waterTemp.length; i++) {
                // if (usecalVal)
                // {
                //   tempCmpDat[i] = sensorData[i] + ((sensorData[i]/calVal) * k * (waterTemp[i] - temperature));
                // }
                // else
                // {
                tempCmpDat[i] = sensorData[i] + k * (temperature - waterTemp[i]);
                // }
            }
            // now do lowpass filter
            outDat = this.lowpassFilter(tempCmpDat, alpha);
            return outDat;
        },
        tempCompTurbidity(sensorData, alpha, temperature, k) {
            // calVal is the sensor high calibration value
            // do temperature comp
            k = parseFloat(k);
            temperature = parseFloat(temperature);
            // let waterTemp = this.datByCol[this.wtI];
            let waterTemp = this.newDataArray.find((x) => x.sensorName == "waterTemp").history;

            let outDat = [];
            // if(this.deg || !this.unitPlayTemp)
            // { // if temp is in f, change to c
            //  waterTemp = waterTemp.map((x)=> this.ftoC(x));
            // }
            let tempCmpDat = [];
            for (let i = 0; i < waterTemp.length; i++) {
                // if (usecalVal)
                // {
                //   tempCmpDat[i] = sensorData[i] + ((sensorData[i]/calVal) * k * (waterTemp[i] - temperature));
                // }
                // else
                // {
                tempCmpDat[i] = sensorData[i] + (k / 100) * sensorData[i] * (waterTemp[i] - temperature);
                // }
            }
            // now do lowpass filter
            outDat = this.lowpassFilter(tempCmpDat, alpha);
            return outDat;
        },
        NPQComp(fullDat) {
            // calculate average of prev nights CA and PC
            let nightDatCA = []; // temp storage of night time data
            let nightDatPC = [];
            let dayDatCA = [];
            let dayDatPC = [];
            let pcAvgNightNPQ = []; // new array to hold prev nights data
            let caAvgNightNPQ = [];
            let tCANight = 0;
            let tPCNight = 0;
            let tCADay = 0;
            let tPCDay = 0;
            let tCA = 0;
            let tPC = 0;
            let c = 0;
            let c2 = 0;
            let isnight = false;
            let isday = false;
            let nightFull = false;
            let dayFull = false;
            let minDate = 0;
            let newDat = [];

            // get total time (in hours) of data in fullDat
            let totalTime =
                Math.abs(new Date(fullDat[0][0] * 1000) - new Date(fullDat[fullDat.length - 1][0] * 1000)) /
                36e5;
            // find first instance of day and night hours
            let dayStart = fullDat.findIndex(
                (x) => new Date(x[0] * 1000).getHours() >= 10 && new Date(x[0] * 1000).getHours() <= 12
            );
            let dayEnd = fullDat.findIndex(
                (x) => new Date(x[0] * 1000).getHours() >= 14 && new Date(x[0] * 1000).getHours() <= 16
            );
            let nightStart = fullDat.findIndex(
                (x) => new Date(x[0] * 1000).getHours() >= 22 && new Date(x[0] * 1000).getHours() <= 24
            );
            let nightEnd = fullDat.findIndex(
                (x) => new Date(x[0] * 1000).getHours() >= 2 && new Date(x[0] * 1000).getHours() <= 4
            );
            if (dayStart <= 0 || nightStart <= 0 || dayEnd <= 0 || nightEnd <= 0 || totalTime <= 48) {
                for (let i = 0; i < fullDat.length; i++) {
                    caAvgNightNPQ[i] = fullDat[i][this.caI];
                    pcAvgNightNPQ[i] = fullDat[i][this.pcI];
                }
                newDat = fullDat;
            } else {
                if (nightEnd < dayEnd) {
                    minDate = new Date(fullDat[Math.max(dayEnd, nightEnd)][0] * 1000).getDate() + 1;
                } else {
                    minDate = new Date(fullDat[Math.max(dayEnd, nightEnd)][0] * 1000).getDate();
                }
                if (nightEnd < nightStart) {
                    let b = fullDat.slice(nightStart);
                    let newNight = b.findIndex(
                        (x) => new Date(x[0] * 1000).getHours() >= 2 && new Date(x[0] * 1000).getHours() <= 4
                    );
                    nightEnd = newNight + nightStart;
                }
                if (dayEnd < dayStart) {
                    let b = fullDat.slice(dayStart);
                    let newDay = b.findIndex(
                        (x) => new Date(x[0] * 1000).getHours() >= 14 && new Date(x[0] * 1000).getHours() <= 16
                    );
                    dayEnd = newDay + dayStart;
                }
                // get data by time
                let day1 = fullDat.slice(dayStart, dayEnd);
                let avgCaDay1 = day1.map((x) => x[this.caI]).reduce((a, b) => a + b, 0) / day1.length;
                let avgPcDay1 = day1.map((x) => x[this.pcI]).reduce((a, b) => a + b, 0) / day1.length;

                let night1 = fullDat.slice(nightStart, nightEnd);
                let avgCaNight1 = night1.map((x) => x[this.caI]).reduce((a, b) => a + b, 0) / night1.length;
                let avgPcNight1 = night1.map((x) => x[this.pcI]).reduce((a, b) => a + b, 0) / night1.length;

                tCA = avgCaNight1 / avgCaDay1;
                tPC = avgPcNight1 / avgPcDay1;

                // reduce data
                newDat = fullDat.slice(
                    fullDat.findIndex((x) => new Date(x[0] * 1000).getDate() >= minDate)
                );

                // now perform NPQ
                for (let i = 0; i < newDat.length; i++) {
                    let tmp = new Date(newDat[i][this.utI] * 1000).getHours();
                    // console.log(tmp);
                    if (tmp >= 22 || tmp < 3) {
                        nightDatCA[c] = newDat[i][this.caI];
                        nightDatPC[c] = newDat[i][this.pcI];
                        isnight = true; // switch store dat
                        c += 1;
                    } else if (tmp >= 3 && tmp < 10) {
                        isnight = false;
                    } else if (tmp >= 10 && tmp < 15) {
                        dayDatCA[c2] = newDat[i][this.caI];
                        dayDatPC[c2] = newDat[i][this.pcI];
                        isday = true; // switch store dat
                        c2 += 1;
                    } else if (tmp >= 15 && tmp < 22) {
                        isday = false;
                    } else {
                        // console.log("Error on day/night switch, time not accounted for");
                        // console.log(tmp);
                    }
                    if (!isnight && c > 0) {
                        // take avg
                        tCANight = nightDatCA.reduce((a, b) => a + b, 0) / nightDatCA.length;
                        tPCNight = nightDatPC.reduce((a, b) => a + b, 0) / nightDatPC.length;
                        nightDatCA = [];
                        nightDatPC = [];
                        c = 0;
                        nightFull = true;
                    }
                    if (!isday && c2 > 0) {
                        tCADay = dayDatCA.reduce((a, b) => a + b, 0) / dayDatCA.length;
                        tPCDay = dayDatPC.reduce((a, b) => a + b, 0) / dayDatPC.length;
                        dayDatCA = [];
                        dayDatPC = [];
                        c2 = 0;
                        dayFull = true;
                    }
                    if (dayFull && nightFull) {
                        tCA = tCANight / tCADay;
                        tPC = tPCNight / tPCDay;
                        dayFull = false;
                        nightFull = false;
                    }

                    caAvgNightNPQ[i] = tCA;
                    pcAvgNightNPQ[i] = tPC;
                }
            }

            this.pcAvgNightNPQ = pcAvgNightNPQ;
            this.caAvgNightNPQ = caAvgNightNPQ;
            return newDat;
        },
        lightComp(param, lightDat, k, maxLight, nightAvg) {
            k = parseFloat(k);
            maxLight = parseFloat(maxLight);
            let outDat = [];
            for (let i = 0; i < param.length; i++) {
                if (i == 0) {
                    if (nightAvg.length == param.length) {
                        outDat[i] = param[i] + k * nightAvg[i] * Math.min(lightDat[i], maxLight);
                    } else {
                        outDat[i] = param[i] + k * Math.min(lightDat[i], maxLight);
                    }
                } else {
                    if (nightAvg.length == param.length) {
                        outDat[i] = param[i] + k * nightAvg[i] * Math.min(lightDat[i - 1], maxLight);
                    } else {
                        outDat[i] = param[i] + k * Math.min(lightDat[i - 1], maxLight);
                    }
                }
            }
            return outDat;
        },
        lowpassFilter(param, alpha) {
            alpha = parseFloat(alpha);
            let outDat = [];
            // if (alpha == 0)
            // {
            //   outDat = param;
            // }
            // else
            // {
            for (let i = 0; i < param.length; i++) {
                if (i == 0) {
                    outDat[i] = param[i];
                } else {
                    outDat[i] = (1 - alpha) * param[i] + alpha * outDat[i - 1];
                }
            }
            // }
            return outDat;
        },
        assignSensorIndices(hisReport) {
            this.utI = hisReport.sensors.findIndex((x) => x.sensorName == "utcTime");
            this.wtI = hisReport.sensors.findIndex((x) => x.sensorName == "waterTemp");
            this.atI = hisReport.sensors.findIndex((x) => x.sensorName == "airTemp");
            this.liI = hisReport.sensors.findIndex((x) => x.sensorName == "light");
            this.pcI = hisReport.sensors.findIndex((x) => x.sensorName == "phycocyanin");
            this.caI = hisReport.sensors.findIndex((x) => x.sensorName == "chlorA");
            this.tuI = hisReport.sensors.findIndex((x) => x.sensorName == "turbidity");
            this.bsI = hisReport.sensors.findIndex((x) => x.sensorName == "battSOC");
            this.ssI = hisReport.sensors.findIndex((x) => x.sensorName == "sigStrength");
            this.pvI = hisReport.sensors.findIndex((x) => x.sensorName == "panelVolts");
            this.wlI = hisReport.sensors.findIndex((x) => x.sensorName == "waterLight");
            this.btI = hisReport.sensors.findIndex((x) => x.sensorName == "buoyTemp");
            this.laI = hisReport.sensors.findIndex((x) => x.sensorName == "latitude");
            this.loI = hisReport.sensors.findIndex((x) => x.sensorName == "longitude");
            this.bvI = hisReport.sensors.findIndex((x) => x.sensorName == "battVolts");
            this.sqI = hisReport.sensors.findIndex((x) => x.sensorName == "sigQuality");
            this.cvI = hisReport.sensors.findIndex((x) => x.sensorName == "codeVersion");
            this.ldI = hisReport.sensors.findIndex((x) => x.sensorName == "leakDetect");
            this.wsI = hisReport.sensors.findIndex((x) => x.sensorName == "windSpeed");
            this.piI = hisReport.sensors.findIndex((x) => x.sensorName == "precipitationIntensity");
            return;
        },
        assignChartTitles(sensor) {
            let label = "";
            let units = "";
            switch (true) {
                case sensor === "chlorA":
                    label = "Chlorophyll-a";
                    units = "RFU";
                    break;
                case sensor === "phycocyanin":
                    label = "Phycocyanin";
                    units = "RFU";
                    break;
                case sensor === "airTemp":
                    label = "Air Temperature";
                    units = "C";
                    break;
                case sensor === "waterTemp":
                    label = "Water Temperature";
                    units = "C";
                    break;
                case sensor === "light":
                    label = "Ambient Solar Light";
                    units = "umoles/m²/sec";
                    break;
                case sensor === "turbidity":
                    label = "Turbidity";
                    units = "NTU";
                    break;
                case sensor === "battSOC":
                    label = "Battery Strength";
                    units = "%";
                    break;
                case sensor === "windSpeed":
                    label = "Wind Speed";
                    units = "m/s";
                    break;
                case sensor === "panelVolts":
                    label = "Solar Panel";
                    units = "V";
                    break;
                case sensor === "leakDetect":
                    label = "Leak Detector";
                    units = "Counts";
                    break;
                case sensor === "pcTrend":
                    label = "Phycocyanin Trend";
                    units = "RFU";
                    break;
                case sensor === "wtTrend":
                    label = "Water Temp. Trend";
                    units = "C";
                    break;
                case sensor === "caTrend":
                    label = "Chlorophyll Trend";
                    units = "RFU";
                    break;
                case sensor === "pcFieldCal":
                    label = "Field Calibrated Phycocyanin";
                    units = "RFU";
                    break;
                case sensor === "caFieldCal":
                    label = "Field Calibrated Chlorophyll";
                    units = "RFU";
                    break;
                case sensor === "windSpeed":
                    label = "Wind Speed";
                    units = "m/s";
                    break;
                case sensor === "precipitationIntensity":
                    label = "Precipitation Intensity";
                    units = "mm/h";
                    break;
                default:
                    break;
            }
            return [label, units];
        },
        incrementKeys() {
            this.keyPCStatChart += 1;
            this.keyCAStatChart += 1;
            this.keyTUStatChart += 1;
            this.keyATStatChart += 1;
            this.keyWTStatChart += 1;
            this.keyLIStatChart += 1;
            this.keyCaPc += 1;
            this.keyWaterTemp += 1;
            this.keyBatSig += 1;
            this.keyTurb += 1;
            this.keyLight += 1;
            this.keyWaterTempStatChart += 1;
            this.keyAirTempStatChart += 1;
            this.keyTurbTrend += 1;
            this.keyWaterTempTrend += 1;
            this.keyPlayground += 1;
        },
        resetTrendline() {
            const data = {
                pcProperties: {
                    kl: 0.01, // vertical shift
                    alpha: 0.99, // 0 - 1 lowpass filtering
                    shift: 1, // shift to offset lowpass
                    maxLight: 200, // shift for solar light in lightcomp
                    alphaTemp: 0.99, // 0 - 1 lowpass filtering
                    kTemp: 0.02, // vertical shift
                    stTemp: 25, // temperature at calibration
                    calVal: 710, // value at high calibration
                    useCal: false, // control whether or not calVal is used
                },
                caProperties: {
                    kl: 0.05,
                    alpha: 0.95,
                    shift: 2,
                    maxLight: 400,
                },
                tuProperties: {
                    kl: 0.01,
                    alpha: 0.95,
                    shift: 2,
                    alphaTemp: 0.99,
                    kTemp: 0.02,
                    stTemp: 25,
                    calVal: 50,
                    useCal: false,
                },
                wtProperties: {
                    alpha: 0.95,
                    shift: 2,
                },
                phProperties: {
                    alpha: 0.95,
                    shift: 2,
                },
                doProperties: {
                    alpha: 0.95,
                    shift: 2,
                },
                psProperties: {
                    alpha: 0.95,
                    shift: 2,
                },
            };
            return data;
        },
        resetAlerts() {
            return [
                {
                    devicePropName: "phycocyanin",
                    active: false,
                    low: 0,
                    high: 500,
                },
                {
                    devicePropName: "waterTemp",
                    active: false,
                    low: 0,
                    high: 40,
                },
                {
                    devicePropName: "chlorA",
                    active: false,
                    low: 0,
                    high: 2000,
                },
                {
                    devicePropName: "light",
                    active: false,
                    low: 0,
                    high: 2000,
                },
                {
                    devicePropName: "turbidity",
                    active: false,
                    low: 0,
                    high: 200,
                },
                {
                    devicePropName: "airTemp",
                    active: false,
                    low: 0,
                    high: 40,
                },
                {
                    devicePropName: "do",
                    active: false,
                    low: 0,
                    high: 20,
                },
                {
                    devicePropName: "ph",
                    active: false,
                    low: 0,
                    high: 14
                },
            ];
        },
        blankStatChart() {
            let tmpChart = {};
            for (let i = 0; i < this.sensorGauges.length; i++) {
                {
                    tmpChart[i] = {
                        alertValue: 50,
                        datasets: [
                            {
                                backgroundColor: ["#cfcccc", "#cfcccc"],
                                data: [100, 0],
                                label: "",
                            },
                        ],
                        displayName: "",
                        labels: [],
                        maxValue: 100,
                        minValue: 0,
                        name: "",
                        units: "",
                        value: 50,
                    };
                }
            }
            this.statCharts = tmpChart;
        },
        updateStatChart(){
          var degF = this.deg;
          const airTempFromServer = useSlotStore().deviceSnapshot.deviceProps[this.atI].result;
          var smooth = this.smoothPlot;
          var statCharts = this.sensorGauges.map((x) => {
            const devicePropDetails = this.newDataArray.find((dp) => dp.sensorName === x.name);
            const len = devicePropDetails.history.length - 1;
            // let targetValue = fullDat[len][i];
            var targetValue = devicePropDetails.history[len];
            const alerts = this.device.deviceAlerts.find((y) => y.devicePropName == x.name);
            var high = alerts.high;
            var low = alerts.low;
            var maxValue = x.maxValue;
            if (devicePropDetails.sensorName === "airTemp") {
              targetValue = airTempFromServer;
              if (!this.deg) {
                high = this.ctoF(high);
                low = this.ctoF(low);
                targetValue = this.ctoF(targetValue);
                maxValue = this.ctoF(maxValue);
                x.units = "\u00B0 F";
              } else {
                x.units = "\u00B0 C";
              }
            }
            if (devicePropDetails.sensorName === "waterTemp") {
              if (!degF) {
                high = this.ctoF(high);
                low = this.ctoF(low);
                targetValue = this.ctoF(targetValue);
                maxValue = this.ctoF(maxValue);
                x.units = "\u00B0 F";
              } else {
                x.units = "\u00B0 C";
              }
            }

            if (devicePropDetails.sensorName === "phycocyanin") {
              if (smooth) {
                targetValue = this.newDataArray.find((x) => x.sensorName == "pcTrend").history[len]; // TODO: show trend
                x.units = "RFU (Trend)";
              }
              else {
                x.units = "RFU";
              }

            }

            if (devicePropDetails.sensorName === "chlorA") {
              if (smooth) {
                targetValue = this.newDataArray.find((x) => x.sensorName == "caTrend").history[len]; // TODO: show trend
                x.units = "RFU (Trend)";
              }
              else {
                x.units = "RFU";
              }
            }

            return Object.assign(
                {},
                { displayName: x.displayName },
                { sensorName: x.name },
                { units: x.units },
                { value: targetValue },
                { labels: [x.name, "total"] },
                {
                  datasets: [
                    {
                      label: x.name,
                      backgroundColor: [this.getColor(targetValue, high, low), "#eaeaea"],
                      data: [
                        targetValue > maxValue ? maxValue : targetValue,
                        maxValue > targetValue ? maxValue - targetValue : 0,
                      ],
                    },
                  ],
                }
            );
          });
          this.statCharts = statCharts;
        },
        resetCharts() {
            //this.deviceLat = 360;
            //this.deviceLong = 360;
            //this.inLongLat = false;
            this.deviceInWater = false;
            this.playgroundChart = null;
            this.turbTrendChart = null;
            this.waterTrendChart = null;
            this.algaeTimeReportsChart = null;
            this.waterTempLineChart = null;
            this.turbidityLineChart = null;
            this.batteryAndSingalReportsChart = null;
            this.battPVChart = null;
            this.signalAndPanelTimeReportsChart = null;
            this.ssLiChart = null;
            this.eventTable = [];
        },
        onSwitchChange(value) {
            if (this.rfuSwitchUgL) {
                this.isShowSwitchAlert = true;
            } else {
                this.updateCAANDPCData(false)
            }
        },
        doneSwitchChange(sure) {
            if (sure) {
                this.rfuSwitchUgL = true
                console.log('success')
                this.updateCAANDPCData(true)
            } else {
                this.rfuSwitchUgL = false
                console.log('fail')
            }
        },
        updateCAANDPCData(isUGL) {
            this.algaeTimeReportsChart.datasets.forEach((item) => {
                if (item.label.startsWith('PC')) {
                    if (isUGL) {
                        console.log('PC Detail')
                        item.data = item.data.map((data) => data / this.defaultUnitValue.uglToRfuProperties.pcValue)
                    } else {
                        item.data = item.data.map((data) => data * this.defaultUnitValue.uglToRfuProperties.pcValue)
                    }
                } else if (item.label.startsWith('CA')) {
                    if (isUGL) {
                        console.log('CA Detail')
                        item.data = item.data.map((data) => data / this.defaultUnitValue.uglToRfuProperties.caValue)
                    } else {
                        item.data = item.data.map((data) => data * this.defaultUnitValue.uglToRfuProperties.caValue)
                    }
                }
            })
            console.log(this.algaeTimeReportsChart)
            this.caPcChart(false)
            this.$refs.lineChart.updateChart()
        },
        removeAriaHidden() {
            const modalElement = document.getElementById('switch_modal');
            if (modalElement) {
                modalElement.removeAttribute('aria-hidden');
            }
        },
        handleTimeSeriesData(data) {
            // 更新数据存储
            this.timeSeriesData.set(data.sensorName, data.data);

            // 如果是风速或降水数据，更新自定义图表数据
            if (data.sensorName === 'windSpeed' || data.sensorName === 'precipitationIntensity') {
                // 在现有的 customChart 中找到对应的 dataset
                // const datasetIndex = this.customChart.datasets ? this.customChart.datasets.findIndex(dataset => dataset.label === data.sensorName) : -1;

                // if (datasetIndex !== -1) {
                //     // 更新现有数据集
                //     this.customChart.datasets[datasetIndex].data = data.data.values;
                //     this.customChart.labels = data.data.labels;
                // } else if (!!this.customChart.datasets) {
                //     // 如果数据集不存在，添加新的数据集
                //     this.customChart.datasets.push({
                //         label: data.sensorName,
                //         data: data.data.values,
                //         fill: false,
                //         borderColor: this.getLineChartColor(data.sensorName),
                //         backgroundColor: this.getLineChartColor(data.sensorName),
                //         borderWidth: 1,
                //         yAxisID: 'y_axis_1'
                //     });
                //     this.customChart.labels = data.data.labels;
                // }

                // // 刷新图表
                // this.keyCustom += 1;
                // this.$refs.lineChart.updateChart();

            }
        },
        gotoEventsPage() {
            this.$router.push({ name: `eventsPage`, params: { 'id': this.slotId } })
        },
        async getExclusionData() {
          try {
            this.exclusionData.dataProperty = await queryExclusionDataList(this.slotId)
            this.exclusionData.rows = this.exclusionData.dataProperty.length
          }catch (e) {
            console.log('post exclusions/slots/ fail')
          }
        },
        async addExclusionPeriod() {
          if (this.exclusionData.showTips) {
            return
          }
          if (!this.exclusionData.startDateTime) {
            this.exclusionData.showTips = true
            this.exclusionData.tips = 'start date cannot be null'
            return
          }
          if (!this.exclusionData.endDateTime) {
            this.exclusionData.showTips = true
            this.exclusionData.tips = 'end date cannot be null'
            return
          }
          this.exclusionData.showTips = false
          let created = await submitExclusionData(this.slotId,dayjs(this.exclusionData.startDateTime),dayjs(this.exclusionData.endDateTime))
          this.exclusionData.dataProperty.push(created)
          this.exclusionData.startDateTime = null
          this.exclusionData.endDateTime = null
          if (this.exclusionData.on) {
            this.getReports(this.slotId)
          }
        },
        exclusionOnClose(overlay){
          if (this.exclusionData.startDateTime && this.exclusionData.endDateTime) {
            let start_timeStamp = this.exclusionData.startDateTime.valueOf()
            let end_timeStamp = this.exclusionData.endDateTime.valueOf()
            this.exclusionData.tips = 'end time must be greater than start time'
            this.exclusionData.showTips = end_timeStamp <= start_timeStamp
          }else {
            this.exclusionData.showTips = false
          }
        },
        async deleteExclusionData(row){
          await deleteExclusionData(this.slotId,row.item.id)
          if (this.exclusionData.on) {
            this.getReports(this.slotId)
          }else {
            this.getExclusionData()
          }
        },
        async changeExclusionSwitch(){
          await updateExclusionOff(this.exclusionData.on)
          this.getReports(this.slotId)
        },
        setSpikeRange(val){
          this.spikeRemovalData.editDataValue = val
        },
        async doneSpike(){
          if (this.spikeRemovalData.value === this.spikeRemovalData.editDataValue) {
            this.qualityModel = false
            return
          }
          this.spikeRemovalData.value = this.spikeRemovalData.editDataValue
          await updateSpikeRemovalThreshold(this.spikeRemovalData.value)
          this.qualityModel = false
          const slotStore = useSlotStore();
          const deviceHistory = slotStore.computeCompensatedHistory();
          if (deviceHistory && deviceHistory.sensors && deviceHistory.sensors[0].history.length > 0) {
            await this.displayDeviceHistoryImpl(deviceHistory, slotStore);
          }
        },
        cancelSpike(){
          this.spikeRemovalData.editDataValue = this.spikeRemovalData.value
          this.qualityModel = false
        },
        async applyDataProcessing(hisReport, exportOptions) {
            let processedReport = [...hisReport];
            
            if (exportOptions.spikeRemoval || exportOptions.dataExclusion) {
                // Create temporary newDataArray structure to apply existing processing logic
                const tempDataArray = this.createTempDataArray(processedReport);
                
                // Apply Data Exclusion
                if (exportOptions.dataExclusion && this.exclusionData.on && this.exclusionData.dataProperty.length > 0) {
                    filterExclusionData(tempDataArray, this.exclusionData.dataProperty);
                }
                
                // Apply Spike Removal
                if (exportOptions.spikeRemoval) {
                    this.applySpikeRemovalToTempData(tempDataArray);
                }
                
                // Convert processed data back to hisReport format
                processedReport = this.convertTempDataToHisReport(tempDataArray, processedReport);
            }
            
            return processedReport;
        },
        createTempDataArray(hisReport) {
            // Group data by sensor name, maintaining time order
            const sensorMap = new Map();
            
            // First sort by timestamp
            const sortedReport = [...hisReport].sort((a, b) => 
                new Date(a.handshakeTime).getTime() - new Date(b.handshakeTime).getTime()
            );
            
            sortedReport.forEach(entry => {
                if (!sensorMap.has(entry.name)) {
                    sensorMap.set(entry.name, []);
                }
                sensorMap.get(entry.name).push({
                    val: entry.val,
                    timestamp: entry.handshakeTime
                });
            });
            
            // Create newDataArray structure similar to displayDeviceHistoryImpl
            const tempDataArray = [];
            sensorMap.forEach((entries, sensorName) => {
                tempDataArray.push({
                    sensorName: sensorName,
                    history: entries.map(e => e.val)
                });
            });
            
            return tempDataArray;
        },
        applySpikeRemovalToTempData(tempDataArray) {
            const spikeThreshold = this.spikeRemovalData.value || 3;
            const sensorsToProcess = ['phycocyanin', 'chlorA', 'turbidity'];
            
            sensorsToProcess.forEach(sensorName => {
                const sensor = tempDataArray.find(x => x.sensorName === sensorName);
                if (sensor && sensor.history.length > 0) {
                    sensor.history = this.spikeRemovalImpl(sensor.history, spikeThreshold);
                }
            });
        },
        spikeRemovalImpl(points, spikeThreshold) {
            if (points.length < 3) {
                return points;
            }
            
            // Calculate mean and standard deviation
            const mean = points.reduce((sum, value) => sum + value, 0) / points.length;
            const variance = points.reduce((sum, value) => sum + Math.pow(value - mean, 2), 0) / points.length;
            const standardDeviation = Math.sqrt(variance);
            
            let val = points[0];
            for (let i = 1; i < points.length - 1; i++) {
                const currentValue = points[i];
                const diff = Math.abs(currentValue - mean) / standardDeviation;
                if (diff > spikeThreshold) {
                    points[i] = val;
                } else {
                    val = points[i];
                }
            }
            
            return points;
        },
        convertTempDataToHisReport(tempDataArray, originalReport) {
            // Map processed data back to original report format
            const processedReport = [...originalReport];
            
            // Sort original report by timestamp
            const sortedOriginal = processedReport.sort((a, b) => 
                new Date(a.handshakeTime).getTime() - new Date(b.handshakeTime).getTime()
            );
            
            // Create index mapping for each sensor
            const sensorIndexMap = new Map();
            tempDataArray.forEach(sensor => {
                sensorIndexMap.set(sensor.sensorName, 0);
            });
            
            // Update data in chronological order
            sortedOriginal.forEach(entry => {
                const sensor = tempDataArray.find(s => s.sensorName === entry.name);
                if (sensor) {
                    const currentIndex = sensorIndexMap.get(entry.name);
                    if (currentIndex < sensor.history.length) {
                        entry.val = sensor.history[currentIndex];
                        sensorIndexMap.set(entry.name, currentIndex + 1);
                    }
                }
            });
            
            return processedReport;
        },
        openhelp() {
            window.open("https://drive.google.com/drive/folders/12bUyB0iAKUc-D4thPktYoWt-pZF-IZik?usp=sharing", '_blank','noreferrer');
        },
        
        async takeAnotherReading() {
            // Reset states for another reading without power cycling
            this.dataReadingSuccess = false;
            this.dataReadingError = null;
            this.lastDataTime = null;
            
            // Take reading directly without going back to preparation
            await this.takeReading();
        },
        
        // Debug and testing methods
        addDebugLog(type, details, response = null, error = null, success = true) {
            const timestamp = new Date().toLocaleTimeString();
            this.debugLogs.unshift({
                type,
                details,
                response,
                error,
                success,
                timestamp
            });
            
            // Keep only last 20 logs
            if (this.debugLogs.length > 20) {
                this.debugLogs = this.debugLogs.slice(0, 20);
            }
        },
        
        clearDebugLogs() {
            this.debugLogs = [];
        },
        
        toggleMockMode() {
            this.mockMode = !this.mockMode;
            this.addDebugLog('System', `Mock mode ${this.mockMode ? 'enabled' : 'disabled'}`);
        },
        
        // Mock API responses for testing
        getMockResponse(apiType, param = null) {
            // Use test suite's mock response if available
            if (this.testSuiteInstance && this.testSuiteInstance.currentScenario) {
                return this.testSuiteInstance.getMockResponse(apiType, this.currentDataReadingAttempt);
            }
            
            const mockResponses = {
                calAwakeMins: {
                    ok: true,
                    response: { return_value: 0 }
                },
                pingDevice: {
                    ready: Math.random() > 0.3, // 70% chance of being ready
                    lastSeen: Date.now() / 1000,
                    batteryLevel: Math.floor(Math.random() * 100),
                    signalStrength: Math.floor(Math.random() * 100)
                },
                publishTrackerData: {
                    ok: true,
                    response: { 
                        return_value: 1,
                        message: 'Data collection started',
                        dataId: 'mock_' + Date.now()
                    }
                },
                deviceHistory: {
                    device_last_publish: Date.now() / 1000 + Math.random() * 30
                }
            };
            
            return mockResponses[apiType] || { ok: false, error: 'Unknown API type' };
        },
        
        // Test runner methods
        async runTestScenario() {
            this.isRunningTest = true;
            try {
                // Initialize test suite if not already done
                if (!this.testSuiteInstance) {
                    this.testSuiteInstance = dataReadingTestSuite;
                }
                
                // Show selection dialog for test scenario
                const scenarioNames = Object.keys(this.testSuiteInstance.testScenarios);
                const selectedScenario = await this.selectTestScenario(scenarioNames);
                
                if (selectedScenario) {
                    this.addDebugLog('Test Runner', `Running automated test: ${selectedScenario}`);
                    const result = await this.testSuiteInstance.runAutomatedTest(selectedScenario, this);
                    this.addDebugLog('Test Complete', `Test finished: ${result.result.success ? 'PASSED' : 'FAILED'}`, result);
                }
            } catch (error) {
                this.addDebugLog('Test Error', `Test execution failed`, null, error.message, false);
            } finally {
                this.isRunningTest = false;
            }
        },
        
        async selectTestScenario(scenarios) {
            return new Promise((resolve) => {
                // 创建一个简单的选择对话框
                const selection = prompt(`Select test scenario:\n${scenarios.map((s, i) => `${i + 1}. ${s}`).join('\n')}\nEnter number:`);
                if (selection && !isNaN(selection)) {
                    const index = parseInt(selection) - 1;
                    if (index >= 0 && index < scenarios.length) {
                        resolve(scenarios[index]);
                        return;
                    }
                }
                resolve(null);
            });
        },
        
        exportTestReport() {
            if (!this.testSuiteInstance) {
                this.testSuiteInstance = dataReadingTestSuite;
            }
            this.testSuiteInstance.exportTestReport();
            this.addDebugLog('Export', 'Test report exported successfully');
        },
        
        async recordLastDataTime() {
            // Find current slot data to get the last data time
            const slotSummary = this.outDat.find(item => item.id === this.device._id);
            if (slotSummary && slotSummary.device_last_publish) {
                this.lastDataTime = slotSummary.device_last_publish;
            } else {
                this.lastDataTime = Date.now() / 1000; // Current timestamp as fallback
            }
        }
    },
};
</script>